import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Box, ButtonGroup, Chip, CircularProgress, Container, Divider, Grid, IconButton, ImageList, ImageListItem, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Moveable from 'react-moveable';
import parse from 'html-react-parser';
import { TextField, Slider, Select, FormControl, InputLabel } from '@mui/material';
import Colors from '../../assests/images/colors.png'
import { BlockPicker, CirclePicker, TwitterPicker, SliderPicker } from 'react-color';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import CancelIcon from '@mui/icons-material/Cancel';
import { useForm, useFormState } from 'react-hook-form';

import { Color, Gallery, Graphic, Images, TextIcon, UploadIcon, UploadIconSecond } from '../../assests';
import DeleteIcon from '@mui/icons-material/Delete';
import html2canvas from 'html2canvas';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';
import { BsTransparency } from "react-icons/bs";
import { PDFExport } from '@progress/kendo-react-pdf';
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FolderIcon from '@mui/icons-material/Folder';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import { SecondaryButton } from '../Buttons';
import { useLocation, useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import 'animate.css';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { isIPad13, isMobile, isTablet, isIOS, isIOS13 } from 'react-device-detect';
import ReactCurvedText from 'react-curved-text';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { PiWaveSineBold } from "react-icons/pi";
import { FaRegCircle } from "react-icons/fa";
import { TbOvalVertical } from "react-icons/tb";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { MuiColorInput } from 'mui-color-input';
import LayersIcon from '@mui/icons-material/Layers';
import { MdFlipToFront, MdFlipToBack } from "react-icons/md";
import InterestsIcon from '@mui/icons-material/Interests';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import EastIcon from '@mui/icons-material/East';
import { useCallbackPrompt } from '../hooks/useCallBackPrompt';
import ConfirmationDialog from '../DialogBoxComponent/index'
import OrderServices from '../../services/OrderServices';
import { ImTextWidth } from "react-icons/im";
import { IoColorPalette } from "react-icons/io5";
import { FaImages } from "react-icons/fa";
import ConfirmationDialog2 from '../DialogBoxComponent2';
import SaveIcon from '@mui/icons-material/Save';
import CategoryIcon from '@mui/icons-material/Category';
import './style.css'
import Swal from 'sweetalert2';
import axios from 'axios';
import { Helmet } from 'react-helmet';





function TshirtDesignCanvasFinal(imageUrl) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    console.log(imageUrl, 'Design');
    const { design } = useLocation()
    const [frontPictures, setFrontPictures] = useState([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', zIndexes: 1 }])
    const [revertedArrayFront, setRevertedArrayFront] = useState([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', zIndexes: 3, reverted: false }])
    const [backPictures, setBackPictures] = useState([])
    const [revertedArrayBack, setRevertedArrayBack] = useState([])
    const [galleryPictures, setGalleryPictures] = useState([{ imageUrl: imageUrl?.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10 }])
    const [selectedGalleryPic, setSelectedGalleryPic] = useState()
    const parentRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selectedTshirt, setSelectedTshirt] = useState('white')
    const [selectedSize, setSelectedSize] = useState('S')
    const [rotate, setRotate] = useState(false);
    const [quantity, setQuantity] = useState(1)
    const [fontWeight, setFontWeight] = useState(400)
    const [textArray, setTextArray] = useState([]);
    const [textBackArray, setTextBackArray] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState('')
    const [selectedIndexBack, setSelectedIndexBack] = useState('')
    const [imageSeleted, setImageSeleted] = useState(false)
    const [imageSeletedBack, setImageSeletedBack] = useState(false)
    const [imageSelectedIndex, setImageSelectedIndex] = useState()
    const [imageSelectedIndexBack, setImageSelectedIndexBack] = useState()
    const [zIndexes, setZIndexes] = useState(textArray.map(() => 1)); // Initialize zIndexes
    const [highestZIndex, setHighestZIndex] = useState(4);
    const [fonts, setFonts] = useState([]);
    const [selectedFont, setSelectedFont] = useState('Bebas Neue');
    const [selectedTab, setSelectedTab] = useState(0)
    const containerRef = useRef(null);
    const [isUnderline, setIsUnderline] = useState(false)
    const [displayedFonts, setDisplayedFonts] = useState([]);
    const [rotateDirection, setRotateDirection] = useState(false)
    const [isItalic, setIsItalic] = useState(false)
    const [isBold, setIsBold] = useState(false)
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isLessThan1000px, setIsLessThan1000px] = useState(window.innerWidth < 1000);
    const [isLessThan400, setIsLessThan400] = useState(window.innerWidth <= 400)
    const [modalInnerState, setModalInnerState] = useState('')
    const [textState, setTextState] = useState('add')
    const [imageBorderRadius, setImageBorderRadius] = useState(10)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('Bebas Neue');
    const [editModalState, setEditModalState] = useState()
    const [drag, setDrag] = useState(false)
    const [confirmationDialog, setConfirmationDialog] = useState(false)
    const [confirmationDialog2, setConfirmationDialog2] = useState(false)
    const [confirmationDialog3, setConfirmationDialog3] = useState(false)
    const [frontBackupImage, setFrontBackupImage] = useState()
    const [backBackupImage, setBackBackupImage] = useState()
    const [frontRemovedImage, setFrontRemovedImage] = useState(false)
    const [backRemovedImage, setBackRemovedImage] = useState(false)
    const [removerLoader, setRemoverLoader] = useState(false)
    const [tshirtColors, setTshirtColors] = useState([])
    const [library, setLibrary] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [pageLimit, setPageLimit] = useState(6)
    const [savedDesign, setSavedDesign] = useState(false)
    const [textLength, setTextLength] = useState(false)
    const [boxState, setBoxState] = useState(false)
    const [selectedShape, setSelectedShape] = useState({ shape: 'above', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false })
    const getLibrary = async (limit) => {

        try {
            let params = {
                page: 1,
                limit: limit ? limit : pageLimit
            };
            const { data } = await OrderServices.getLibrary(params);
            console.log(data);
            setTotalCount(data?.count)
            setLibrary(data?.library);
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadLoader, setUploadLoader] = useState(false)
    const [uploadedImg, setUploadedImg] = useState(null)

    const handleFileChange = async (e) => {
        const file = e.target.files[0];

        // Check if file exists and is an image
        if (!file || !file.type.startsWith("image/")) {
            Swal.fire({
                title: 'An error occurred!',
                text: 'Please upload a valid image file.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            e.target.value = ""; // Reset file input
            return;
        }

        setUploadLoader(true);

        try {
            const formData = new FormData();
            formData.append("document", file);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/system/upload`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            console.log(response?.data?.data);

            setUploadedImg(`${process.env.REACT_APP_BASE_URL}${response?.data?.data?.path}`);
        } catch (error) {
            console.error("Upload failed:", error);
            alert("File upload failed. Please try again.");
        } finally {
            setUploadLoader(false);
        }
    };

    const handleAddImage = async (e) => {
        try {
            const baseImage = {
                imageUrl: uploadedImg,
                width: 100,
                height: 100,
                rotation: 0,
                top: 20,
                left: 20,
                borderRadius: 10,
                clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            };

            if (!rotateDirection) {
                const highestZIndexFront = Math.max(...frontPictures.map(p => p.zIndexes ?? 0), 0);
                const newZIndex = highestZIndexFront + 1;

                const newFrontItem = { ...baseImage, zIndexes: newZIndex };
                const newRevertedFrontItem = { ...baseImage, zIndexes: newZIndex, reverted: false };

                setFrontPictures([...frontPictures, newFrontItem]);
                setRevertedArrayFront([...frontPictures, newRevertedFrontItem]);
            } else {
                const highestZIndexBack = Math.max(...backPictures.map(p => p.zIndexes ?? 0), 0);
                const newZIndex = highestZIndexBack + 1;

                const newBackItem = { ...baseImage, zIndexes: newZIndex };
                const newRevertedBackItem = { ...baseImage, zIndexes: newZIndex, reverted: false };

                setBackPictures([...backPictures, newBackItem]);
                setRevertedArrayBack([...backPictures, newRevertedBackItem]);
            }

            setUploadedImg('');
        } catch (error) {
            console.error("Error adding image:", error);
        }
    };

    const [state, setState] = useState({})
    const [showDialog, setShowDialog] = useState(true)
    const [handleBlockedNavigation] =
        useCallbackPrompt(false)

    const handleChangeRoute = (event) => {
        const { name, value } = event.target
        setState({ ...state, [name]: value })
        setShowDialog(true)
    }
    const removeBg = async (ImageData, index) => {
        console.log(ImageData);



        setRemoverLoader(true)
        let flag = true
        if (!rotateDirection) {
            setFrontBackupImage(ImageData?.imageUrl)
        }
        else {
            setBackBackupImage(ImageData?.imageUrl)
            flag = false
        }

        try {
            let obj = {
                imageUrl: ImageData?.imageUrl,
            };
            const { data } = await OrderServices.removeBg(obj);
            console.log(data?.image);
            if (flag) {
                setRemoverLoader(false)
                setFrontRemovedImage(data?.image)
                setFrontPictures((prevPictures) =>
                    prevPictures.map((pic, newIndex) =>
                        newIndex === index
                            ? { ...pic, imageUrl: data?.image, width: ImageData?.width, height: ImageData?.height, rotation: ImageData?.rotation, top: ImageData?.top, left: ImageData?.left, borderRadius: ImageData?.borderRadius, clipPath: ImageData?.clipPath, removed: data?.image }
                            : pic
                    )
                );
                setRevertedArrayFront((prevArray) =>
                    prevArray.map((pic, newIndex) =>
                        newIndex === index
                            ? {
                                ...pic,
                                reverted: ImageData?.imageUrl, // Save old image in 'reverted'
                                imageUrl: data?.image, // Update 'imageUrl' with new image
                                width: ImageData?.width,
                                height: ImageData?.height,
                                rotation: ImageData?.rotation,
                                top: ImageData?.top,
                                left: ImageData?.left,
                                borderRadius: ImageData?.borderRadius,
                                clipPath: ImageData?.clipPath
                            }
                            : pic
                    )
                );



            }
            else {
                setRemoverLoader(false)
                setBackRemovedImage(data?.image)
                setBackPictures((prevPictures) =>
                    prevPictures.map((pic, newIndex) =>
                        newIndex === index
                            ? { ...pic, imageUrl: data?.image, width: ImageData?.width, height: ImageData?.height, rotation: ImageData?.rotation, top: ImageData?.top, left: ImageData?.left, borderRadius: ImageData?.borderRadius, clipPath: ImageData?.clipPath }
                            : pic
                    )
                );
                setRevertedArrayBack((prevArray) =>
                    prevArray.map((pic, newIndex) =>
                        newIndex === index
                            ? {
                                ...pic,
                                reverted: ImageData?.imageUrl, // Save old image in 'reverted'
                                imageUrl: data?.image, // Update 'imageUrl' with new image
                                width: ImageData?.width,
                                height: ImageData?.height,
                                rotation: ImageData?.rotation,
                                top: ImageData?.top,
                                left: ImageData?.left,
                                borderRadius: ImageData?.borderRadius,
                                clipPath: ImageData?.clipPath
                            }
                            : pic
                    )
                );
            }




        } catch (error) {
            console.log(error);
        } finally {
            setRemoverLoader(false)
        }
    };
    const revertImage = async (ImageData, index) => {
        if (!ImageData) return;

        if (!rotateDirection) {
            setFrontPictures((prev) =>
                prev.map((item, newIndex) =>
                    newIndex === index
                        ? {
                            ...item,
                            imageUrl: revertedArrayFront?.[index]?.reverted || "",
                            width: ImageData.width,
                            height: ImageData.height,
                            rotation: ImageData.rotation,
                            top: ImageData.top,
                            left: ImageData.left,
                            borderRadius: ImageData.borderRadius,
                            clipPath: ImageData.clipPath,
                        }
                        : item
                )
            );
            setRevertedArrayFront((prev) =>
                prev.map((item, newIndex2) =>
                    newIndex2 === index
                        ? {
                            ...item,
                            reverted: false,

                        }
                        : item
                )
            );

        } else {
            setBackPictures((prev) =>
                prev.map((item, newIndex) =>
                    newIndex === index
                        ? {
                            ...item,
                            imageUrl: revertedArrayBack?.[index]?.reverted || "",
                            width: ImageData.width,
                            height: ImageData.height,
                            rotation: ImageData.rotation,
                            top: ImageData.top,
                            left: ImageData.left,
                            borderRadius: ImageData.borderRadius,
                            clipPath: ImageData.clipPath,
                        }
                        : item
                )
            );
            setRevertedArrayBack((prev) =>
                prev.map((item, newIndex2) =>
                    newIndex2 === index
                        ? {
                            ...item,
                            reverted: false,

                        }
                        : item
                )
            );
        }
    };

    const handleDialogAction = async (value) => {
        setConfirmationDialog(false);
        let message
        if (textArray.length === 0 &&
            textBackArray.length === 0 &&
            frontPictures.length === 0 &&
            backPictures.length === 0) {
            message = 'There are no images or text added to it yet.'
        }
        else if (
            frontPictures.length === 0 &&
            backPictures.length === 0) {
            message = 'No images have been uploaded to it yet.'
        }
        // Check if all arrays are empty
        if (
            (textArray.length === 0 &&
                textBackArray.length === 0) ||
            (frontPictures.length === 0 &&
                backPictures.length === 0)
        ) {

            const result = await Swal.fire({
                title: 'Confirmation',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, proceed',
                cancelButtonText: 'Cancel',
            });

            if (!result.isConfirmed) {
                // Do nothing if the user cancels (just close the Swal)
                return;
            }

            // Logic to execute when the user confirms
            let pic = JSON.parse(localStorage.getItem('gallery'));
            console.log(pic);

            let obj = {
                name: value,
                _id: savedDesign ? savedDesign?._id : null,
                design: {
                    frontText: textArray,
                    backText: textBackArray,
                    frontPic: frontPictures,
                    backPic: backPictures,
                    color: selectedTshirt,
                },
                prompt: localStorage.getItem('prompt'),
                generated_art:
                    frontPictures.length > 0
                        ? frontPictures[0]?.imageUrl
                        : backPictures.length > 0 ? backPictures[0]?.imageUrl : 'https://printmeup.s3.ap-southeast-1.amazonaws.com/processedV1-1734679038836.png',
            };

            console.log(obj, 'obj');
            const { data } = await OrderServices.SaveDesign(obj);
            console.log(data);
            setSavedDesign(data?.design);
            localStorage.setItem('saveDesign', JSON.stringify(data?.design));

            if (data) {
                navigate("/my-account", { state: "2" })
                setConfirmationDialog(false);
            }
        } else {
            // Direct execution if arrays are not empty
            setConfirmationDialog(false);
            console.log(value);

            let pic = JSON.parse(localStorage.getItem('gallery'));
            console.log(pic);

            let obj = {
                name: value,
                _id: savedDesign ? savedDesign?._id : null,
                design: {
                    frontText: textArray,
                    backText: textBackArray,
                    frontPic: frontPictures,
                    backPic: backPictures,
                    color: selectedTshirt,
                },
                prompt: localStorage.getItem('prompt'),
                generated_art:
                    frontPictures.length > 0
                        ? frontPictures[0]?.imageUrl
                        : backPictures.length > 0 ? backPictures[0]?.imageUrl : 'https://printmeup.s3.ap-southeast-1.amazonaws.com/processedV1-1734679038836.png',
            };

            console.log(obj, 'obj');
            const { data } = await OrderServices.SaveDesign(obj);
            console.log(data);
            setSavedDesign(data?.design);
            localStorage.setItem('saveDesign', JSON.stringify(data?.design));

            if (data) {
                navigate("/my-account", { state: "2" })
                setConfirmationDialog(false);
            }
        }
    };


    const handleDialogActionNew = async (value) => {
        setConfirmationDialog(false);
        let message
        if (textArray.length === 0 &&
            textBackArray.length === 0 &&
            frontPictures.length === 0 &&
            backPictures.length === 0) {
            message = 'There are no images or text added to it yet.'
        }
        else if (
            frontPictures.length === 0 &&
            backPictures.length === 0) {
            message = 'No images have been uploaded to it yet.'
        }
        // Check if all arrays are empty
        if (
            (textArray.length === 0 &&
                textBackArray.length === 0) ||
            (frontPictures.length === 0 &&
                backPictures.length === 0)
        ) {
            const result = await Swal.fire({
                title: 'Confirmation',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, proceed',
                cancelButtonText: 'Cancel',
            });

            if (!result.isConfirmed) {
                // Do nothing if the user cancels (just close the Swal)
                return;
            }

            // Logic to execute when the user confirms
            let pic = JSON.parse(localStorage.getItem('gallery'));
            console.log(pic);

            let obj = {
                name: value,
                _id: null,
                design: {
                    frontText: textArray,
                    backText: textBackArray,
                    frontPic: frontPictures,
                    backPic: backPictures,
                    color: selectedTshirt,
                },
                prompt: localStorage.getItem('prompt'),
                generated_art:
                    frontPictures.length > 0
                        ? frontPictures[0]?.imageUrl
                        : backPictures.length > 0 ? backPictures[0]?.imageUrl : 'https://printmeup.s3.ap-southeast-1.amazonaws.com/processedV1-1734679038836.png',
            };

            console.log(obj, 'obj');
            const { data } = await OrderServices.SaveDesign(obj);
            console.log(data);
            setSavedDesign(data?.design);
            localStorage.setItem('saveDesign', JSON.stringify(data?.design));

            if (data) {
                navigate("/my-account", { state: "2" })
                setConfirmationDialog(false);
            }
        } else {
            // Direct execution if arrays are not empty
            setConfirmationDialog(false);
            console.log(value);

            let pic = JSON.parse(localStorage.getItem('gallery'));
            console.log(pic);

            let obj = {
                name: value,
                _id: null,
                design: {
                    frontText: textArray,
                    backText: textBackArray,
                    frontPic: frontPictures,
                    backPic: backPictures,
                    color: selectedTshirt,
                },
                prompt: localStorage.getItem('prompt'),
                generated_art:
                    frontPictures.length > 0
                        ? frontPictures[0]?.imageUrl
                        : backPictures.length > 0 ? backPictures[0]?.imageUrl : 'https://printmeup.s3.ap-southeast-1.amazonaws.com/processedV1-1734679038836.png',
            };

            console.log(obj, 'obj');
            const { data } = await OrderServices.SaveDesign(obj);
            console.log(data);
            setSavedDesign(data?.design);
            localStorage.setItem('saveDesign', JSON.stringify(data?.design));

            if (data) {
                navigate("/my-account", { state: "2" })
                setConfirmationDialog(false);
            }
        }
    };

    // Add formatting handler functions
    const handleBoldToggle = () => {
        setIsBold(!isBold);
        if (textState === 'edit') {
            if (!rotateDirection) {
                textArray[selectedIndex].isBold = !isBold;
                updateTextWithFormatting();
            } else {
                textBackArray[selectedIndexBack].isBold = !isBold;
                updateTextWithFormatting();
            }
        }
    };

    const handleItalicToggle = () => {
        setIsItalic(!isItalic);
        if (textState === 'edit') {
            if (!rotateDirection) {
                textArray[selectedIndex].isItalic = !isItalic;
                updateTextWithFormatting();
            } else {
                textBackArray[selectedIndexBack].isItalic = !isItalic;
                updateTextWithFormatting();
            }
        }
    };

    const handleUnderlineToggle = () => {
        setIsUnderline(!isUnderline);
        if (textState === 'edit') {
            if (!rotateDirection) {
                textArray[selectedIndex].isUnderline = !isUnderline;
                updateTextWithFormatting();
            } else {
                textBackArray[selectedIndexBack].isUnderline = !isUnderline;
                updateTextWithFormatting();
            }
        }
    };

    const updateTextWithFormatting = async () => {
        if (textState === 'edit') {
            if (!rotateDirection) {
                let oldWidth = textArray[selectedIndex].width;
                let oldHeight = textArray[selectedIndex].height;
                let size = calculateTextDimensions(getValues('tshirtText'), textArray[selectedIndex]?.font, '35', textArray[selectedIndex].isBold ? 900 : 600);
                let url = await generateCurvedTextCanvas(
                    getValues('tshirtText'),
                    textArray[selectedIndex].shape?.curve,
                    textArray[selectedIndex].shape?.offSetY,
                    textArray[selectedIndex].shape?.height,
                    textArray[selectedIndex].shape?.bottom,
                    textArray[selectedIndex].shape?.triangle,
                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    textArray[selectedIndex].color,
                    textArray[selectedIndex].font,
                    textArray[selectedIndex]?.shape,
                    textArray[selectedIndex].isBold,
                    textArray[selectedIndex].isItalic,
                    textArray[selectedIndex].isUnderline,
                );

                let scaleFactor = oldWidth / (url.width / 4);
                let adjustedHeight = (url.height / 4) * scaleFactor;

                let updatedArray = textArray.map((item, index) => {
                    if (index === selectedIndex) {
                        return {
                            ...item,
                            text: getValues('tshirtText'),
                            font: textArray[selectedIndex].font,
                            url: url?.croppedBase64Image,
                            width: oldWidth,
                            height: adjustedHeight,
                            scaleFactor: scaleFactor,
                            isBold: textArray[selectedIndex].isBold,
                            isItalic: textArray[selectedIndex].isItalic,
                            isUnderline: textArray[selectedIndex].isUnderline
                        };
                    }
                    return item;
                });
                setTextArray(updatedArray);
            } else {
                let oldWidth = textBackArray[selectedIndexBack].width;
                let oldHeight = textBackArray[selectedIndexBack].height;
                let size = calculateTextDimensions(getValues('tshirtText'), textBackArray[selectedIndexBack].font, '35', 600);
                let url = await generateCurvedTextCanvas(
                    getValues('tshirtText'),
                    textBackArray[selectedIndexBack].shape?.curve,
                    textBackArray[selectedIndexBack].shape?.offSetY,
                    textBackArray[selectedIndexBack].shape?.height,
                    textBackArray[selectedIndexBack].shape?.bottom,
                    textBackArray[selectedIndexBack].shape?.triangle,
                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    textBackArray[selectedIndexBack].color,
                    textBackArray[selectedIndexBack].font,
                    textBackArray[selectedIndexBack]?.shape,
                    textBackArray[selectedIndexBack].isBold,
                    textBackArray[selectedIndexBack].isItalic,
                    textBackArray[selectedIndexBack].isUnderline,
                );

                let scaleFactor = oldWidth / (url.width / 4);
                let adjustedHeight = (url.height / 4) * scaleFactor;

                let updatedArray = textBackArray.map((item, index) => {
                    if (index === selectedIndexBack) {
                        return {
                            ...item,
                            text: getValues('tshirtText'),
                            font: textBackArray[selectedIndexBack].font,
                            url: url?.croppedBase64Image,
                            width: oldWidth,
                            height: adjustedHeight,
                            scaleFactor: scaleFactor,
                            isBold: textBackArray[selectedIndexBack].isBold,
                            isItalic: textBackArray[selectedIndexBack].isItalic,
                            isUnderline: textBackArray[selectedIndexBack].isUnderline
                        };
                    }
                    return item;
                });
                setTextBackArray(updatedArray);
            }
        }
    };

    const handleDialogAction2 = async (value, id) => {
        setConfirmationDialog2(false)

        localStorage.setItem('designArray', JSON.stringify({ frontText: textArray, backText: textBackArray, frontPic: frontPictures, backPic: backPictures, color: selectedTshirt }))
        localStorage.setItem('gallery', JSON.stringify(galleryPictures))
        console.log(value);
        let pic = JSON.parse(localStorage.getItem('gallery'))
        console.log(JSON.parse(localStorage.getItem('gallery')));


        let obj = {
            name: value,
            _id: id,
            design: { frontText: textArray, backText: textBackArray, frontPic: frontPictures, backPic: backPictures, color: selectedTshirt },
            prompt: localStorage.getItem('prompt'),
            generated_art: frontPictures.length > 0 ? frontPictures[0]?.imageUrl : backPictures[0]?.imageUrl
        }
        console.log(obj, 'obj');
        const { data } = await OrderServices.SaveDesign(obj)
        console.log(data?.responseCode, 'statusstatusstatusstatus');
        localStorage.setItem('saveDesign', JSON.stringify(data?.design))
        setSavedDesign(data?.design)
        if (data?.design) {
            setConfirmationDialog(false)


            navigate(`/order/${data?.design?._id}`)

        }
    };

    const handleDialogAction3 = async (value) => {
        navigate(`/`)

    };
    const itemsPerPage = 50;
    const Tabs = [
        { id: 0, name: "Add Text", icon: (color) => <TextIcon color={color} /> },
        { id: 1, name: "Tshirt Colors", icon: (color) => <Color color={color} /> },
        { id: 2, name: "Graphic", icon: (color) => <Graphic color={color} /> },
        { id: 3, name: "Gallery", icon: (color) => <Gallery color={color} /> },
        { id: 4, name: "Upload", icon: (color) => <UploadIcon color={color} /> },
    ];
    const desiredFonts = [
        'Teko', 'Bebas Neue', 'Baloo Bhaina',
        'Barlow Condensed', 'Righteous', 'Monoton',
        'Bungee Shade', 'Lato', 'Playfair Display',
        'Cinzel', 'Muli', 'Trade Gothic', 'PT Sans Narrow',
        'Nunito', 'Bebas Neue', 'Black Ops One', 'Audiowide',
        'Russo One', 'Archivo Black' // Replaced Staatliches with Archivo Black
    ];







    const smallFonts = [
        'Teko',
        'Barlow Condensed', 'Righteous',
        'Lato', 'Playfair Display', 'PT Sans Narrow', 'Nunito'
    ];







    const customColors = [
        '#000000', // black
        '#FFFFFF', // white
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF',
        '#0000ff',
        '#3eeb29'
    ];
    const contentRef = useRef(null);
    const {
        register,
        handleSubmit,
        getValues,
        setValue,
        formState: { errors },
        reset
    } = useForm();
    const {
        register: register1,
        handleSubmit: handleSubmit1,
        getValues: getValues1,
        setValue: setValue1,
        formState: { errors1 },

    } = useForm();

    const handleSearch = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        if (term === '') {
            setDisplayedFonts(fonts.slice(0, itemsPerPage));
        } else {
            const filteredFonts = fonts.filter((font) =>
                font.family.toLowerCase().includes(term.toLowerCase())
            );
            setDisplayedFonts(filteredFonts);
        }
    };


    const [textShapes, setTextShapes] = useState(textArray.map(() => 'none')); // Initialize shapes for all text items
    const [textShapesBack, setTextShapesBack] = useState(textBackArray.map(() => 'none'));
    const handleShapeChange = (index, shape) => {
        console.log(textArray, 'textArray[selectedIndex]');
        if (!rotateDirection) {
            if (textArray[selectedIndex].shape) {

                textArray[selectedIndex].shape = shape;
                setTextShapes(prevShapes => {
                    const newShapes = [...prevShapes];
                    newShapes[selectedIndex] = shape;
                    return newShapes;
                });
            }
        } else {
            console.log(textBackArray[selectedIndexBack].shape, 'asdasasdasdasdads');
            if (textBackArray[selectedIndexBack].shape) {

                textBackArray[selectedIndexBack].shape = shape;
                setTextShapesBack(prevShapes => {
                    const newShapes = [...prevShapes];
                    newShapes[selectedIndexBack] = shape;
                    return newShapes;
                });
            }
        }
    };

    useEffect(() => {
        let data = localStorage.getItem('saveDesign')
        data = JSON.parse(data)
        if (data) {
            setSavedDesign(data)
        }

    }, [])







    const toggleDrawer = (open) => (event) => {
        setOpen(open);
    };

    const handleClick = (item) => {
        setSelectedSize(item)

    };
    const navigate = useNavigate()
    const [blockPickerColor, setBlockPickerColor] = useState("#37d67a");

    const [fontSize, setFontSize] = useState(18); // Initial font size
    const [fontFamily, setFontFamily] = useState(); // Initial font family
    const [selectedColor, setSelectedColor] = useState('')
    const [selectedBottomTab, setSelectedBottomTab] = React.useState('recents');
    const [editNav, setEditNav] = useState(false)
    const [imageEdit, setImageEdit] = useState(false)
    const [simpleNav, setSimpleNav] = useState(true)
    const [editDrawer, setEditDrawer] = useState(false)

    const [showButton, setShowButton] = useState(window.innerWidth < 1320);


    const shapesArray = [{ name: 'Square', value: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', color: 'gray' },
    { name: 'Hexagon', value: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)', color: '#3cb371' },
    { name: 'Heptagon', value: 'polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%)', color: '#ffa500' },
    { name: 'Octagon', value: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)', color: '#1e90ff' }

    ]
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const handleChange = (event, newValue) => {
        setSelectedBottomTab(newValue);
        console.log(newValue);
    };
    const handleIncreament = () => {
        setQuantity(quantity + 1)

    }
    const handleDrawer = (value, action) => {
        console.log(value, action);
        setOpen(value)
        setModalInnerState(action)

    }
    const handleEditDrawer = (value, action) => {
        console.log(value, action);
        setEditDrawer(value)
        setEditModalState(action)

    }
    const handleWeightChange = (event, newValue) => {
        setFontWeight(newValue)
        if (textState == 'edit') {
            if (!rotateDirection) {
                textArray[selectedIndex].fontWeight = newValue
                let size = calculateTextDimensions(textArray[selectedIndex].text, textArray[selectedIndex].fontFamily, textArray[selectedIndex].fontSize, newValue)
                textArray[selectedIndex].width = size.width + 3;

                let element = document.getElementById(`text${selectedIndex}`)
                if (element) {

                    element.style.fontWeight = `${newValue}`

                }
            }
            else {
                textBackArray[selectedIndexBack].fontWeight = newValue
                let size = calculateTextDimensions(textBackArray[selectedIndexBack].text, textBackArray[selectedIndexBack].fontFamily, textBackArray[selectedIndexBack].fontSize, newValue)
                textBackArray[selectedIndexBack].width = size.width + 3;
                let element = document.getElementById(`text${selectedIndexBack}`)
                if (element) {

                    element.style.fontWeight = `${newValue}`

                }
            }
        }

    }
    const handleImageBorderRadius = (event, newValue) => {
        // Check if newValue is defined
        if (newValue === undefined) return;

        setImageBorderRadius(newValue);

        // Update borderRadius based on the rotateDirection
        if (!rotateDirection) {
            if (frontPictures[imageSelectedIndex]) {
                frontPictures[imageSelectedIndex].borderRadius = newValue;
                console.log(frontPictures);
            }
        } else {
            if (backPictures[imageSelectedIndexBack]) {
                backPictures[imageSelectedIndexBack].borderRadius = newValue;
                console.log(backPictures, 'backPictures');
            }
        }
    };


    const handleDecreament = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1)
        }
    }
    const handleTextColor = async (color) => {
        console.log(color, 'color.hex');

        let size = calculateTextDimensions(getValues('tshirtText'),
            !rotateDirection ? textArray[selectedIndex].font : textBackArray[selectedIndexBack].font,
            '35', 600
        );

        let url = await generateCurvedTextCanvas(
            getValues('tshirtText'),
            !rotateDirection ? textArray[selectedIndex].shape?.curve : textBackArray[selectedIndexBack].shape?.curve,
            !rotateDirection ? textArray[selectedIndex].shape?.offSetY : textBackArray[selectedIndexBack].shape?.offSetY,
            !rotateDirection ? textArray[selectedIndex].shape?.height : textBackArray[selectedIndexBack].shape?.height,
            !rotateDirection ? textArray[selectedIndex].shape?.bottom : textBackArray[selectedIndexBack].shape?.bottom,
            !rotateDirection ? textArray[selectedIndex].shape?.triangle : textBackArray[selectedIndexBack].shape?.triangle,
            size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
            size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
            color,
            !rotateDirection ? textArray[selectedIndex].font : textBackArray[selectedIndexBack].font,
            !rotateDirection ? textArray[selectedIndex].shape : textBackArray[selectedIndexBack].shape,
            !rotateDirection ? textArray[selectedIndex].isBold : textBackArray[selectedIndexBack].isBold,
            !rotateDirection ? textArray[selectedIndex].isItalic : textBackArray[selectedIndexBack].isItalic,
            !rotateDirection ? textArray[selectedIndex].isUnderline : textBackArray[selectedIndexBack].isUnderline,

        );

        if (textState === 'edit') {
            if (!rotateDirection) {
                const updatedArray = [...textArray];
                updatedArray[selectedIndex] = {
                    ...updatedArray[selectedIndex],
                    width: textArray[selectedIndex].width,
                    height: textArray[selectedIndex].height,
                    url: url?.croppedBase64Image,
                    color: color,
                };
                setTextArray(updatedArray); // Triggers re-render
            } else {
                const updatedBackArray = [...textBackArray];
                updatedBackArray[selectedIndexBack] = {
                    ...updatedBackArray[selectedIndexBack],

                    url: url?.croppedBase64Image,
                    color: color,
                };
                console.log(updatedBackArray, 'updatedBackArray');

                setTextBackArray(updatedBackArray); // Triggers re-render
            }
        }
    };

    const addImage = (location) => {
        if (!rotateDirection && frontPictures.length > 0) {
            handleHorizontalImagePosition('center', 'front')
            handleVerticalImagePosition('center', 'front')
        }
        if (!rotateDirection && frontPictures.length == 0) {
            let gallery = localStorage.getItem('gallery')
            console.log(gallery);



            gallery = JSON.parse(gallery)
            setFrontPictures([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }])
            setGalleryPictures([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }])


        }
        else if (rotateDirection && backPictures.length == 0) {
            let gallery = localStorage.getItem('gallery')
            setBackPictures([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }])
            setGalleryPictures([{ imageUrl: imageUrl.imageUrl, width: 100, height: 100, rotation: 0, top: 20, left: 20, borderRadius: 10, clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)' }])

        }
        if (rotateDirection && backPictures.length > 0) {
            handleHorizontalImagePosition('center', 'back')
            handleVerticalImagePosition('center', 'back')
        }
        setOpen(false)


    }
    const handleDelete = (index, location) => {
        console.log('delete');
        if (location == 'front') {
            let array = textArray
            let newArray = array.filter((_, i) => i !== index);

            console.log(newArray);

            setTextArray(newArray)
            setSelectedIndex('')
            setSelectedIndexBack('')

        }
        else {
            let array = textBackArray
            let newArray = array.filter((_, i) => i !== index);

            console.log(newArray);

            setTextBackArray(newArray)
            setSelectedIndex('')
            setSelectedIndexBack('')
            // let element = document.getElementById('back' + index)
            // element.remove()
        }
    }

    const handleImageDelete = (index, location) => {
        console.log(index, location);
        if (location == 'front') {
            console.log(frontPictures, 'frontPictures');
            let array = frontPictures
            let newArray = array.filter((_, i) => i !== index);
            let newArray2 = revertedArrayFront.filter((_, i) => i !== index);
            setRevertedArrayFront(newArray2)
            console.log(newArray);
            setFrontPictures(newArray)
            setImageBorderRadius(10)
        }
        else {
            console.log(backPictures, 'backPicturesbackPictures');
            let array = backPictures
            let newArray = array.filter((_, i) => i !== index);
            let newArray2 = revertedArrayBack.filter((_, i) => i !== index);
            setRevertedArrayBack(newArray2)
            setImageBorderRadius(10)
            console.log(newArray);
            setBackPictures(newArray)
        }

    }
    const handleFontSizeChange = (event, newValue) => {
        setFontSize(newValue)
        console.log(newValue, 'newValuenewValuenewValue');
        if (textState == 'edit') {
            if (!rotateDirection) {
                textArray[selectedIndex].fontSize = `${newValue}px`
                let element = document.getElementById(`text${selectedIndex}`)
                if (element) {

                    element.style.fontSize = `${newValue}px`
                }
            }
            else {
                textBackArray[selectedIndexBack].fontSize = `${newValue}px`
                let element = document.getElementById(`text${selectedIndexBack}`)
                if (element) {

                    element.style.fontSize = `${newValue}px`
                }
            }
        }

    };

    const handleFontFamilyChange = (value) => {

        let element = document.getElementById(`text${selectedIndex}`)
        if (element) {

            element.style.fontFamily = value
        }

    };


    const colors = [
        "#F7D560", // Yellow (C: 5, M: 15, Y: 75, K: 0)
        "#FFB300", // Orange-Yellow (C: 0, M: 30, Y: 100, K: 0)
        "#43A047", // Green (C: 80, M: 10, Y: 90, K: 10)
        "#7CB342", // Lime Green (C: 60, M: 10, Y: 90, K: 5)
        "#E64A19", // Deep Orange (C: 0, M: 80, Y: 90, K: 10)
        "#5D4037", // Brown (C: 30, M: 60, Y: 60, K: 50)
        "#546E7A", // Slate Gray (C: 40, M: 20, Y: 20, K: 50)
        "#001A66", // Navy Blue (C: 100, M: 80, Y: 0, K: 60)
        "#000000", // Black (C: 0, M: 0, Y: 0, K: 100)
        "#1A263D", // Dark Blue-Black (C: 80, M: 60, Y: 50, K: 70)
        "#D9005D", // Magenta (C: 0, M: 100, Y: 40, K: 15)
        "#8E44AD", // Purple (C: 40, M: 80, Y: 0, K: 15)
        "#2980B9", // Blue (C: 85, M: 50, Y: 0, K: 25)
        "#009EE3", // Light Blue (C: 80, M: 20, Y: 0, K: 10)
        "#00897B", // Teal (C: 90, M: 40, Y: 50, K: 20)
        "#FFFFFF"  // White (C: 0, M: 0, Y: 0, K: 0)
    ];



    const [selectedElement, setSelectedElement] = useState(null);

    const getPricing = async () => {
        try {
            let params = {

            }
            const { data } = await OrderServices.getPricing(params)
            console.log(data);
            setTshirtColors(data?.pricing?.shirt_colors)



        } catch (error) {
            console.log(error);
        } finally {

        }
    }
    useEffect(() => {
        console.log(textArray, 'textArrayChange');


    }, [textArray])


    function adjustPositionToBounds() {
        const parent = document.getElementById("pdf");

        console.log(document.getElementById(selectedIndex));
        let leftPos
        let topPos
        const element = document.getElementById(selectedIndex); // Get the selected element

        if (!parent || !element) return;

        const parentRect = parent.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        // Adjust left position
        if (elementRect.left < parentRect.left) {
            leftPos = 0
            textArray[selectedIndex].left = 0;
        } else if (elementRect.right > parentRect.right) {
            textArray[selectedIndex].left = parent.clientWidth - element.clientWidth;
            leftPos = parent.clientWidth - element.clientWidth
        }

        // Adjust top position
        if (elementRect.top < parentRect.top) {
            textArray[selectedIndex].top = 0;
            topPos = 0
        } else if (elementRect.bottom > parentRect.bottom) {
            textArray[selectedIndex].top = parent.clientHeight - element.clientHeight;
            topPos = parent.clientHeight - element.clientHeight;
        }

        let updatedTextArray = [...textArray];

        updatedTextArray[selectedIndex] = {
            ...updatedTextArray[selectedIndex],
            top: topPos,
            left: leftPos,

        };
        setTextArray(updatedTextArray);

        console.log("Updated Top:", textArray[selectedIndex].top);
        console.log("Updated Left:", textArray[selectedIndex].left);
    }


    function adjustPositionToBoundsBack() {
        const parent = document.getElementById("pdf2");
        console.log(document.getElementById('back' + selectedIndexBack));
        let leftPos
        let topPos
        const element = document.getElementById('back' + selectedIndexBack); // Get the selected element

        if (!parent || !element) return;

        const parentRect = parent.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        // Adjust left position
        if (elementRect.left < parentRect.left) {
            leftPos = 0
            textBackArray[selectedIndexBack].left = 0;
        } else if (elementRect.right > parentRect.right) {
            textBackArray[selectedIndexBack].left = parent.clientWidth - element.clientWidth;
            leftPos = parent.clientWidth - element.clientWidth
        }

        // Adjust top position
        if (elementRect.top < parentRect.top) {
            textBackArray[selectedIndexBack].top = 0;
            topPos = 0
        } else if (elementRect.bottom > parentRect.bottom) {
            textBackArray[selectedIndexBack].top = parent.clientHeight - element.clientHeight;
            topPos = parent.clientHeight - element.clientHeight;
        }

        let updatedtextBackArray = [...textBackArray];

        updatedtextBackArray[selectedIndexBack] = {
            ...updatedtextBackArray[selectedIndexBack],
            top: topPos,
            left: leftPos,

        };
        setTextBackArray(updatedtextBackArray);

        console.log("Updated Top:", textBackArray[selectedIndexBack].top);
        console.log("Updated Left:", textBackArray[selectedIndexBack].left);
    }

    useEffect(() => {
        function handleClickOutside(event) {
            // Skip if clicked element or any of its parents has id "Test"
            console.log(event.target.closest('#Test'), 'iddddd');



            console.log(event.target, 'testttttt');
            console.log(parentRef.current);
            console.log(event.target.tagName === 'div', event.target.parentElement == null);

            if (event.target.tagName === 'div') {
                console.log("tedt cond");
            }
            else if (
                (event.target.tagName === 'div' && event.target.classList.contains('Design-0')) ||
                (event.target.tagName === 'div' && event.target.classList.contains('Design2-0'))
            ) {
                console.log("image cond");
            }
            else {
                if (
                    parentRef.current && parentRef.current.contains(event.target) &&
                    !(
                        (event.target.tagName === 'DIV' && event.target.parentElement !== null) ||
                        (event.target.tagName === 'DIV' && event.target.classList.contains('Design-0') && event.target.parentElement !== null) ||
                        (event.target.tagName === 'DIV' && event.target.classList.contains('Design2-0') && event.target.parentElement !== null)
                    )
                ) {
                    console.log("yes its containing");
                    setSelectedElement(null);
                    setImageSeleted(false);
                    setImageSelectedIndex(null);
                    setImageSeletedBack(false);
                    setImageSelectedIndexBack(null);
                    setSimpleNav(true);
                    setEditNav(false);
                    setImageEdit(false);
                } else if (parentRef.current && !parentRef.current.contains(event.target)) {
                    console.log("yes no its containing");
                    setSelectedElement(null);
                    setImageSeleted(false);
                    setImageSeletedBack(false);
                    setSimpleNav(true);
                    setEditNav(false);
                    setImageEdit(false);
                }
            }
        }

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);


    const handleInputChange = async (event) => {
        if (textState == 'edit') {
            if (!rotateDirection) {
                if (getValues('tshirtText')) {
                    console.log(textArray[selectedIndex]?.font, 'url123');
                    console.log(document.getElementById('pdf'));
                    console.log(textArray[selectedIndex]);
                    adjustPositionToBounds();

                    let oldWidth = textArray[selectedIndex].width;
                    let oldHeight = textArray[selectedIndex].height;

                    let size = await calculateTextDimensions(getValues('tshirtText'), textArray[selectedIndex]?.font, '35', 600);
                    let tshirtText = getValues('tshirtText');

                    console.log(size, 'url123');

                    let url = await generateCurvedTextCanvas(
                        getValues('tshirtText'),
                        textArray[selectedIndex].shape?.curve,
                        textArray[selectedIndex].shape?.offSetY,
                        textArray[selectedIndex].shape?.height,
                        textArray[selectedIndex].shape?.bottom,
                        textArray[selectedIndex].shape?.triangle,
                        size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                            (getValues('tshirtText')?.length <= 15 ? 700 :
                                (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                        size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                            (getValues('tshirtText')?.length <= 15 ? 700 :
                                (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                        textArray[selectedIndex].color,
                        textArray[selectedIndex].font,
                        textArray[selectedIndex]?.shape,
                        textArray[selectedIndex].isBold,
                        textArray[selectedIndex].isItalic,
                        textArray[selectedIndex].isUnderline,
                    );
                    console.log(url, 'url123');

                    // Calculate the scale factor
                    let scaleFactor = oldWidth / (url.width / 4);

                    // Adjust the height proportionally while keeping the width constant
                    let adjustedHeight = (url.height / 4) * scaleFactor;

                    let updatedArray = textArray.map((item, index) => {
                        if (index === selectedIndex) {
                            return {
                                ...item,
                                text: getValues('tshirtText'),
                                font: textArray[selectedIndex].font,
                                url: url?.croppedBase64Image,
                                width: oldWidth, // Keep the original width
                                height: adjustedHeight, // Adjust the height proportionally
                                scaleFactor: scaleFactor // Store the scale factor for future use if needed
                            };
                        }
                        return item;
                    });

                    setEditDrawer(false);
                    setTextArray(updatedArray);
                }
            } else {
                if (getValues('tshirtText')) {
                    adjustPositionToBoundsBack();

                    let oldWidth = textBackArray[selectedIndexBack].width;
                    let oldHeight = textBackArray[selectedIndexBack].height;

                    let size = calculateTextDimensions(getValues('tshirtText'), textBackArray[selectedIndexBack].font, '35', 600);
                    let tshirtText = getValues('tshirtText');

                    let url = await generateCurvedTextCanvas(
                        getValues('tshirtText'),
                        textBackArray[selectedIndexBack].shape?.curve,
                        textBackArray[selectedIndexBack].shape?.offSetY,
                        textBackArray[selectedIndexBack].shape?.height,
                        textBackArray[selectedIndexBack].shape?.bottom,
                        textBackArray[selectedIndexBack].shape?.triangle,
                        size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                            (getValues('tshirtText')?.length <= 15 ? 700 :
                                (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                        size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                            (getValues('tshirtText')?.length <= 15 ? 700 :
                                (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                        textBackArray[selectedIndexBack].color,
                        textBackArray[selectedIndexBack].font,
                        textBackArray[selectedIndexBack]?.shape,
                        textBackArray[selectedIndexBack].isBold,
                        textBackArray[selectedIndexBack].isItalic,
                        textBackArray[selectedIndexBack].isUnderline,
                    );

                    // Calculate the scale factor
                    let scaleFactor = oldWidth / (url.width / 4);

                    // Adjust the height proportionally while keeping the width constant
                    let adjustedHeight = (url.height / 4) * scaleFactor;

                    let updatedArray = textBackArray.map((item, index) => {
                        if (index === selectedIndexBack) {
                            return {
                                ...item,
                                text: getValues('tshirtText'),
                                font: textBackArray[selectedIndexBack].font,
                                url: url?.croppedBase64Image,
                                width: oldWidth, // Keep the original width
                                height: adjustedHeight, // Adjust the height proportionally
                                scaleFactor: scaleFactor // Store the scale factor for future use if needed
                            };
                        }
                        return item;
                    });

                    setEditDrawer(false);
                    setTextBackArray(updatedArray);
                }
            }
        }

    };

    async function calculateFontSize(text, font, boxWidth, boxHeight) {
        let minFontSize = 1;
        let maxFontSize = 1000;
        let fontSize = 64; // Initial guess

        while (minFontSize <= maxFontSize) {
            let size = await calculateTextDimensions(text, font, fontSize.toString(), 600);

            if (size.width <= boxWidth && size.height <= boxHeight) {
                // Text fits, try a larger font size
                minFontSize = fontSize + 1;
            } else {
                // Text does not fit, try a smaller font size
                maxFontSize = fontSize - 1;
            }

            fontSize = Math.floor((minFontSize + maxFontSize) / 2);
        }

        return fontSize;
    }

    const handleExportWithComponent = (pdfExportComponent) => {
        pdfExportComponent.current.save();
    };
    const Addtext = async () => {
        setSelectedShape({ shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false })
        const tshirtText = getValues('tshirtText');
        console.log(tshirtText, 'tshirtText');
        let size = calculateTextDimensions(getValues('tshirtText'), 'Bebas Neue', '35', 600)
        let newWidthOffset = tshirtText.length < 5 ? 30 : tshirtText.length < 8
            ? 20
            : tshirtText.length < 15
                ? 30
                : tshirtText.length < 25
                    ? 60
                    : 70;
        let url = await generateCurvedTextCanvas(
            tshirtText,
            0,
            0,
            70,
            84,
            false,
            size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
            size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

            'black',
            'Bebas Neue',
            { shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false },
            isBold,
            isItalic,
            isUnderline
        )
        const textDimensions = calculateTextDimensions(tshirtText, selectedFont, fontSize, fontWeight);
        // Define the new object structure
        let newTshirtObject = {
            text: tshirtText,
            font: 'Bebas Neue',
            fontSize: fontSize,
            color: 'black',
            rotation: 0,
            fontWeight: fontWeight,
            width: url.width / 4,
            height: (url.height) / 4,
            top: 10,    // or dynamic value
            left: 10,   // or dynamic value
            zIndexes: 1,
            shape: selectedShape,
            url: url?.croppedBase64Image
        };
        let newTshirtObjectBack = {
            text: tshirtText,
            font: 'Bebas Neue',
            fontSize: fontSize,
            color: 'black',
            rotation: 0,
            fontWeight: fontWeight,
            width: url.width / 4,
            height: (url.height) / 4,
            top: 10,    // or dynamic value
            left: 10,   // or dynamic value
            zIndexes: 1,
            shape: selectedShape,
            url: url?.croppedBase64Image
        };

        if (!rotateDirection) {
            // Update the state with the new object
            setTextArray([...textArray, newTshirtObject]);
            console.log([...textArray, newTshirtObject], 'saraib');
        } else {
            // Update the state with the new object
            setTextBackArray([...textBackArray, newTshirtObjectBack]);
            console.log([...textBackArray, newTshirtObjectBack], 'saraib2');
        }
        setOpen(false)
        // Clear the input field
        setValue('tshirtText', '');
    };
    const Addtext1 = async (newText) => {
        setSelectedShape({ shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false })
        let tshirtText = getValues1('tshirtText1');
        console.log(getValues1('tshirtText1'));

        console.log(tshirtText, 'tshirtText1');
        if (!tshirtText) {
            tshirtText = newText
        }
        let size = calculateTextDimensions(getValues1('tshirtText1'), 'Bebas Neue', '35', 600)
        console.log(size);

        let url = await generateCurvedTextCanvas(
            tshirtText,
            0,
            0,
            70,
            84,
            false,
            size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
            size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                (getValues('tshirtText')?.length <= 15 ? 700 :
                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

            'black',
            'Bebas Neue',
            { shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false },
            isBold,
            isItalic,
            isUnderline
        )
        console.log(url, 'crooped');

        const textDimensions = calculateTextDimensions(tshirtText, selectedFont, fontSize, fontWeight);
        // Define the new object structure
        let newTshirtObject = {
            text: tshirtText,
            font: 'Bebas Neue',
            fontSize: fontSize,
            color: 'black',
            rotation: 0,
            fontWeight: fontWeight,
            width: url.width / 4,
            height: (url.height) / 4,
            top: 10,    // or dynamic value
            left: 10,   // or dynamic value
            zIndexes: 1,
            shape: selectedShape,
            url: url?.croppedBase64Image
        };
        let newTshirtObjectBack = {
            text: tshirtText,
            font: 'Bebas Neue',
            fontSize: fontSize,
            color: 'black',
            rotation: 0,
            fontWeight: fontWeight,
            width: url.width / 4,
            height: (url.height) / 4,
            top: 10,    // or dynamic value
            left: 10,   // or dynamic value
            zIndexes: 1,
            shape: selectedShape,
            url: url?.croppedBase64Image
        };

        if (!rotateDirection) {
            // Update the state with the new object
            setTextArray([...textArray, newTshirtObject]);
            console.log([...textArray, newTshirtObject], 'saraib');
        } else {
            // Update the state with the new object
            setTextBackArray([...textBackArray, newTshirtObjectBack]);
            console.log([...textBackArray, newTshirtObjectBack], 'saraib2');
        }
        setOpen(false)

        // Clear the input field
        setValue1('tshirtText1', '');
    };
    const handleElementClick = (e, index, action) => {
        console.log(action);

        if (action == 'delete') {
            document.getElementById(index).remove()
        }
        console.log('asdasdasdasdda');
        setSelectedIndex(index)
        let element = document.getElementById(`text${index}`)
        console.log(element);
        if (element) {

            var computedStyle = window.getComputedStyle(element);

            // Get the font-weight property
            var fontWeight = computedStyle.fontWeight;
            var textSize = computedStyle.fontSize;
            var color = computedStyle.color


            // Log the font-weight to the console
            console.log(fontWeight);
            console.log(color);
            console.log(textSize.replace("px", ""));
            setFontWeight(fontWeight)
            setBlockPickerColor(color)
            setFontSize(textSize.replace("px", ""))
        }

        if (parentRef.current.contains(e.target)) {

            setSelectedElement(e.target);
        } else {

            setSelectedElement(null);


        }
    }
    console.log(frontPictures, 'frontPicturesfrontPictures');
    const handleContextMenuOption = (index, option, location, image) => {
        const getMinZIndex = (textArray, picturesArray) => {
            const textZIndexes = textArray.map(item => item.zIndexes || 0);
            const pictureZIndexes = picturesArray.map(item => item.zIndexes || 0);
            return Math.min(...textZIndexes, ...pictureZIndexes, Infinity);
        };

        const getMaxZIndex = (textArray, picturesArray) => {
            const textZIndexes = textArray.map(item => item.zIndexes || 0);
            const pictureZIndexes = picturesArray.map(item => item.zIndexes || 0);
            return Math.max(...textZIndexes, ...pictureZIndexes, 0);
        };

        const newZIndexes = [...zIndexes];

        if (option === 'Forward') {
            let newZIndex;

            if (location === 'front') {
                const maxZIndex = getMaxZIndex(textArray, frontPictures);
                newZIndex = maxZIndex + 1;

                if (image) {
                    frontPictures[imageSelectedIndex].zIndexes = newZIndex;
                } else {
                    textArray[selectedIndex] = {
                        ...textArray[selectedIndex],
                        zIndexes: newZIndex,
                    };
                }
            } else {
                const maxZIndex = getMaxZIndex(textBackArray, backPictures);
                newZIndex = maxZIndex + 1;

                if (image) {
                    backPictures[imageSelectedIndexBack].zIndexes = newZIndex;
                } else {
                    textBackArray[selectedIndexBack] = {
                        ...textBackArray[selectedIndexBack],
                        zIndexes: newZIndex,
                    };
                }
            }

            newZIndexes[index] = newZIndex;
            setHighestZIndex(newZIndex);
        } else if (option === 'Backward') {
            const minZIndex = location === 'front'
                ? getMinZIndex(textArray, frontPictures)
                : getMinZIndex(textBackArray, backPictures);

            const newZIndex = Math.max(0, minZIndex - 1);
            newZIndexes[index] = newZIndex;

            if (location === 'front') {
                if (image) {
                    frontPictures[imageSelectedIndex].zIndexes = newZIndex;
                } else {
                    textArray[selectedIndex] = {
                        ...textArray[selectedIndex],
                        zIndexes: newZIndex,
                    };
                }
            } else {
                if (image) {
                    backPictures[imageSelectedIndexBack].zIndexes = newZIndex;
                } else {
                    textBackArray[selectedIndexBack] = {
                        ...textBackArray[selectedIndexBack],
                        zIndexes: newZIndex,
                    };
                }
            }
        }

        setZIndexes(newZIndexes);
    };






    const loadFont = (fontName) => {
        const linkId = `google-font-${fontName.replace(/ /g, '-')}`;
        if (!document.getElementById(linkId)) {
            const link = document.createElement('link');
            link.id = linkId;
            link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, '+')}&display=swap`;
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
    };

    const loadMoreFonts = useCallback(() => {
        if (loading) return;
        setLoading(true);

        const newFonts = fonts.slice((page - 1) * itemsPerPage, page * itemsPerPage);
        setDisplayedFonts(prevFonts => [...prevFonts, ...newFonts]);

        setLoading(false);
    }, [page, loading, fonts]);

    const handleScroll = () => {
        if (!containerRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

        if (scrollTop + clientHeight >= scrollHeight - 5 && !loading) {
            setPage(prevPage => prevPage + 1);
        }
    };
    useEffect(() => {
        loadMoreFonts();
    }, [page]);

    const handleCaptureClick = async () => {
        if (parentRef.current) {
            const canvas = await html2canvas(parentRef.current, {
                scale: 10, // Increase scale for higher quality
                useCORS: true // Use CORS to handle cross-origin images
            });
            const dataUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = 'capture.png';
            link.click();
        }
    };
    const handleFontClick = async (fontName) => {
        setSelectedFont(fontName);
        setSearchTerm(fontName)
        // document.getElementById('dropdown-font').style.
        setIsDropdownOpen(false)
        loadFont(fontName);
        if (textState == 'edit') {
            if (!rotateDirection) {
                let oldWidth = textArray[selectedIndex].width;
                let oldHeight = textArray[selectedIndex].height;

                textArray[selectedIndex].fontFamily = fontName;
                console.log(textArray[selectedIndex], 'fontNamefontName');

                let size = calculateTextDimensions(getValues('tshirtText'), fontName, '35', 600);
                let tshirtText = getValues('tshirtText');

                let url = await generateCurvedTextCanvas(
                    getValues('tshirtText'),
                    textArray[selectedIndex].shape?.curve,
                    textArray[selectedIndex].shape?.offSetY,
                    textArray[selectedIndex].shape?.height,
                    textArray[selectedIndex].shape?.bottom,
                    textArray[selectedIndex].shape?.triangle,
                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                    textArray[selectedIndex].color,
                    fontName,
                    textArray[selectedIndex]?.shape,
                    textArray[selectedIndex].isBold,
                    textArray[selectedIndex].isItalic,
                    textArray[selectedIndex].isUnderline,
                );

                // Calculate the scale factor
                let scaleFactor = oldWidth / (url.width / 4);

                // Adjust the height proportionally while keeping the width constant
                let adjustedHeight = (url.height / 4) * scaleFactor;

                let updatedArray = textArray.map((item, index) => {
                    if (index === selectedIndex) {
                        return {
                            ...item,
                            font: fontName,
                            url: url?.croppedBase64Image,
                            width: oldWidth, // Keep the original width
                            height: adjustedHeight, // Adjust the height proportionally
                            scaleFactor: scaleFactor // Store the scale factor for future use if needed
                        };
                    }
                    return item;
                });

                setTextArray(updatedArray);
            } else {
                let oldWidth = textBackArray[selectedIndexBack].width;
                let oldHeight = textBackArray[selectedIndexBack].height;

                console.log(textBackArray[selectedIndexBack].shape, ' textBackArray[selectedIndexBack].shape');

                let size = calculateTextDimensions(getValues('tshirtText'), fontName, '35', 600);
                let tshirtText = getValues('tshirtText');
                let newWidthOffset = tshirtText.length < 5 ? 30 : tshirtText.length < 8
                    ? 20
                    : tshirtText.length < 15
                        ? 30
                        : tshirtText.length < 25
                            ? 60
                            : 70; // Default case for lengths >= 25

                let url = await generateCurvedTextCanvas(
                    getValues('tshirtText'),
                    textBackArray[selectedIndexBack].shape?.curve,
                    textBackArray[selectedIndexBack].shape?.offSetY,
                    textBackArray[selectedIndexBack].shape?.height,
                    textBackArray[selectedIndexBack].shape?.bottom,
                    textBackArray[selectedIndexBack].shape?.triangle,
                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                        (getValues('tshirtText')?.length <= 15 ? 700 :
                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                    textBackArray[selectedIndexBack].color,
                    fontName,
                    textBackArray[selectedIndexBack]?.shape,
                    textBackArray[selectedIndexBack].isBold,
                    textBackArray[selectedIndexBack].isItalic,
                    textBackArray[selectedIndexBack].isUnderline,
                );

                // Calculate the scale factor
                let scaleFactor = oldWidth / (url.width / 4);

                // Adjust the height proportionally while keeping the width constant
                let adjustedHeight = (url.height / 4) * scaleFactor;

                let updatedArray = textBackArray.map((item, index) => {
                    if (index === selectedIndexBack) {
                        return {
                            ...item,
                            font: fontName,
                            url: url?.croppedBase64Image,
                            width: oldWidth, // Keep the original width
                            height: adjustedHeight, // Adjust the height proportionally
                            scaleFactor: scaleFactor // Store the scale factor for future use if needed
                        };
                    }
                    return item;
                });

                setTextBackArray(updatedArray);
            }
        }

    };
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const handleShapeSelect = (name, value) => {
        setSelectedShape(value)
        if (!rotateDirection) {
            let element = document.getElementById(`front-${imageSelectedIndex}`)
            if (element) {
                frontPictures[imageSelectedIndex].clipPath = value
                element.style.clipPath = value
            }
        }
        else {
            let element = document.getElementById(`back-${imageSelectedIndexBack}`)
            if (element) {
                backPictures[imageSelectedIndexBack].clipPath = value
                element.style.clipPath = value
            }
        }
    }
    const handleRotate = () => {
        // Trigger the animation by updating the state
        setRotate(true);

        // Remove the class after the animation ends
        setTimeout(() => {
            setRotate(false);
        }, 1000); // Duration of the animation should match the CSS animation duration
    };

    const handleHorizontalPosition = (position, shirtPosition) => {
        if (shirtPosition == 'front') {
            let element = document.getElementById(selectedIndex)
            if (element) {
                if (position == 'left') {
                    element.style.left = '0px'
                    textArray[selectedIndex].left = element.style.left
                }
                if (position == 'center') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth) / 2;
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition}px`
                    textArray[selectedIndex].left = leftPosition
                }
                if (position == 'right') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth);
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition - 2}px`
                    textArray[selectedIndex].left = leftPosition - 2
                }
            }
        }
        else {
            let element = document.getElementById('back' + selectedIndexBack)
            if (element) {
                if (position == 'left') {
                    element.style.left = '0px'
                    textBackArray[selectedIndexBack].left = element.style.left
                }
                if (position == 'center') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf2')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth) / 2;
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition}px`
                    textBackArray[selectedIndexBack].left = leftPosition
                }
                if (position == 'right') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf2')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth);
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition - 2}px`
                    textBackArray[selectedIndexBack].left = leftPosition - 2
                }
            }
        }
    }
    const handleVerticalPosition = (position, shirtPosition) => {
        if (shirtPosition == 'front') {
            let element = document.getElementById(selectedIndex)
            if (element) {
                if (position == 'top') {
                    element.style.top = '0px'
                    textArray[selectedIndex].top = element.style.top
                }
                if (position == 'center') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight) / 2
                    element.style.top = `${topPosition}px`
                    textArray[selectedIndex].top = topPosition

                }
                if (position == 'bottom') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight)
                    element.style.top = `${topPosition}px`
                    textArray[selectedIndex].top = topPosition
                }
            }
        }
        else {
            let element = document.getElementById('back' + selectedIndexBack)
            if (element) {
                if (position == 'top') {
                    element.style.top = '0px'
                    textBackArray[selectedIndexBack].top = element.style.top
                }
                if (position == 'center') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf2')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight) / 2
                    element.style.top = `${topPosition}px`
                    textBackArray[selectedIndexBack].top = element.style.top

                }
                if (position == 'bottom') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf2')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight)
                    element.style.top = `${topPosition}px`
                    textBackArray[selectedIndexBack].top = element.style.top
                }
            }
        }
    }
    const handleHorizontalImagePosition = (position, shirtPosition) => {
        if (shirtPosition == 'front') {
            let element = document.getElementById(`front-${imageSelectedIndex}`)
            if (element) {
                if (position == 'left') {
                    element.style.left = '0px'
                    frontPictures[imageSelectedIndex].left = element.style.left
                }
                if (position == 'center') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth) / 2;
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition}px`
                    frontPictures[imageSelectedIndex].left = leftPosition
                }
                if (position == 'right') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth);
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition - 2}px`
                    frontPictures[imageSelectedIndex].left = leftPosition - 2
                }
            }
        }
        else {
            let element = document.getElementById(`back-${imageSelectedIndexBack}`)
            if (element) {
                if (position == 'left') {
                    element.style.left = '0px'
                    backPictures[imageSelectedIndexBack].left = 0
                }
                if (position == 'center') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf2')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth) / 2;
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition}px`
                    backPictures[imageSelectedIndexBack].left = leftPosition
                }
                if (position == 'right') {
                    let childWidth = element.offsetWidth
                    console.log(childWidth);
                    let element2 = document.getElementById('pdf2')
                    let parentWidth = element2.offsetWidth
                    const leftPosition = (parentWidth - childWidth);
                    console.log(leftPosition, 'leftPosition');
                    element.style.left = `${leftPosition - 2}px`
                    backPictures[imageSelectedIndexBack].left = leftPosition - 2
                }
            }
        }
    }
    const handleVerticalImagePosition = (position, shirtPosition) => {
        if (shirtPosition == 'front') {
            let element = document.getElementById(`front-${imageSelectedIndex}`)
            if (element) {
                if (position == 'top') {
                    element.style.top = '0px'
                    frontPictures[imageSelectedIndex].top = 0
                }
                if (position == 'center') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight) / 2
                    element.style.top = `${topPosition}px`
                    frontPictures[imageSelectedIndex].top = topPosition

                }
                if (position == 'bottom') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight)
                    element.style.top = `${topPosition}px`
                    frontPictures[imageSelectedIndex].top = topPosition
                }
            }
        }
        else {
            let element = document.getElementById(`back-${imageSelectedIndexBack}`)
            if (element) {
                if (position == 'top') {
                    element.style.top = '0px'
                    backPictures[imageSelectedIndexBack].top = 0
                }
                if (position == 'center') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf2')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight) / 2
                    element.style.top = `${topPosition}px`
                    backPictures[imageSelectedIndexBack].top = topPosition

                }
                if (position == 'bottom') {
                    let childHeight = element.offsetHeight
                    console.log(childHeight);
                    let element2 = document.getElementById('pdf2')
                    let parentHeight = element2.offsetHeight
                    let topPosition = (parentHeight - childHeight)
                    element.style.top = `${topPosition}px`
                    backPictures[imageSelectedIndexBack].top = topPosition
                }
            }
        }
    }

    function calculateTextDimensions(text, fontFamily, fontSize, fontWeight) {

        // Measure the text height
        // Create a temporary span element to measure height more accurately
        const span = document.createElement('span');
        span.style.fontFamily = fontFamily;
        span.style.fontSize = fontSize + 'px';
        span.style.fontWeight = fontWeight;
        span.style.position = 'absolute';
        span.style.visibility = 'hidden';
        span.textContent = text;

        // Append the span to the document
        document.body.appendChild(span);
        const textHeight = span.offsetHeight;
        const textWidth = span.offsetWidth;
        console.log(textHeight, textWidth, 'asdasd');


        //Remove the temporary span
        document.body.removeChild(span);

        return {
            width: textWidth,
            height: textHeight
        };
    }
    function calculateFontSizeToFit(text, fontFamily, maxWidth, maxHeight) {
        // Create a temporary span element
        const span = document.createElement('span');
        span.style.position = 'absolute';
        span.style.visibility = 'hidden';
        span.style.whiteSpace = 'nowrap'; // Prevent wrapping
        document.body.appendChild(span);

        let fontSize = 10; // Start with a small font size
        let fontSizeIncrement = 1; // Increment size

        function updateSpanStyle(fontSize) {
            span.style.fontFamily = fontFamily;
            span.style.fontSize = `${fontSize}px`;
            span.textContent = text;
        }

        while (true) {
            updateSpanStyle(fontSize);

            // Get the dimensions of the text
            const textWidth = span.offsetWidth;
            const textHeight = span.offsetHeight;

            if (textWidth > maxWidth || textHeight > maxHeight) {
                document.body.removeChild(span);
                console.log(fontSize - fontSizeIncrement, "sizehisize")

                return fontSize - fontSizeIncrement; // Return the largest size that fits
            }

            fontSize += fontSizeIncrement;
        }

    }
    useEffect(() => {
        const handleResize = () => {
            // Log device type
            if (isIPad13) {
                console.log("Device: iPad");
            } else if (isTablet) {
                console.log("Device: Tablet");
            } else {
                console.log("Device: Not a tablet");
            }

            // Update states based on window width
            const isTabletOrIPad = isIPad13 || isTablet;
            const threshold = isTabletOrIPad ? 1400 : 1000;

            if (window.innerWidth < threshold) {
                setIsLessThan1000px(true);
            } else {
                setIsLessThan1000px(false);
            }

            if (window.innerWidth <= 400) {
                setIsLessThan400(true);
                setIsLessThan1000px(false); // Ensures states don't conflict
            } else {
                setIsLessThan400(false);
            }
        };

        // Call once on initial render
        handleResize();

        // Attach event listener
        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isIPad13, isTablet]);


    async function autoCropBase64Image(base64Image) {
        return new Promise((resolve, reject) => {
            try {
                const img = new Image();
                img.src = base64Image;

                img.onload = function () {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    canvas.width = img.width;
                    canvas.height = img.height;

                    ctx.drawImage(img, 0, 0);

                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const data = imageData.data;

                    let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0;

                    for (let y = 0; y < canvas.height; y++) {
                        for (let x = 0; x < canvas.width; x++) {
                            const alpha = data[(y * canvas.width + x) * 4 + 3]; // Alpha channel
                            if (alpha > 0) {
                                if (x < minX) minX = x;
                                if (x > maxX) maxX = x;
                                if (y < minY) minY = y;
                                if (y > maxY) maxY = y;
                            }
                        }
                    }

                    const width = maxX - minX + 1;
                    const height = maxY - minY + 1;

                    const croppedCanvas = document.createElement("canvas");
                    const croppedCtx = croppedCanvas.getContext("2d");
                    croppedCanvas.width = width;
                    croppedCanvas.height = height;

                    croppedCtx.drawImage(
                        canvas,
                        minX, minY, width, height,
                        0, 0, width, height
                    );

                    const croppedBase64Image = croppedCanvas.toDataURL();
                    resolve({ croppedBase64Image, width, height });
                };

                img.onerror = function () {
                    reject("Failed to load the base64 image.");
                };
            } catch (error) {
                reject(error);
            }
        });
    }



    // Function to apply circular text shape
    const applyCircleShape = (textElement, radius) => {
        const characters = textElement.innerText.split('');
        const angleIncrement = 360 / characters.length;
        textElement.innerHTML = ''; // Clear existing content
        characters.forEach((char, index) => {
            const angle = angleIncrement * index;
            const x = radius * Math.cos(angle * Math.PI / 180);
            const y = radius * Math.sin(angle * Math.PI / 180);
            textElement.innerHTML += `<span style="position:absolute; transform: translate(${x}px, ${y}px) rotate(${angle}deg);">${char}</span>`;
        });
    };



    // Function to apply wave text shape
    const applyWaveShape = (textElement, amplitude, frequency) => {
        const characters = textElement.innerText.split('');
        textElement.innerHTML = ''; // Clear existing content
        characters.forEach((char, index) => {
            const y = amplitude * Math.sin(index * frequency);
            textElement.innerHTML += `<span style="position:relative; display:inline-block; transform: translateY(${y}px);">${char}</span>`;
        });
    };

    // Apply the selected shape to the text element
    const handleShapeApply = (index) => {
        const textElement = document.getElementById(`text${selectedIndex}`);
        if (textElement) {
            if (selectedShape === 'circle') {
                applyCircleShape(textElement, 50); // Example radius
            } else if (selectedShape === 'wave') {
                applyWaveShape(textElement, 10, 0.5); // Example amplitude and frequency
            }
            // Add more shape functions as needed
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setShowButton(window.innerWidth < 1320);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        const apiKey = 'AIzaSyCz36I7yOND3PvQXO6Nnl6TyJaZwiYvm1k'; // Replace with your actual API key
        const apiUrl = `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                setFonts(data.items);
                const filteredFonts = data.items.filter(font => desiredFonts.includes(font.family));
                setDisplayedFonts(filteredFonts);

                // Load the fonts explicitly using the FontFace API
                const fontPromises = filteredFonts.map(font => {
                    const fontFace = new FontFace(font.family, `url(${font.files.regular})`);
                    return fontFace.load().then(loadedFont => {
                        document.fonts.add(loadedFont);
                    });
                });

                // Wait for all fonts to be loaded
                Promise.all(fontPromises).then(() => {
                    console.log('All fonts loaded');
                }).catch(error => {
                    console.error('Error loading fonts:', error);
                });
            })
            .catch(error => {
                console.error('Error fetching fonts:', error);
            });
    }, [])

    useEffect(() => {
        const pdfElement = document.getElementById('pdf');
        if (pdfElement) {
            pdfElement.style.display = 'none';
            setTimeout(() => {
                pdfElement.style.display = 'block';
            }, 1000);
        }
        setTextState(false)
    }, [rotateDirection]);
    useEffect(() => {
        let data = localStorage.getItem('designArray')
        let gallery = localStorage.getItem('gallery')
        console.log(gallery);
        if (gallery) {

            gallery = JSON.parse(gallery)
            setGalleryPictures(gallery)
        }

        if (data) {
            data = JSON.parse(data)
            setTextArray(data?.frontText)
            setTextBackArray(data?.backText)
            setFrontPictures(
                data?.frontPic?.map(item => ({
                    ...item,
                    zIndexes: item.zIndexes !== undefined ? item.zIndexes : 1,
                })) || []
            );

            setBackPictures(
                data?.backPic?.map(item => ({
                    ...item,
                    zIndexes: item.zIndexes !== undefined ? item.zIndexes : 1,
                })) || []
            );

            setSelectedTshirt(data?.color)

        }
        console.log(data, 'data');

    }, [])
    useEffect(() => {
        if (textArray.length == 0 || textBackArray.length == 0) {
            setEditNav(false)
            setSimpleNav(true)
        }



    }, [textArray, textBackArray])

    useEffect(() => {
        if (frontPictures.length == 0 || backPictures.length == 0) {
            setImageEdit(false)
            setSimpleNav(true)
        }

    }, [frontPictures, backPictures])
    useEffect(() => {
        if (simpleNav) {
            setEditNav(false);
            setImageEdit(false);
        } else if (editNav) {
            setSimpleNav(false);
            setImageEdit(false);
        } else if (imageEdit) {
            setSimpleNav(false);
            setEditNav(false);
        }
    }, [simpleNav, editNav, imageEdit]);
    const [isLandscape, setIsLandscape] = useState(false);

    const handleOrientationChange = () => {
        // if (isMobile) {

        //     setIsLandscape(window.innerWidth > window.innerHeight);

        // }
        // else {
        //     setIsLandscape(false);
        // }
    };

    useEffect(() => {
        console.log(isMobile || isTablet);

        if (isMobile) {

            // Add event listener to detect screen size changes
            window.addEventListener("resize", handleOrientationChange);
            handleOrientationChange(); // Initial check on load

            // Clean up the event listener on component unmount
            return () => {
                window.removeEventListener("resize", handleOrientationChange);
            };
        }
        console.log(document.getElementsByClassName('widget-visible'), 'iframe');
        let elements = document.getElementsByClassName('widget-visible');
        for (let i = 0; i < elements.length; i++) {
            elements[i].remove();
        }
        const iframes = document.getElementsByName('iframe');
        console.log(iframes, 'iframe');

        if (iframes.length > 0) {
            for (let i = 0; i < iframes.length; i++) {
                iframes[i].style.visibility = 'hidden !important';
            }
        } else {
            console.warn("No elements with name 'iframe' found.");
        }
    }, []);
    useEffect(() => {
        const handleTouchMove = (event) => {
            event.preventDefault();
        };

        // Select all elements with the class 'no-scroll'
        const elements = document.querySelectorAll('.no-scroll');

        // Attach event listener to each element
        elements.forEach((element) => {
            element.addEventListener('touchmove', handleTouchMove, { passive: false });
        });

        // Cleanup event listeners on component unmount
        return () => {
            elements.forEach((element) => {
                element.removeEventListener('touchmove', handleTouchMove);
            });
        };
    }, []);

    useEffect(() => {
        getPricing()
        // if(design){
        //     console.log(design,'design')
        //     setFrontPictures(imageUrl?.frontPic)
        //     setBackPictures(imageUrl?.backPic)
        //     setTextArray(imageUrl?.frontText)
        //     setTextBackArray(imageUrl?.backT)

        // }
    }, [])

    const canvasRef = useRef(null);
    const [curve, setCurve] = useState(110);
    const [offsetY, setOffsetY] = useState(4);
    const [textHeight, setTextHeight] = useState(64);
    const [bottom, setBottom] = useState(200);
    const [isTriangle, setIsTriangle] = useState(false);
    const [text, setText] = useState("Print Me Up");
    const generateCurvedTextCanvas = async (
        text,
        curve,
        offsetY,
        textHeight,
        bottom,
        isTriangle,
        width,
        height,
        color,
        fontName,
        item,
        bold,
        italic,
        underline
    ) => {
        console.log(item.value, 'color.hex');
        if (item.value == 'shape0') {
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            // Adjust dimensions based on font
            if (fontName === "Bebas Neue") {
                desiredWidth = width - 20;
                desiredHeight = height;
            } else if (fontName === "Righteous") {
                desiredWidth = width - 5;
                desiredHeight = height - 10;
            } else if (fontName === "Bebas Neue" || fontName === "Bungee Shade") {
                desiredWidth = width;
                desiredHeight = height;
            } else {
                desiredWidth = width;
                desiredHeight = height;
            }
            desiredWidth = width;
            desiredHeight = height;
            if (fontName === "Playfair Display") {
                desiredWidth = width;
                desiredHeight = height + 10;
            } else if (fontName === "Righteous") {
                desiredHeight = height + 10;
            } else if (fontName === "Barlow Condensed") {
                desiredHeight = height + 10;
            }
            if (item?.value === 'shape3') {
                desiredWidth = width + 40;
                desiredHeight = 104;
            }
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            console.log(fontName, "fontName");
            // Set up font and fill text
            let font = (isIOS || isIOS13) ? `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}40px ${fontName || "Bebas Neue"}` : `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}55px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset
            if (isIOS || isIOS13) {
                yOffset = -10;
                if (fontName === "Archivo Black") {
                    yOffset = -8;
                }
            } else {
                yOffset = 10 / scale;
                if (fontName === "Monoton") {
                    yOffset = 10;
                }
            }
            if (fontName === "Bebas Neue") {
                yOffset = 15 / scale;
                xOffset = width * 0.45;
            } else {
                xOffset = width * 0.45;
            }
            // Draw text
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                const underlineY = yOffset + (isIOS || isIOS13 ? 40 : 55) + 2;
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 2;
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let dltY = curve / textHeight;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    textHeight,
                    i,
                    height * Newheight - (offsetY / textHeight) * y,
                    1,
                    y
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            return base64;
        } else if (item.value == 'shape1') {
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            desiredWidth = width;
            desiredHeight = height;
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            // alert(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}64px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset;
            if (isIOS || isIOS13) {
                yOffset = -14;
                // alert(fontName,'dddd')
                if (fontName === "Archivo Black") {
                    yOffset = 5;
                }
            } else {
                yOffset = 10 / scale;
                if (fontName === "Monoton") {
                    yOffset = 20;
                }
            }
            xOffset = width * 0.5;
            if (smallFonts.includes(fontName)) {
                yOffset = 0;
                xOffset = width * 0.5;
                if (isIOS || isIOS13) {
                    yOffset = -15;
                }
            }
            // Draw text
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                const underlineY = yOffset + 64 + 2;
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 2;
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let dltY = curve / textHeight + 20;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    textHeight + 20,
                    i,
                    height * Newheight - (offsetY / textHeight) * y,
                    1,
                    y
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            return base64;
        } else if (item.value == 'shape2') {
            console.log(text, curve, offsetY, textHeight, bottom, width, height, color, fontName, item, 'itemitem');
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            desiredWidth = width;
            desiredHeight = height;
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            // alert(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}64px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset = 0;
            xOffset = width * 0.5;
            if (isIOS || isIOS13) {
                yOffset = -17;
                if (fontName == 'Bebas Neue') {
                    yOffset = -10;
                }
                if (fontName === "Archivo Black") {
                    yOffset = -8;
                }
            } else {
                yOffset = 0;
                if (fontName === "Monoton") {
                    yOffset = 5;
                }
            }
            if (smallFonts.includes(fontName)) {
                yOffset = 0;
                if (isIOS || isIOS13) {
                    yOffset = -15;
                }
            }
            // Draw text
            // Render text
            octx.clearRect(0, 0, os.width, os.height);
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                const underlineY = yOffset + 64 + 2;
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 2;
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let dltY = curve / textHeight + 35;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    textHeight + 35,
                    i,
                    height * 0.5 - (offsetY / textHeight) * y,
                    1,
                    y
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            console.log(canvasImage, 'canvasImage');
            return base64;
        } else if (item.value == 'shape3') {
            console.log(text, curve, offsetY, textHeight, bottom, width, height, color, fontName, item, 'itemitem');
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            desiredWidth = width;
            desiredHeight = height;
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            console.log(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}40px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset
            if (isIOS || isIOS13) {
                yOffset = 7;
                if (fontName == 'Bebas Neue') {
                    yOffset = 7;
                }
            } else {
                yOffset = 12;
                if (fontName === "Monoton") {
                    yOffset = 15;
                }
            }
            if (smallFonts.includes(fontName)) {
                yOffset = 12;
                if (isIOS || isIOS13) {
                    yOffset = 12;
                }
            }
            xOffset = width * 0.5;
            // Draw text
            // Render text
            octx.clearRect(0, 0, os.width, os.height);
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                const underlineY = yOffset + 40 + 2;
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 2;
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let dltY = curve / textHeight + 50;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    textHeight + 50,
                    i,
                    height * 0.5 - (offsetY / textHeight) * y,
                    1,
                    y
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            console.log(canvasImage, 'canvasImage');
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(canvasImage, 'canvasImage');
            return base64;
        } else if (item.value == 'shape4') {
            console.log(text, curve, offsetY, textHeight, bottom, width, height, color, fontName, item, 'itemitem');
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            desiredWidth = width;
            desiredHeight = height;
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            console.log(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}64px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset
            xOffset = width * 0.5;
            // if (fontName === "Bebas Neue") {
            //   yOffset = 15 / scale;
            //   xOffset = width * 0.5;
            // } else {
            //   xOffset = width * 0.5;
            // }
            if (isIOS || isIOS13) {
                yOffset = -17;
                if (fontName == 'Bebas Neue') {
                    yOffset = 0;
                }
                if (fontName === "Archivo Black") {
                    yOffset = 0;
                }
            } else {
                yOffset = 0;
                if (fontName === "Monoton") {
                    yOffset = 5; 
                }
            }
            if (smallFonts.includes(fontName)) {
                yOffset = -3;
                if (fontName == 'Playfair Display') {
                    yOffset = -3.2;
                }
                if (fontName == 'Nunito') {
                    yOffset = 0;
                }
                if (isIOS || isIOS13) {
                    
                    yOffset = -18;
                    if (fontName == 'Playfair Display') {
                        yOffset = -21;
                    }
                }
            }
            // Draw text
            // Render text
            octx.clearRect(0, 0, os.width, os.height);
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                let underlineY
                if (isIOS || isIOS13) {
                    underlineY = yOffset + 55 + 5; // Increased offset for better visibility
                }
                else {
                    underlineY = yOffset + 50 + 5; // Increased offset for better visibility
                }
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 3; // Slightly thicker line for 64px font
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let heightNew = smallFonts.includes(fontName) ? textHeight + 2 : textHeight
            let dltY = curve / heightNew;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    heightNew,
                    i,
                    height * 0.5 - (offsetY / textHeight) * y,
                    1,
                    y
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            return base64;
        } else if (item.value == 'shape5') {
            console.log(text, curve, offsetY, textHeight, bottom, width, height, color, fontName, item, 'itemitem');
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            desiredWidth = width;
            desiredHeight = height;
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            console.log(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}64px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset
            if (fontName === "Bebas Neue") {
                yOffset = 15 / scale;
                xOffset = width * 0.5;
            }
            if (isIOS || isIOS13) {
                yOffset = -17;
                xOffset = width * 0.5;
                if (fontName == 'Bebas Neue') {
                    yOffset = -5;
                }
                if (fontName == 'Monoton') {
                    yOffset = -20;
                }
                if (fontName === "Archivo Black") {
                    yOffset = -10;
                }
            } else {
                xOffset = width * 0.5;
                yOffset = 0;
                if (fontName == 'Monoton') {
                    yOffset = 6;
                }
            }
            if (smallFonts.includes(fontName)) {
                xOffset = width * 0.5;
                yOffset = -2;
                if (isIOS || isIOS13) {
                    yOffset = -20;
                }
            }
            // Draw text
            // Render text
            octx.clearRect(0, 0, os.width, os.height);
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                let underlineY
                if (isIOS || isIOS13) {
                    underlineY = yOffset + 50 + 5; // Increased offset for better visibility
                    if (fontName.toLowerCase() == 'black ops one') {
                        underlineY = yOffset + 55 + 5; // Increased offset for better visibility
                    }
                }
                else {
                    underlineY = yOffset + 45 + 5; // Increased offset for better visibility
                }
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 3; // Slightly thicker line for 64px font
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let heightNew = smallFonts.includes(fontName) ? textHeight + 40 : textHeight
            if (fontName == 'Monoton') {
                heightNew = textHeight + 15;
            }
            let dltY = curve / heightNew;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    heightNew,
                    i,
                    height * 0.5 - (offsetY / textHeight) * y + 1,
                    1,
                    y * 0.35
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            return base64;
        } else if (item.value == 'shape6') {
            console.log(text, curve, offsetY, textHeight, bottom, width, height, color, fontName, item, 'itemitem');
            // Validate inputs
            if (!text || !fontName || !width || !height) {
                console.error("Invalid input parameters");
                return null;
            }
            console.log(item, 'widthcheck');
            let desiredWidth, desiredHeight;
            // Adjust dimensions based on font
            if (fontName === "Bebas Neue") {
                desiredWidth = width;
                desiredHeight = height;
            } else if (fontName === "Righteous") {
                desiredWidth = width - 5;
                desiredHeight = height - 10;
            } else if (fontName === "Bebas Neue" || fontName === "Bungee Shade") {
                desiredWidth = width;
                desiredHeight = height;
            } else {
                desiredWidth = width;
                desiredHeight = height;
            }
            desiredWidth = width;
            desiredHeight = height;
            if (fontName === "Playfair Display") {
                desiredWidth = width;
                desiredHeight = height + 10;
            } else if (fontName === "Righteous") {
                desiredHeight = height + 10;
            } else if (fontName === "Barlow Condensed") {
                desiredHeight = height + 10;
            }
            if (item?.value === 'shape3') {
                desiredWidth = width + 40;
                desiredHeight = 104;
            }
            // Scale factor to increase resolution
            const scale = 3; // Increase for higher resolution
            desiredWidth *= scale;
            desiredHeight *= scale;
            textHeight *= scale;
            // Create the main canvas
            const canvas = document.createElement("canvas");
            canvas.width = desiredWidth;
            canvas.height = desiredHeight;
            const ctx = canvas.getContext("2d");
            // Apply scaling to the context
            ctx.scale(scale, scale);
            // Create an offscreen canvas
            const os = document.createElement("canvas");
            os.width = desiredWidth;
            os.height = desiredHeight;
            const octx = os.getContext("2d");
            octx.scale(scale, scale);
            console.log(fontName, "fontName");
            // Set up font and fill text
            let font = `${italic ? 'italic ' : ''}${bold ? 'bold ' : ''}64px ${fontName || "Bebas Neue"}`;
            octx.font = font;
            octx.fillStyle = color;
            octx.textBaseline = "top";
            octx.textAlign = "center";
            // Handle text rendering based on font
            let xOffset;
            let yOffset;
            if (fontName === "Bebas Neue") {
                yOffset = 15 / scale;
                xOffset = width * 0.5;
            }
            if (isIOS || isIOS13) {
                xOffset = width * 0.5;
                yOffset = -16;
                if (fontName == 'Bebas Neue') {
                    yOffset = 0;
                }
                if (fontName === "Archivo Black") {
                    yOffset = 0;
                }
            } else {
                xOffset = width * 0.5;
                yOffset = 0;
                if (fontName === "Monoton") {
                    yOffset = 10;
                }
            }
            if (smallFonts.includes(fontName)) {
                xOffset = width * 0.5;
                yOffset = 0;
                if (isIOS || isIOS13) {
                    yOffset = -15;
                }
            }
            // Draw text
            // Render text
            octx.clearRect(0, 0, os.width, os.height);
            let newText = smallFonts.includes(fontName) ? text : text.toUpperCase()
            octx.fillText(newText, xOffset, yOffset);

            // Draw underline if needed
            if (underline) {
                const textMetrics = octx.measureText(newText);
                const textWidth = textMetrics.width;
                const underlineY = yOffset + 64 + 2;
                octx.beginPath();
                octx.moveTo(xOffset - textWidth / 2, underlineY);
                octx.lineTo(xOffset + textWidth / 2, underlineY);
                octx.strokeStyle = color;
                octx.lineWidth = 2;
                octx.stroke();
            }

            // Debug: Check if the text was rendered
            if (octx.measureText(text).width === 0) {
                console.error("Text rendering failed. Check font loading or input parameters.");
                return null;
            }
            // Adjust height for shapes
            let Newheight = item?.value === "shape1" ? 0.1 : item?.value === "shape3" ? 0.5 : 0.2;
            const angleSteps = 180 / width;
            let i = width;
            let y = 0;
            let dltY = curve / textHeight + 50;
            // Render curved text
            while (i--) {
                if (isTriangle) {
                    y += dltY;
                    if (i === Math.floor(width * 0.5)) dltY = -dltY;
                } else {
                    y = bottom - curve * Math.sin((i * angleSteps * Math.PI) / 180);
                }
                ctx.drawImage(
                    os,
                    i * scale,
                    0,
                    1 * scale,
                    textHeight + 50,
                    i,
                    height * 0.5 - (offsetY / textHeight) * y,
                    1,
                    y * 0.3
                );
            }
            let canvasImage = canvas.toDataURL("image/png")
            console.log(canvasImage, 'canvasImage');
            let base64 = await autoCropBase64Image(canvasImage)
            console.log(base64, 'crooped');
            return base64;
        }
    };


    useEffect(() => {
        getLibrary()
    }, [])

    useEffect(() => {
        setSelectedShape({ shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false })

    }, [rotateDirection])



    // useEffect(() => {
    //   const canvas = canvasRef.current;
    //   const ctx = canvas?.getContext("2d");

    //   const font = "35px Bebas Neue";
    //   const w = canvas.width;
    //   const h = canvas.height;

    //   const os = document.createElement("canvas");
    //   os.width = w;
    //   os.height = h;
    //   const octx = os.getContext("2d");

    //   octx.font = font;
    //   octx.textBaseline = "top";
    //   octx.textAlign = "center";

    //   octx.clearRect(0, 0, w, h);
    //   ctx.clearRect(0, 0, w, h);

    //   octx.fillText(text.toUpperCase(), w * 0.5, 0);

    //   const angleSteps = 180 / w;
    //   let i = w;
    //   let y = 0;
    //   let dltY = curve / textHeight;

    //   while (i--) {
    //     if (isTriangle) {
    //       y += dltY;
    //       if (i === Math.floor(w * 0.5)) dltY = -dltY;
    //     } else {
    //       y = bottom - curve * Math.sin(i * angleSteps * Math.PI / 180);
    //     }
    //     ctx.drawImage(os, i, 0, 1, textHeight, i, h * 0.5 - (offsetY / textHeight) * y, 1, y);
    //   }
    //   var base64Image = canvas.toDataURL('image/png');
    // console.log(base64Image);
    // }, [curve, offsetY, textHeight, bottom, isTriangle, text]);
    return (
        <>
 <Helmet>
        <title>Design Tool | Print Me Up</title>
        <meta
          name="description"
          content="Use Print Me Up's AI-powered design tool to create stunning, personalized t-shirt designs. Customize fonts, colors, and graphics instantly."
        />
        <meta
          name="keywords"
          content="design tool, t-shirt designer, AI t-shirt generator, custom t-shirt, print me up design, t-shirt customization"
        />
        <link rel="canonical" href="https://pk.printmeup.ai/product-final" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Design Tool | Print Me Up" />
        <meta
          property="og:description"
          content="Design your own t-shirt using Print Me Up’s AI-powered design tool. Create, customize, and print your style in minutes!"
        />
        <meta
          property="og:image"
          content="https://pk.printmeup.ai/images/share-design-tool.jpg"
        />
        <meta
          property="og:url"
          content="https://pk.printmeup.ai/product-final"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Print Me Up" />

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Design Tool | Print Me Up" />
        <meta
          name="twitter:description"
          content="Bring your ideas to life with Print Me Up’s design tool. Customize your t-shirt in real-time with AI and creative freedom."
        />
        <meta
          name="twitter:image"
          content="https://pk.printmeup.ai/images/share-design-tool.jpg"
        />
        <meta name="twitter:site" content="@PrintMeUp" />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Design Tool | Print Me Up",
            "url": "https://pk.printmeup.ai/product-final",
            "applicationCategory": "DesignApplication",
            "operatingSystem": "All",
            "description":
              "An online AI-powered t-shirt design tool by Print Me Up that allows users to create and customize t-shirt designs with ease.",
            "creator": {
              "@type": "Organization",
              "name": "Print Me Up",
              "url": "https://pk.printmeup.ai/",
              "logo":
                "https://pk.printmeup.ai/static/media/mainlogo.615e917be0574c945659.png",
            },
          })}
        </script>
      </Helmet>
            <Grid sx={{ height: isLessThan1000px || isLessThan400 ? '' : '' }}>
                {/* ========== Confirmation Dialog ========== */}
                <ConfirmationDialog2
                    open={confirmationDialog}
                    overwrite={localStorage.getItem('saveDesign') ? true : false}
                    existingValue={savedDesign?.name}
                    onClose={() => setConfirmationDialog(false)}
                    message={"Secure Your Design Journey"}
                    action={handleDialogAction}
                    action2={handleDialogActionNew}
                />

                <ConfirmationDialog
                    open={confirmationDialog2}
                    onClose={() => setConfirmationDialog2(false)}
                    singleButton={true}
                    message={"Proceed To Checkout"}
                    action={handleDialogAction2}
                />
                <ConfirmationDialog
                    open={confirmationDialog3}
                    onClose={() => setConfirmationDialog3(false)}
                    singleButton={true}
                    sx={{
                        '& .MuiDialog-paper': {
                            width: { lg: '400px !important', md: '400px', sm: '400px', xs: '90%' },
                            height: { lg: '130px !important', md: '130px', sm: '130px', xs: '160px' },
                            borderRadius: 2,
                            py: { lg: 4, md: 4, sm: 2, xs: 2 },
                            px: 5,
                            backgroundColor: '#0F172A'
                        },
                    }}
                    Input={false}
                    message={"You have unsaved changes. Are you sure you want to leave without saving?"}
                    action={handleDialogAction3}
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#07141d', height: '10.6vh' }} >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%', margin: '0 auto' }}>

                        <Box>
                            <Box onClick={() => setConfirmationDialog3(true)} component={'img'} sx={{ cursor: "pointer" }} src={Images.mainlogo} width={'150px'} ></Box>
                        </Box>
                        <Box>
                            <Grid
                                container
                                justifyContent="flex-end"
                                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                            >
                                {isSmallScreen ? (
                                    <>
                                        {/* IconButton for small screens */}
                                        <IconButton
                                            onClick={() => {
                                                localStorage.setItem('designArray', JSON.stringify({
                                                    frontText: textArray,
                                                    backText: textBackArray,
                                                    frontPic: frontPictures,
                                                    backPic: backPictures,
                                                    color: selectedTshirt
                                                }));
                                                localStorage.setItem('gallery', JSON.stringify(galleryPictures));
                                                setConfirmationDialog(true);
                                            }}
                                            sx={{
                                                background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
                                                margin: '10px',
                                                color: '#0C1427'
                                            }}
                                        >
                                            <SaveIcon />
                                        </IconButton>

                                        <IconButton
                                            onClick={() => {
                                                if (localStorage.getItem('saveDesign')) {
                                                    let data = JSON.parse(localStorage.getItem('saveDesign'));
                                                    handleDialogAction2(data?.name, data?._id);

                                                } else {
                                                    setConfirmationDialog2(true);
                                                }
                                            }}
                                            sx={{
                                                background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)',
                                                margin: '10px',
                                                color: '#0C1427'
                                            }}
                                        >
                                            <ShoppingCartIcon />
                                        </IconButton>
                                    </>
                                ) : (
                                    <>
                                        {/* SecondaryButton for medium and large screens */}
                                        <SecondaryButton
                                            onClick={() => {
                                                localStorage.setItem('designArray', JSON.stringify({
                                                    frontText: textArray,
                                                    backText: textBackArray,
                                                    frontPic: frontPictures,
                                                    backPic: backPictures,
                                                    color: selectedTshirt
                                                }));

                                                localStorage.setItem('gallery', JSON.stringify(galleryPictures));
                                                setConfirmationDialog(true);
                                            }}
                                            className="checkout-btn"
                                            iconPosition="end"
                                            m="20px"
                                            p="10px 20px"
                                            fontWeight={600}
                                            color="#0C1427"
                                            sx={{ background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", ml: '0px !important' }}
                                            title="Save Design"
                                        />

                                        <SecondaryButton
                                            onClick={() => {
                                                if (localStorage.getItem('saveDesign')) {
                                                    let data = JSON.parse(localStorage.getItem('saveDesign'));
                                                    handleDialogAction2(data?.name, data?._id);

                                                } else {
                                                    setConfirmationDialog2(true);
                                                }
                                            }}
                                            className="checkout-btn"
                                            iconPosition="end"
                                            m="20px"
                                            p="10px 20px"
                                            fontWeight={600}
                                            color="#0C1427"
                                            sx={{ background: 'linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)', ml: '5px !important' }}
                                            title="Proceed To Checkout"
                                        />
                                    </>
                                )}
                            </Grid>
                        </Box>
                    </Box>

                </Box>

                <Drawer
                    anchor="bottom"
                    open={editDrawer}
                    className='custom-scrollbar'
                    onClose={() => setEditDrawer(false)}
                    sx={{
                        '& .MuiDrawer-paper': {
                            borderTopLeftRadius: '20px', // Adjust the border radius value as needed
                            borderTopRightRadius: '20px',
                            height: editModalState == 'fontFamily' ? '40%' : 'auto',
                            backgroundColor: '#0F172A'
                        },
                    }}

                >
                    {editModalState == 'Color' && <Box sx={{ margin: '10px auto', p: 2 }}>
                        <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mt: 2, mb: 2 }}> Color</InputLabel>
                        <div className="blockpicker" style={{ textAlign: 'left' }}>
                            <CirclePicker colors={colors} disableAlpha={true} editableDisable={true} color={blockPickerColor} onChange={(color) => {
                                console.log(color.hex, 'color.hex');
                                handleTextColor(color.hex);


                                setBlockPickerColor(color.hex);
                            }} />
                        </div>
                    </Box>}
                    {editModalState == 'fontFamily' &&
                        <Box >
                            <div onTouchStart={() => setSelectedElement(null)} onMouseDown={() => setSelectedElement(null)} onTouchMove={() => setSelectedElement(null)} onClick={() => setSelectedElement(null)} className='no-scrol' style={{ marginTop: '20px', padding: 5 }}>
                                {/* <InputLabel sx={{ color: 'black', fontWeight: '500', textAlign: 'left', fontFamily: 'Poppins, sans-serif', mt: 3.5 }}>Font Weight</InputLabel>
                            <Slider
                                aria-label="Font Weight"
                                value={fontWeight}
                                onChange={handleWeightChange}
                                color='#0F172A'
                                valueLabelDisplay="auto"
                                step={100}
                                marks
                                min={100}
                                max={900}
                            /> */}
                                {/* <InputLabel sx={{ color: 'black', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Poppins, sans-serif' }}>Font Size</InputLabel>
                            <Grid container justifyContent={"center"} xs={12} mt={'2%'}>
                                <Slider
                                    value={parseInt(fontSize)}
                                    defaultValue={fontSize}
                                    valueLabelDisplay="on"
                                    onChange={handleFontSizeChange}
                                    color='#0F172A'
                                    sx={{ fontFamily: 'Poppins, sans-serif' }}
                                    aria-label="Font Size"
                                />
                            </Grid> */}
                                <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', paddingLeft: '5px', mb: 2 }}>Font Family</InputLabel>
                                <div>
                                    <div className="dropdown-container">

                                        {true && (

                                            <div ref={containerRef}  >
                                                <Grid container spacing={2}>
                                                    {displayedFonts.map((font) => {
                                                        loadFont(font.family);
                                                        return (
                                                            <Grid item xs={6} >
                                                                <div
                                                                    key={font.family}
                                                                    style={{ fontFamily: font.family, cursor: 'pointer', padding: '10px', border: selectedFont == font.family ? '3px solid #0BD1D1' : '3px solid white', borderRadius: '8px', textAlign: 'center', color: selectedFont == font.family ? '#0BD1D1' : 'white' }}
                                                                    onClick={() => handleFontClick(font.family)}
                                                                >
                                                                    {font.family == 'Black Ops One' || font.family == 'Audiowide' ? font?.family?.toUpperCase() : font.family}
                                                                </div>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>
                                                {loading && <div>Loading more fonts...</div>}
                                            </div>

                                        )}
                                    </div>

                                </div>
                            </div>
                        </Box>}
                    {editModalState == 'editText' &&
                        <>
                            <Box sx={{ p: 3 }}>
                                <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>{textState == 'edit' ? 'Edit Text' : 'Add Text'}</InputLabel>
                                <TextField
                                    fullWidth={true}

                                    size='small'
                                    InputProps={{
                                        style: {
                                            fontSize: `${16}px`,
                                            color: "white", fontFamily: 'Maven Pro, sans-serif',
                                            border: '1px solid white',
                                            textAlign: 'center'
                                        }
                                    }}
                                    {...register("tshirtText", {
                                        required: true,
                                        onChange: (e) => {
                                            console.log(e.target.value.length);

                                            if (e.target.value.length > 25) {
                                                setTextLength(true)
                                            }
                                            else {
                                                setTextLength(false)
                                            }
                                        }
                                    })}


                                />
                                {textLength && <span style={{ color: 'red', fontSize: '12px' }}>Text cannot exceed 25 characters</span>}
                                {textState == 'edit' &&
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                        <Button
                                            disabled={textLength}
                                            onClick={() => handleInputChange()}
                                            sx={{
                                                textAlign: 'center',
                                                background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',
                                                borderRadius: '15px',
                                                textTransform: 'capitalize',
                                                mt: 2

                                            }}
                                        >
                                            Update
                                        </Button>
                                    </Box>
                                }

                            </Box>
                            <Box>
                                {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '50%', margin: '0 auto' }}>
                                    <Button type='submit' fullWidth sx={{
                                        backgroundColor: '#0F172A', fontWeight: 'bold', color: 'white', padding: '10px 25px', '&:hover': {
                                            backgroundColor: 'white',
                                            color: '#0F172A',
                                            border: '2px solid #0F172A'
                                        },
                                        border: '2px solid transparent'
                                    }}
                                        onClick={() => { setEditNav(false); setEditDrawer(false) }}>
                                        Save
                                    </Button>
                                </Box> */}
                            </Box>
                        </>}
                    {editModalState == 'Alignment' &&
                        <Box sx={{ p: 4 }}>
                            <Box>

                                <Grid container spacing={2} alignItems={'flex-end'}>

                                    <Grid item lg={12} md={12}>
                                        <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Text Alignments</InputLabel>
                                        <Box>

                                            <Box sx={{ display: 'flex', gap: 2 }}>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('left', rotateDirection ? 'back' : 'front')}><FormatAlignLeftIcon sx={{ color: 'white' }} /></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('center', rotateDirection ? 'back' : 'front')}><FormatAlignJustifyIcon sx={{ color: 'white' }} /></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('right', rotateDirection ? 'back' : 'front')}><FormatAlignRightIcon sx={{ color: 'white' }} /></Button>



                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={12} md={12}>
                                        <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Alignment Top - Bottom</InputLabel>
                                        <Box>

                                            <Box sx={{ display: 'flex', gap: 2 }}>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('top', rotateDirection ? 'back' : 'front')}><VerticalAlignTopIcon sx={{ color: 'white' }} /></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('center', rotateDirection ? 'back' : 'front')} ><VerticalAlignCenterIcon sx={{ color: 'white' }} /></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('bottom', rotateDirection ? 'back' : 'front')}><VerticalAlignBottomIcon sx={{ color: 'white' }} /></Button>



                                            </Box>

                                        </Box>
                                    </Grid>
                                </Grid>



                            </Box>
                        </Box>}
                    {editModalState == 'Shapes' &&
                        <Box sx={{ p: 4 }}>
                            {/* NEW: Text Formatting Section */}
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mt: 2, mb: 2, fontFamily: 'Maven Pro, sans-serif' }}>Text Formatting</InputLabel>
                                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        <Button
                                            sx={{
                                                border: '1px solid white',
                                                padding: '8px 12px',
                                                minWidth: '45px !important',
                                                backgroundColor: isBold ? '#0BD1D1' : 'transparent',
                                                color: isBold ? '#0F172A' : 'white',
                                                '&:hover': {
                                                    backgroundColor: isBold ? '#0BD1D1' : '#1E293B',
                                                }
                                            }}
                                            onClick={() => {
                                                setIsBold(!isBold);
                                                if (textState === 'edit') {
                                                    if (!rotateDirection) {
                                                        textArray[selectedIndex].isBold = !isBold;
                                                        updateTextWithFormatting();
                                                    } else {
                                                        textBackArray[selectedIndexBack].isBold = !isBold;
                                                        updateTextWithFormatting();
                                                    }
                                                }
                                            }}
                                        >
                                            <FormatBoldIcon />
                                        </Button>
                                        <Button
                                            sx={{
                                                border: '1px solid white',
                                                padding: '8px 12px',
                                                minWidth: '45px !important',
                                                backgroundColor: isItalic ? '#0BD1D1' : 'transparent',
                                                color: isItalic ? '#0F172A' : 'white',
                                                '&:hover': {
                                                    backgroundColor: isItalic ? '#0BD1D1' : '#1E293B',
                                                }
                                            }}
                                            onClick={() => {
                                                setIsItalic(!isItalic);
                                                if (textState === 'edit') {
                                                    if (!rotateDirection) {
                                                        textArray[selectedIndex].isItalic = !isItalic;
                                                        updateTextWithFormatting();
                                                    } else {
                                                        textBackArray[selectedIndexBack].isItalic = !isItalic;
                                                        updateTextWithFormatting();
                                                    }
                                                }
                                            }}
                                        >
                                            <FormatItalicIcon />
                                        </Button>
                                        <Button
                                            sx={{
                                                border: '1px solid white',
                                                padding: '8px 12px',
                                                minWidth: '45px !important',
                                                backgroundColor: isUnderline ? '#0BD1D1' : 'transparent',
                                                color: isUnderline ? '#0F172A' : 'white',
                                                '&:hover': {
                                                    backgroundColor: isUnderline ? '#0BD1D1' : '#1E293B',
                                                }
                                            }}
                                            onClick={() => {
                                                setIsUnderline(!isUnderline);
                                                if (textState === 'edit') {
                                                    if (!rotateDirection) {
                                                        textArray[selectedIndex].isUnderline = !isUnderline;
                                                        updateTextWithFormatting();
                                                    } else {
                                                        textBackArray[selectedIndexBack].isUnderline = !isUnderline;
                                                        updateTextWithFormatting();
                                                    }
                                                }
                                            }}
                                        >
                                            <FormatUnderlinedIcon />
                                        </Button>
                                    </Box>
                                    <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                </Grid>
                            </Grid>
                            {/* END: Text Formatting Section */}
                            <Box>

                                <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Text Shapes</InputLabel>

                                <Box sx={{ display: 'flex', mb: 2, mt: 2, flexWrap: 'wrap', gap: 1 }}>

                                    {[
                                        { shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false },
                                        { shape: 'above', value: 'shape1', curve: 120, offSetY: 5, height: 80, bottom: 180, triangle: false },
                                        { shape: 'down', value: 'shape2', curve: -120, offSetY: 50, height: 60, bottom: 0, triangle: false },
                                        { shape: 'triangle', value: 'shape3', curve: 200, offSetY: 40, height: 60, bottom: 0, triangle: false },
                                        { shape: 'triangle', value: 'shape4', curve: 140, offSetY: 50, height: 60, bottom: 0, triangle: true },
                                        { shape: 'triangle', value: 'shape5', curve: 180, offSetY: 50, height: 50, bottom: 0, triangle: true },
                                        { shape: 'triangle', value: 'shape6', curve: 350, offSetY: 50, height: 60, bottom: 0, triangle: false },

                                    ].map((item, index) => (
                                        <Box

                                            width={'28%'}
                                            height={'60px'}

                                            key={index}
                                            onClick={async () => {
                                                setSelectedShape(item);

                                                if (!rotateDirection) {
                                                    try {
                                                        console.log(textArray[selectedIndex], 'textarrararar');
                                                        let oldWidth = textArray[selectedIndex].width;
                                                        let oldHeight = textArray[selectedIndex].height;

                                                        let size = await calculateTextDimensions(
                                                            getValues('tshirtText'),
                                                            textArray[selectedIndex].font,
                                                            '35',
                                                            600
                                                        );
                                                        console.log(size, 'sizesize');

                                                        let url = await generateCurvedTextCanvas(
                                                            getValues('tshirtText'),
                                                            item.curve,
                                                            item.offSetY,
                                                            item.height,
                                                            item.bottom,
                                                            item?.triangle, // ✅ fixed
                                                            size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                            size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                            textArray[selectedIndex].color,
                                                            textArray[selectedIndex].font,
                                                            item,
                                                            textArray[selectedIndex].isBold,
                                                            textArray[selectedIndex].isItalic,
                                                            textArray[selectedIndex].isUnderline,
                                                        );

                                                        console.log(url, 'front url');
                                                        let scaleFactor = oldWidth / (url.width / 4);
                                                        let adjustedHeight = (url.height / 4) * scaleFactor;

                                                        let updatedArray = textArray.map((item2, index) => {
                                                            if (index === selectedIndex) {
                                                                return {
                                                                    ...item2,
                                                                    text: getValues('tshirtText'),
                                                                    width: oldWidth,
                                                                    height: adjustedHeight,
                                                                    url: url.croppedBase64Image,
                                                                    shape: item,
                                                                    scaleFactor: scaleFactor
                                                                };
                                                            }
                                                            return item2;
                                                        });

                                                        console.log(updatedArray, 'updated front array');
                                                        setTextArray(updatedArray);
                                                    } catch (error) {
                                                        console.error("Error updating textArray:", error);
                                                    }
                                                } else {
                                                    try {
                                                        if (selectedIndexBack === undefined || selectedIndexBack === -1 || !textBackArray[selectedIndexBack]) {
                                                            console.warn("Invalid selectedIndexBack or textBackArray[selectedIndexBack] missing.");
                                                            return;
                                                        }

                                                        let oldWidth = textBackArray[selectedIndexBack].width;
                                                        let oldHeight = textBackArray[selectedIndexBack].height;

                                                        let size = await calculateTextDimensions(
                                                            getValues('tshirtText'),
                                                            textBackArray[selectedIndexBack].font,
                                                            '35',
                                                            600
                                                        );

                                                        let url = await generateCurvedTextCanvas(
                                                            getValues('tshirtText'),
                                                            item.curve,
                                                            item.offSetY,
                                                            item.height,
                                                            item.bottom,
                                                            item?.triangle, // ✅ fixed here too
                                                            size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                            size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                    (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                            textBackArray[selectedIndexBack].color,
                                                            textBackArray[selectedIndexBack].font,
                                                            item,
                                                            textBackArray[selectedIndexBack].isBold,
                                                            textBackArray[selectedIndexBack].isItalic,
                                                            textBackArray[selectedIndexBack].isUnderline,
                                                        );

                                                        console.log(url, 'back url');
                                                        let scaleFactor = oldWidth / (url.width / 4);
                                                        let adjustedHeight = (url.height / 4) * scaleFactor;

                                                        let updatedArray = textBackArray.map((item2, index) => {
                                                            if (index === selectedIndexBack) {
                                                                return {
                                                                    ...item2,
                                                                    text: getValues('tshirtText'),
                                                                    width: oldWidth,
                                                                    height: adjustedHeight,
                                                                    fontSize: item.fontSize ? parseFloat(item.fontSize) * scaleFactor : undefined, // ✅ safety check
                                                                    url: url.croppedBase64Image,
                                                                    shape: item,
                                                                    scaleFactor: scaleFactor
                                                                };
                                                            }
                                                            return item2;
                                                        });

                                                        console.log(updatedArray, 'updated back array');
                                                        setTextBackArray(updatedArray);
                                                    } catch (error) {
                                                        console.error("Error updating textBackArray:", error);
                                                    }
                                                }

                                            }}

                                            sx={{
                                                fontSize: '16px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: 'white',
                                                textTransform: 'none',
                                                border: item?.value == selectedShape?.value ? '2px solid #0BD1D1 ' : '2px solid white',
                                                // boxShadow: item?.value == selectedShape?.value ? ' rgba(0, 0, 0, 0.35) 0px 5px 15px' : 'none',
                                                borderRadius: '10px',
                                                transition: '0.3s ease',



                                            }}

                                        >
                                            <Box
                                                component={'img'}
                                                src={Images[item?.value]}
                                                width={'60px'}
                                                height={'30px'}

                                            />

                                        </Box>
                                    ))}

                                </Box>


                            </Box>
                        </Box>}
                    {editModalState == 'Layers' &&
                        <Box sx={{ margin: '10px' }}>

                            <Box sx={{ p: 5 }}>
                                <InputLabel sx={{ color: 'white', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mb: 2, fontWeight: 500 }}>Layer Positions</InputLabel>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                        typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                            ? handleContextMenuOption(selectedIndex, 'Forward', rotateDirection ? 'back' : 'front')
                                            : ''
                                    }><Box component={'img'} src={Images.bringFront} width={'20px'}></Box></Button>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                        typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                            ? handleContextMenuOption(selectedIndex, 'Backward', rotateDirection ? 'back' : 'front')
                                            : ''
                                    } ><Box component={'img'} src={Images.bringBack} width={'20px'}></Box></Button>




                                </Box>
                            </Box>
                        </Box>}
                    {editModalState == 'ImageLayers' &&
                        <Box sx={{ margin: '10px' }}>

                            <Box sx={{ p: 5 }}>
                                <InputLabel sx={{ color: 'white', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', fontWeight: 500, mb: 2 }}>Layer Positions</InputLabel>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                        typeof imageSelectedIndex === 'number' || typeof imageSelectedIndexBack === 'number'
                                            ? handleContextMenuOption(imageSelectedIndex, 'Forward', rotateDirection ? 'back' : 'front', 'image')
                                            : ''
                                    }><Box component={'img'} src={Images.bringFront} width={'20px'}></Box></Button>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                        typeof imageSelectedIndex === 'number' || typeof imageSelectedIndexBack === 'number'
                                            ? handleContextMenuOption(imageSelectedIndex, 'Backward', rotateDirection ? 'back' : 'front', 'image')
                                            : ''
                                    }><Box component={'img'} src={Images.bringBack} width={'20px'}></Box></Button>




                                </Box>
                            </Box>
                        </Box>}
                    {editModalState == 'ImageAlignment' &&
                        <Box sx={{ p: 4 }}>
                            <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Image Alignment</InputLabel>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('left', rotateDirection ? 'back' : 'front')}><FormatAlignLeftIcon sx={{ color: 'white' }} /></Button>
                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('center', rotateDirection ? 'back' : 'front')}  ><FormatAlignJustifyIcon sx={{ color: 'white' }} /></Button>
                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('right', rotateDirection ? 'back' : 'front')}><FormatAlignRightIcon sx={{ color: 'white' }} /></Button>



                            </Box>
                            <Box>


                            </Box>
                            <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2, mt: 2 }}>Alignment Top - Bottom</InputLabel>
                            <Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('top', rotateDirection ? 'back' : 'front')}><VerticalAlignTopIcon sx={{ color: 'white' }} /></Button>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('center', rotateDirection ? 'back' : 'front')}  ><VerticalAlignCenterIcon sx={{ color: 'white' }} /></Button>
                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('bottom', rotateDirection ? 'back' : 'front')}><VerticalAlignBottomIcon sx={{ color: 'white' }} /></Button>



                                </Box>


                            </Box>

                        </Box>}
                    {editModalState === 'imageShapes' && (
                        <Box sx={{ p: 4, height: "200px" }} >
                            <Box sx={{ p: '20px', pb: 0 }}>
                                <InputLabel
                                    sx={{
                                        color: 'white',
                                        fontWeight: '500',
                                        textAlign: 'left',
                                        fontFamily: 'Maven Pro, sans-serif',
                                        mt: 1
                                    }}
                                >
                                    Image Border Radius
                                </InputLabel>
                                <Slider
                                    aria-label="Font Weight"
                                    value={imageBorderRadius}
                                    onChange={handleImageBorderRadius}
                                    sx={{
                                        color: '#ff5722', // Change slider color (e.g., orange)
                                        '& .MuiSlider-thumb': {
                                            backgroundColor: 'white', // Thumb color
                                            width: '17px',
                                            height: '17px'
                                        },
                                        '& .MuiSlider-track': {
                                            backgroundColor: '#0BD1D1', // Track color
                                            borderColor: ' #0BD1D1 !important'
                                        },
                                        '& .MuiSlider-rail': {
                                            backgroundColor: 'gray', // Rail color (background)
                                        },
                                    }}
                                    valueLabelDisplay="auto"
                                    min={0}
                                    max={100}
                                />
                            </Box>
                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                            <Box sx={{ p: '20px' }}>
                                <InputLabel
                                    sx={{
                                        color: 'white',
                                        fontWeight: '500',
                                        textAlign: 'left',
                                        mt: 2, // Using mt shorthand consistently
                                        fontFamily: 'Maven Pro, sans-serif'
                                    }}
                                >
                                    Shapes
                                </InputLabel>
                                <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 2, flexWrap: 'wrap' }}>
                                    <Grid container sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                        {shapesArray.map((item) => (

                                            <Box component={'div'} onClick={() => handleShapeSelect(item?.name, item?.value)} sx={{ border: '1px solid white', borderRadius: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '45px', p: '10px 0px', cursor: 'pointer' }}>
                                                <Box component={'img'} src={Images[item?.name]} width={'25px'}></Box>
                                            </Box>


                                        ))}
                                    </Grid>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    {editModalState === 'background' && (
                        <Box sx={{ p: '20px' }}><InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mt: 1 }}>Background</InputLabel>
                            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>

                                <Button onClick={() => {

                                    if (!rotateDirection) {
                                        console.log(revertedArrayFront[imageSelectedIndex]?.reverted, 'checkcheckcheckcheck');
                                        if (frontPictures[imageSelectedIndex]?.removed) {
                                            setFrontPictures((prevPictures) =>
                                                prevPictures.map((pic, newIndex) =>
                                                    newIndex === imageSelectedIndex
                                                        ? { ...pic, imageUrl: frontPictures[imageSelectedIndex]?.removed, width: revertedArrayFront[imageSelectedIndex]?.width, height: revertedArrayFront[imageSelectedIndex]?.height, rotation: revertedArrayFront[imageSelectedIndex]?.rotation, top: revertedArrayFront[imageSelectedIndex]?.top, left: revertedArrayFront[imageSelectedIndex]?.left, borderRadius: revertedArrayFront[imageSelectedIndex]?.borderRadius, clipPath: revertedArrayFront[imageSelectedIndex]?.clipPath }
                                                        : pic
                                                )
                                            );
                                            setRevertedArrayFront((prev) =>
                                                prev.map((item, newIndex2) =>
                                                    newIndex2 === imageSelectedIndex
                                                        ? {
                                                            ...item,
                                                            reverted: frontPictures[imageSelectedIndex]?.imageUrl,

                                                        }
                                                        : item
                                                )
                                            );
                                        }
                                        else {
                                            removeBg(
                                                !rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack],
                                                !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack
                                            );
                                        }
                                    }
                                    else {
                                        if (backPictures[imageSelectedIndexBack]?.removed) {
                                            setBackPictures((prevPictures) =>
                                                prevPictures.map((pic, newIndex) =>
                                                    newIndex === imageSelectedIndexBack
                                                        ? { ...pic, imageUrl: backPictures[imageSelectedIndexBack]?.removed, width: revertedArrayFront[imageSelectedIndexBack]?.width, height: revertedArrayFront[imageSelectedIndexBack]?.height, rotation: revertedArrayFront[imageSelectedIndexBack]?.rotation, top: revertedArrayFront[imageSelectedIndexBack]?.top, left: revertedArrayFront[imageSelectedIndexBack]?.left, borderRadius: revertedArrayFront[imageSelectedIndexBack]?.borderRadius, clipPath: revertedArrayFront[imageSelectedIndexBack]?.clipPath }
                                                        : pic
                                                )
                                            );
                                            setRevertedArrayFront((prev) =>
                                                prev.map((item, newIndex2) =>
                                                    newIndex2 === imageSelectedIndexBack
                                                        ? {
                                                            ...item,
                                                            reverted: backPictures[imageSelectedIndexBack]?.imageUrl,

                                                        }
                                                        : item
                                                )
                                            );
                                        }
                                        else {
                                            removeBg(
                                                !rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack],
                                                !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack
                                            );
                                        }
                                    }






                                }} sx={{
                                    textTransform: 'capitalize', borderRadius: '10px', fontSize: '12px',
                                    background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',
                                    '&.Mui-disabled': {
                                        backgroundColor: 'gray',

                                    },
                                    '&:hover': {
                                        backgroundColor: '#0F172A',
                                    },
                                }} disabled={!rotateDirection ? revertedArrayFront[imageSelectedIndex]?.reverted : revertedArrayBack[imageSelectedIndexBack]?.reverted}>Remove Background</Button>
                                <Button onClick={() => {
                                    revertImage(!rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack], !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack)


                                }} sx={{
                                    textTransform: 'capitalize', borderRadius: '10px', fontSize: '12px',
                                    background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',
                                    '&.Mui-disabled': {
                                        backgroundColor: 'gray',

                                    },
                                    '&:hover': {
                                        backgroundColor: '#0F172A',
                                    },

                                }} disabled={!rotateDirection ? !revertedArrayFront[imageSelectedIndex]?.reverted : !revertedArrayBack[imageSelectedIndexBack]?.reverted}>Revert Background</Button>
                            </Box>
                        </Box>
                    )}

                </Drawer>
                <Drawer
                    anchor="bottom"
                    open={open}
                    className='custom-scrollbar'
                    onClose={toggleDrawer(false)}
                    sx={{
                        '& .MuiDrawer-paper': {
                            borderTopLeftRadius: '20px', // Adjust the border radius value as needed
                            borderTopRightRadius: '20px',
                            backgroundColor: '#0F172A',
                            height: modalInnerState == 'Text' || modalInnerState == 'Gallery' ? '30%' : modalInnerState == 'Color' ? '20%' : '60%'
                        },
                    }}
                    onClick={() => {
                        if (!selectedElement) {

                            setTextState(''); setValue('tshirtText', '')
                        }
                    }}
                >
                    {modalInnerState == 'Image' && <>


                        <Box sx={{ p: '10px' }} >
                            <Box sx={{ p: '20px' }}><InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Maven Pro, sans-serif', mt: 3.5, mb: 4 }}>Gallery</InputLabel>

                                <Box sx={{ width: "90%", margin: "0 auto" }}>
                                    <Grid container justifyContent={"space-between"}>
                                        {library.length > 0 &&
                                            library?.map((item, index) => (
                                                <Grid
                                                    key={index}
                                                    onClick={() => {
                                                        const newImage = {
                                                            imageUrl: item?.url,
                                                            width: 100,
                                                            height: 100,
                                                            rotation: 0,
                                                            top: 20,
                                                            left: 20,
                                                            borderRadius: 10,
                                                            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                                                        };

                                                        if (!rotateDirection) {
                                                            const highestZIndexFront = Math.max(...frontPictures.map(p => p.zIndexes ?? 0), 0);
                                                            const newZIndex = highestZIndexFront + 1;

                                                            const newFrontItem = { ...newImage, zIndexes: newZIndex };
                                                            const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                            setFrontPictures([...frontPictures, newFrontItem]);
                                                            setRevertedArrayFront([...frontPictures, newRevertedItem]);
                                                        } else {
                                                            const highestZIndexBack = Math.max(...backPictures.map(p => p.zIndexes ?? 0), 0);
                                                            const newZIndex = highestZIndexBack + 1;

                                                            const newBackItem = { ...newImage, zIndexes: newZIndex };
                                                            const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                            setBackPictures([...backPictures, newBackItem]);
                                                            setRevertedArrayBack([...backPictures, newRevertedItem]);
                                                        }
                                                    }}

                                                    item
                                                    xs={5}
                                                    sx={{
                                                        mt: "2%",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <Box sx={{ position: "relative" }}>
                                                        <Box
                                                            className="image-selection"
                                                            component={"img"}
                                                            width={"100%"}
                                                            src={item.url}
                                                            style={{ borderRadius: '12px', backgroundColor: "#0BD1D14D" }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = "";
                                                                if (e.target.parentNode) {
                                                                    e.target.parentNode.style.backgroundColor =
                                                                        "grey";
                                                                    e.target.parentNode.style.display = "flex";
                                                                    e.target.parentNode.style.justifyContent =
                                                                        "center";
                                                                    e.target.parentNode.style.alignItems = "center";
                                                                    e.target.parentNode.style.height = "220px";
                                                                    e.target.parentNode.innerHTML =
                                                                        "No preview available";
                                                                }
                                                            }}
                                                        />

                                                    </Box>
                                                </Grid>

                                            ))}
                                        {totalCount !== library?.length && <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    //   variant="text"
                                                    className="heading-font2"
                                                    //   color="primary"
                                                    onClick={() => { setPageLimit(pageLimit + 6); getLibrary(pageLimit + 6); }}
                                                    sx={{
                                                        background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',
                                                        fontWeight: 500,
                                                        textTransform: "capitalize",
                                                        mt: 4,
                                                        p: "7px 20px",
                                                        fontSize: "15px",

                                                        borderRadius: "15px",
                                                        "&:hover": {
                                                            background: '#0F172A',
                                                            color: "white",
                                                        },
                                                    }}
                                                >
                                                    View More
                                                </Button>
                                            </Box>
                                        </Grid>}
                                    </Grid>
                                </Box>
                            </Box>


                        </Box>

                    </>}

                    {modalInnerState == 'Text' &&
                        <Box sx={{ p: '5px' }} component={'form'}  >
                            <Grid component={'div'} onClick={() => { setValue('tshirtText', '') }} container display={'flex'} justifyContent={'center'} alignItems={"center"}>
                                <Grid sx={{ width: '90%' }}>

                                    <div>
                                        <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Poppins, sans-serif', mt: 3, mb: 2 }}>{textState == 'edit' ? 'Edit Text' : 'Add Text'}</InputLabel>
                                        <TextField
                                            fullWidth

                                            size='small'
                                            InputProps={{
                                                style: {
                                                    fontSize: `${16}px`,
                                                    color: "white", fontFamily: 'Maven Pro, sans-serif',
                                                    border: '1px solid white',
                                                    textAlign: 'center'
                                                }
                                            }}
                                            {...register1("tshirtText1", {
                                                required: true,

                                                onChange: (e) => {
                                                    console.log(e.target.value.length);
                                                    handleInputChange()
                                                    if (e.target.value.length > 25) {
                                                        setTextLength(true)
                                                    }
                                                    else {
                                                        setTextLength(false)
                                                    }
                                                }
                                            })}

                                            onKeyDown={(event) => {
                                                console.log("key is down")
                                                if (event.key === 'Enter' && !textLength) {

                                                    Addtext1(event.target.value);
                                                }
                                            }}

                                        />
                                        {textLength && <span style={{ color: 'red', fontSize: '12px' }}>Text cannot exceed 25 characters</span>}
                                        {textState == 'edit' && <Box>
                                            <div style={{ marginTop: '20px' }}>
                                                <InputLabel className='heading-font2' sx={{ color: 'black', fontWeight: '500', textAlign: 'left', mb: 2 }}>Font Family</InputLabel>
                                                <div>
                                                    <div className="dropdown-container">
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            id='dropdown-font'
                                                            className="dropdown-toggle"
                                                            placeholder="Select Font"
                                                            style={{ fontFamily: searchTerm, backgroundColor: 'transparent', borderRadius: '5px', borderColor: 'white', color: 'white' }}
                                                            value={searchTerm == 'Black Ops One' || searchTerm == 'Audiowide' ? searchTerm.toUpperCase() : searchTerm}
                                                            onClick={toggleDropdown}
                                                            onChange={handleSearch}
                                                        />
                                                        {isDropdownOpen && (

                                                            <div ref={containerRef}  >
                                                                <Grid container>
                                                                    {displayedFonts.map((font) => {
                                                                        loadFont(font.family);
                                                                        return (
                                                                            <Grid item xs={6}>
                                                                                <div
                                                                                    key={font.family}
                                                                                    style={{ fontFamily: font.family, cursor: 'pointer', padding: '10px', color: 'white' }}
                                                                                    onClick={() => handleFontClick(font.family)}
                                                                                >
                                                                                    {font.family == 'Black Ops One' || font.family == 'Audiowide' ? font?.family?.toUpperCase() : font.family}
                                                                                </div>
                                                                            </Grid>
                                                                        );
                                                                    })}
                                                                </Grid>
                                                                {loading && <div>Loading more fonts...</div>}
                                                            </div>

                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                            {/* <InputLabel sx={{ color: 'black', fontWeight: '500', textAlign: 'left', fontFamily: 'Poppins, sans-serif', mt: 3.5 }}>Font Weight</InputLabel>
                                            <Slider
                                                aria-label="Font Weight"
                                                value={fontWeight}
                                                onChange={handleWeightChange}
                                                color='#0F172A'
                                                valueLabelDisplay="auto"
                                                step={100}
                                                marks
                                                min={100}
                                                max={900}
                                            /> */}
                                            {/* <InputLabel sx={{ color: 'black', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Poppins, sans-serif' }}>Font Size</InputLabel>
                                        <Grid container justifyContent={"center"} xs={12} mt={'2%'}>
                                            <Slider
                                                value={parseInt(fontSize)}
                                                defaultValue={fontSize}
                                                valueLabelDisplay="on"
                                                onChange={handleFontSizeChange}
                                                color='#0F172A'
                                                sx={{ fontFamily: 'Poppins, sans-serif' }}
                                                aria-label="Font Size"
                                            />
                                        </Grid> */}
                                            <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mt: 2 }}>Text Color</InputLabel>
                                            <div className="blockpicker" style={{ textAlign: 'left', }}>
                                                <CirclePicker colors={colors} disableAlpha={true} editableDisable={true} color={blockPickerColor} onChange={(color) => {
                                                    console.log(color.hex, 'color.hex');
                                                    handleTextColor(color.hex);
                                                    let size = calculateTextDimensions(getValues('tshirtText'), 'Bebas Neue', '35', 600)
                                                    let url = generateCurvedTextCanvas(
                                                        getValues('tshirtText'),
                                                        110,
                                                        4,
                                                        64,
                                                        200,
                                                        false,
                                                        size.width + 40,
                                                        size.height + 40,
                                                        color.hex,
                                                        false,
                                                        isBold,
                                                        isItalic,
                                                        isUnderline
                                                    )
                                                    if (!rotateDirection) {
                                                        textArray[selectedIndex].url = url
                                                    }
                                                    else {
                                                        textBackArray[selectedIndexBack].url = url
                                                    }
                                                    setBlockPickerColor(color.hex);
                                                }} />
                                            </div>
                                        </Box>}
                                    </div>
                                    {textState == 'edit' && <Box>
                                        <Box sx={{ p: 5 }}>
                                            <InputLabel sx={{ color: 'white', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', fontWeight: 500, mb: 2 }}>Layer Positions</InputLabel>
                                            <Box sx={{ display: 'flex', gap: 2 }}>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                    typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                                        ? handleContextMenuOption(selectedIndex, 'Forward', rotateDirection ? 'back' : 'front')
                                                        : ''
                                                }><Box component={'img'} src={Images.bringFront} width={'20px'}></Box></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                    typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                                        ? handleContextMenuOption(selectedIndex, 'Backward', rotateDirection ? 'back' : 'front')
                                                        : ''
                                                } ><Box component={'img'} src={Images.bringBack} width={'20px'}></Box></Button>




                                            </Box>
                                        </Box>
                                        <Grid container mt={2}>
                                            <Grid item xs={12}>
                                                <InputLabel sx={{ color: 'black', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Poppins, sans-serif' }}>Text Alignments</InputLabel>
                                                <Box>

                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('left', rotateDirection ? 'back' : 'front')}><FormatAlignLeftIcon sx={{ color: 'white' }} /></Button>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('center', rotateDirection ? 'back' : 'front')}><FormatAlignJustifyIcon sx={{ color: 'white' }} /></Button>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('right', rotateDirection ? 'back' : 'front')}><FormatAlignRightIcon sx={{ color: 'white' }} /></Button>



                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Alignment Top - Bottom</InputLabel>
                                                <Box>

                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('top', rotateDirection ? 'back' : 'front')}><VerticalAlignTopIcon sx={{ color: 'white' }} /></Button>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('center', rotateDirection ? 'back' : 'front')} ><VerticalAlignCenterIcon sx={{ color: 'white' }} /></Button>
                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('bottom', rotateDirection ? 'back' : 'front')}><VerticalAlignBottomIcon sx={{ color: 'white' }} /></Button>



                                                    </Box>

                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Text Shape</InputLabel>

                                        <Box sx={{ display: 'flex', mb: 2, mt: 2, flexWrap: 'wrap', gap: 1 }}>

                                            {[
                                                { shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false },
                                                { shape: 'above', value: 'shape1', curve: 120, offSetY: 5, height: 80, bottom: 180, triangle: false },
                                                { shape: 'down', value: 'shape2', curve: -120, offSetY: 50, height: 60, bottom: 0, triangle: false },
                                                { shape: 'triangle', value: 'shape3', curve: 200, offSetY: 40, height: 60, bottom: 0, triangle: false },
                                                { shape: 'triangle', value: 'shape4', curve: 140, offSetY: 50, height: 60, bottom: 0, triangle: true },
                                                { shape: 'triangle', value: 'shape5', curve: 180, offSetY: 50, height: 50, bottom: 0, triangle: true },
                                                { shape: 'triangle', value: 'shape6', curve: 350, offSetY: 50, height: 60, bottom: 0, triangle: false },

                                            ].map((item, index) => (
                                                <Box

                                                    width={'28%'}
                                                    height={'60px'}

                                                    key={index}
                                                    onClick={async () => {
                                                        setSelectedShape(item);

                                                        if (!rotateDirection) {
                                                            try {

                                                                console.log(textArray[selectedIndex], 'textarrararar');
                                                                let oldWidth = textArray[selectedIndex].width;
                                                                let oldHeight = textArray[selectedIndex].height;

                                                                // Await the size calculation
                                                                let size = await calculateTextDimensions(getValues('tshirtText'), textArray[selectedIndex].font, '35', 600);
                                                                console.log(size, 'sizesize');

                                                                // Await the curved text canvas generation
                                                                let url = await generateCurvedTextCanvas(
                                                                    getValues('tshirtText'),
                                                                    item.curve,
                                                                    item.offSetY,
                                                                    item.height,
                                                                    item.bottom,
                                                                    item?.triangle,
                                                                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                                                                    textArray[selectedIndex].color,
                                                                    textArray[selectedIndex].font,
                                                                    item,
                                                                    textArray[selectedIndex].isBold,
                                                                    textArray[selectedIndex].isItalic,
                                                                    textArray[selectedIndex].isUnderline,
                                                                );
                                                                console.log(url, 'textarrararar');
                                                                console.log(oldWidth);
                                                                console.log(oldHeight);

                                                                // Calculate the scale factor
                                                                let scaleFactor = oldWidth / (url.width / 4);

                                                                // Adjust the height proportionally while keeping the width constant
                                                                let adjustedHeight = (url.height / 4) * scaleFactor;

                                                                // Update the array with the new data
                                                                let updatedArray = textArray.map((item2, index) => {
                                                                    if (index === selectedIndex) {
                                                                        return {
                                                                            ...item2,
                                                                            text: getValues('tshirtText'),
                                                                            width: oldWidth, // Keep the original width
                                                                            height: adjustedHeight, // Adjust the height proportionally
                                                                            url: url.croppedBase64Image,
                                                                            shape: item,
                                                                            scaleFactor: scaleFactor // Store the scale factor for future use if needed
                                                                        };
                                                                    }
                                                                    return item2;
                                                                });
                                                                console.log(updatedArray, 'updatedArray');

                                                                setTextArray(updatedArray);
                                                            } catch (error) {
                                                                console.error("Error updating textArray:", error);
                                                            }
                                                        } else {
                                                            try {
                                                                let oldWidth = textBackArray[selectedIndexBack].width;
                                                                let oldHeight = textBackArray[selectedIndexBack].height;

                                                                let size = await calculateTextDimensions(getValues('tshirtText'), textBackArray[selectedIndexBack].font, '35', 600);

                                                                // Await the curved text canvas generation
                                                                let url = await generateCurvedTextCanvas(
                                                                    getValues('tshirtText'),
                                                                    item.curve,
                                                                    item.offSetY,
                                                                    item.height,
                                                                    item.bottom,
                                                                    false,
                                                                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),

                                                                    textBackArray[selectedIndexBack].color,
                                                                    textBackArray[selectedIndexBack].font,
                                                                    item,
                                                                    textBackArray[selectedIndexBack].isBold,
                                                                    textBackArray[selectedIndexBack].isItalic,
                                                                    textBackArray[selectedIndexBack].isUnderline,
                                                                );

                                                                // Calculate the scale factor
                                                                let scaleFactor = oldWidth / (url.width / 4);

                                                                // Adjust the height proportionally while keeping the width constant
                                                                let adjustedHeight = (url.height / 4) * scaleFactor;

                                                                // Update the array with the new data
                                                                let updatedArray = textBackArray.map((item2, index) => {
                                                                    if (index === selectedIndexBack) {
                                                                        return {
                                                                            ...item2,
                                                                            text: getValues('tshirtText'),
                                                                            width: oldWidth, // Keep the original width
                                                                            height: adjustedHeight, // Adjust the height proportionally
                                                                            fontSize: parseFloat(item.fontSize) * scaleFactor, // Scale the font size
                                                                            url: url.croppedBase64Image,
                                                                            shape: item,
                                                                            scaleFactor: scaleFactor // Store the scale factor for future use if needed
                                                                        };
                                                                    }
                                                                    return item2;
                                                                });

                                                                setTextBackArray(updatedArray);
                                                            } catch (error) {
                                                                console.error("Error updating textBackArray:", error);
                                                            }
                                                        }
                                                    }}

                                                    sx={{
                                                        fontSize: '16px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        color: 'white',
                                                        textTransform: 'none',
                                                        border: item?.value == selectedShape?.value ? '2px solid #0BD1D1 ' : '2px solid white',
                                                        // boxShadow: item?.value == selectedShape?.value ? ' rgba(0, 0, 0, 0.35) 0px 5px 15px' : 'none',
                                                        borderRadius: '10px',
                                                        transition: '0.3s ease',



                                                    }}

                                                >
                                                    <Box
                                                        component={'img'}
                                                        src={Images[item?.value]}
                                                        width={'60px'}
                                                        height={'30px'}

                                                    />

                                                </Box>
                                            ))}

                                        </Box>


                                    </Box>}
                                    {textState != 'edit' && <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%', margin: '0 auto', mt: '5%' }}>
                                        <Button fullWidth={true} disabled={textLength} sx={{
                                            background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A', fontWeight: 'bold', padding: '10px 25px', '&:hover': {



                                            },

                                        }}
                                            onClick={(e) => Addtext1(getValues1('tshirtText1'))}
                                        >
                                            Add Text
                                        </Button>
                                    </Box>}
                                </Grid>
                            </Grid>
                        </Box>}
                    {modalInnerState == 'Color' && <Box sx={{ p: '10px' }} >
                        <Box component={'form'} sx={{ margin: '0 auto' }} onSubmit={handleSubmit(Addtext)} >
                            <Grid container display={'flex'} p={3}>
                                <Grid>
                                    <div>
                                        <InputLabel sx={{ color: 'white', fontWeight: '500', fontFamily: 'Poppins, sans-serif' }}>Tshirt Colors</InputLabel>


                                        <Grid className='color-options-div' sx={{ mt: "20px" }}  >
                                            <div className="color-options">
                                                {tshirtColors?.map((color) => (
                                                    color?.enabled && (
                                                        <div
                                                            key={color.name}
                                                            className="circle"
                                                            style={{
                                                                background: color.color,
                                                                transform: selectedColor === color.color ? 'scale(1.2)' : '',
                                                                border: selectedColor === color.color ? '2px solid #0EA5EA' : ''
                                                            }}
                                                            onClick={() => {
                                                                setSelectedTshirt(color.name);
                                                                setSelectedColor(color.color);
                                                            }}
                                                        >
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </Grid>



                                    </div>

                                </Grid>
                            </Grid>
                        </Box>
                    </Box>}
                    {modalInnerState == 'Gallery' &&
                        <Box sx={{ p: '10px' }} >
                            <Box sx={{ p: '20px' }}><InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Maven Pro, sans-serif', mt: 3.5, mb: 4 }}>Gallery</InputLabel>

                                <Box sx={{ width: "90%", margin: "0 auto" }}>
                                    <Grid container justifyContent={"space-between"}>
                                        {library.length > 0 &&
                                            library?.map((item, index) => (
                                                <Grid
                                                    key={index}
                                                    onClick={() => {
                                                        const newImage = {
                                                            imageUrl: item?.url,
                                                            width: 100,
                                                            height: 100,
                                                            rotation: 0,
                                                            top: 20,
                                                            left: 20,
                                                            borderRadius: 10,
                                                            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                                                        };

                                                        if (!rotateDirection) {
                                                            const highestZIndexFront = Math.max(...frontPictures.map(p => p.zIndexes ?? 0), 0);
                                                            const newZIndex = highestZIndexFront + 1;
                                                            console.log(newZIndex, 'newZIndexnewZIndexnewZIndex');

                                                            const newFrontItem = { ...newImage, zIndexes: newZIndex };
                                                            const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                            setFrontPictures([...frontPictures, newFrontItem]);
                                                            setRevertedArrayFront([...frontPictures, newRevertedItem]);
                                                        } else {
                                                            const highestZIndexBack = Math.max(...backPictures.map(p => p.zIndexes ?? 0), 0);
                                                            const newZIndex = highestZIndexBack + 1;

                                                            const newBackItem = { ...newImage, zIndexes: newZIndex };
                                                            const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                            setBackPictures([...backPictures, newBackItem]);
                                                            setRevertedArrayBack([...backPictures, newRevertedItem]);
                                                        }
                                                    }}

                                                    item
                                                    xs={5}
                                                    sx={{
                                                        mt: "2%",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <Box sx={{ position: "relative" }}>
                                                        <Box

                                                            component={"img"}
                                                            className="image-selection"
                                                            width={"100%"}
                                                            src={item.url}
                                                            style={{ borderRadius: '12px', backgroundColor: "#0BD1D14D" }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = "";
                                                                if (e.target.parentNode) {
                                                                    e.target.parentNode.style.backgroundColor =
                                                                        "grey";
                                                                    e.target.parentNode.style.display = "flex";
                                                                    e.target.parentNode.style.justifyContent =
                                                                        "center";
                                                                    e.target.parentNode.style.alignItems = "center";
                                                                    e.target.parentNode.style.height = "220px";
                                                                    e.target.parentNode.innerHTML =
                                                                        "No preview available";
                                                                }
                                                            }}
                                                        />

                                                    </Box>
                                                </Grid>

                                            ))}
                                        {totalCount !== library?.length && <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                <Button
                                                    //   variant="text"
                                                    className="heading-font2"
                                                    //   color="primary"
                                                    onClick={() => { setPageLimit(pageLimit + 6); getLibrary(pageLimit + 6); }}
                                                    sx={{
                                                        background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',

                                                        textTransform: "capitalize",
                                                        mt: 4,
                                                        p: "7px 20px",
                                                        fontSize: "15px",

                                                        borderRadius: "15px",
                                                        "&:hover": {
                                                            background: '#0F172A',
                                                            color: "white",
                                                        },
                                                    }}
                                                >
                                                    View More
                                                </Button>
                                            </Box>
                                        </Grid>}
                                    </Grid>
                                </Box>
                            </Box>


                        </Box>}
                    {modalInnerState == 'Upload' && <>


                        <Box  >
                            <Box
                                sx={{
                                    width: "94%",
                                    margin: '20px auto',
                                    height: 160,
                                    border: "2px dashed white",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "transparent",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    "&:hover": { borderColor: "#ffffff90" },
                                }}
                                onClick={() => document.getElementById("upload-image").click()} // Trigger file input click
                            >
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id="upload-image"
                                    onChange={handleFileChange}
                                />

                                <UploadIconSecond sx={{ fontSize: 40, color: "#fff" }} />
                                <Typography variant="body1" sx={{ mt: 0.5, color: 'white !important', fontFamily: 'Maven Pro, sans-serif' }}>
                                    Upload Image
                                </Typography>
                            </Box>

                            {uploadedImg && <Box sx={{ position: "relative", display: 'flex', justifyContent: 'center' }}>
                                <Box
                                    className="image-selection"
                                    component={"img"}
                                    width={"200px"}
                                    height={'200px'}
                                    src={uploadedImg}
                                    style={{ borderRadius: '12px', backgroundColor: "#0BD1D14D", textAlign: 'center' }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "";
                                        if (e.target.parentNode) {
                                            e.target.parentNode.style.backgroundColor =
                                                "grey";
                                            e.target.parentNode.style.display = "flex";
                                            e.target.parentNode.style.justifyContent =
                                                "center";
                                            e.target.parentNode.style.alignItems = "center";
                                            e.target.parentNode.style.height = "220px";
                                            e.target.parentNode.innerHTML =
                                                "No preview available";
                                        }
                                    }}
                                />

                            </Box>}
                            {uploadedImg && <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <SecondaryButton
                                    onClick={() => {
                                        handleAddImage()
                                    }}
                                    className="checkout-btn"
                                    iconPosition="end"
                                    m="20px"
                                    p="10px 20px"
                                    fontWeight={600}
                                    color="#0C1427"
                                    sx={{ background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", ml: '0px !important' }}
                                    title="Add"
                                />
                            </Box>}
                        </Box>

                    </>}
                </Drawer>

                <Grid container justifyContent={'center'} sx={{ backgroundColor: 'white', height: "86.4vh" }}>
                    {/* {(!isLessThan1000px || isLessThan400) && <Box component={'div'} className="animat__animat animat__fadeInLeft" sx={{ display: 'flex', justifyContent: 'flex-start', p: '5px', width: '100%' }}>
                        <ButtonGroup variant="contained" aria-label="Basic button group" >
                            <Button onClick={(e, data, target) => (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') ? handleContextMenuOption(selectedIndex, 'Forward', rotateDirection ? 'back' : 'front') : ''} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Bring To Front</Button>
                            <Button onClick={(e, data, target) => (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') ? handleContextMenuOption(selectedIndex, 'Backward', rotateDirection ? 'back' : 'front') : ''} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Send to Back</Button>
                            <Button onClick={(e) => {
                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {

                                    e.stopPropagation(); setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                }
                            }} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Edit</Button>
                            <Button onClick={(e) => {
                                e.stopPropagation();
                                console.log('asasd22asd');
                                if (!rotateDirection) {

                                    handleDelete(selectedIndex, 'front');
                                    console.log(imageSelectedIndex, 'asdasdas');
                                    if (imageSelectedIndex != null && imageSelectedIndex !== '') {
                                        console.log(imageSelectedIndex, 'asdasdas2');
                                        handleImageDelete(imageSelectedIndex, 'front');
                                    }

                                }
                                else {
                                    console.log(selectedIndexBack);
                                    handleDelete(selectedIndexBack, 'back');
                                    console.log(imageSelectedIndexBack != null, imageSelectedIndexBack !== '', imageSelectedIndexBack);
                                    if (imageSelectedIndexBack != null && imageSelectedIndexBack !== '') {

                                        handleImageDelete(imageSelectedIndexBack, 'back')
                                    }
                                }
                            }} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Delete</Button>

                        </ButtonGroup>

                    </Box>} */}
                    {!isMobile && !isLessThan1000px && !isLessThan400 && <Grid item xs={12} md={4} lg={4} id={'Test'} sx={{ paddingBottom: '5%', padding: '0px', pt: '0px', backgroundColor: "white", height: '89.4vh', overflowY: 'auto', width: '50%' }} justifyContent={'center'}>
                        <Grid container sx={{ width: '100%', height: '100%' }}>
                            <Grid item md={2} lg={2} sx={{ backgroundColor: '#07141d', paddingRight: '12px' }}>
                                {Tabs.map((item, index) => (
                                    <Box
                                        component={'div'}
                                        onClick={() => { setSelectedTab(item.id); setTextState(''); setValue('tshirtText', ''); setValue1('tshirtText1', ''); setFontFamily('') }}
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            // backgroundColor: selectedTab == item.id ? '#0BD1D1' : '#0F172A',
                                            width: '100%',
                                            color: selectedTab == item.id ? 'white' : 'white',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            paddingTop: '10px',
                                            paddingBottom: '14px',
                                            fontFamily: 'Poppins, sans-serif',
                                            fontSize: '8px',

                                            transition: 'background-color 1s ease, color 1s ease',
                                        }}
                                    >
                                        <Box> {item.icon(selectedTab == item.id ? "#0BD1D1" : "white")}</Box>
                                        <Box sx={{ color: selectedTab == item.id ? "#0BD1D1" : "white", fontWeight: selectedTab == item.id ? "bold" : "", fontFamily: 'Maven Pro, sans-serif' }}>{item.name}</Box>
                                    </Box>
                                ))}
                            </Grid>
                            <Grid item sm={12} md={10} lg={10} sx={{ background: 'linear-gradient(160deg, rgba(11, 209, 209, 0.3), rgba(15, 23, 42, 0.2))', overflowY: selectedTab == 3 ? 'none' : 'scroll', backgroundColor: '#0F172A' }} >
                                {selectedTab == 0 && (
                                    <Box  >
                                        <Box component={'form'} onSubmit={handleSubmit(Addtext)}  >
                                            <Grid container display={'flex'} justifyContent={'center'} alignItems={"flex-start"} sx={{ height: '86.4vh' }}>
                                                <Grid sx={{ width: '90%' }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        {textState == 'edit' && <IconButton sx={{ textAlign: 'right' }} onClick={() => {
                                                            if (!rotateDirection) {
                                                                handleDelete(selectedIndex, 'front');
                                                                console.log(imageSelectedIndex, 'asdasdas');
                                                                setTextState('')
                                                                setValue('tshirtText', '')
                                                            }
                                                            else {
                                                                console.log(selectedIndexBack);
                                                                handleDelete(selectedIndexBack, 'back');
                                                                console.log(imageSelectedIndexBack != null, imageSelectedIndexBack !== '', imageSelectedIndexBack);
                                                                setTextState('')
                                                                setValue('tshirtText', '')
                                                            }
                                                        }}><DeleteIcon sx={{ color: 'white' }} /></IconButton>}
                                                    </Box>
                                                    <div>
                                                        <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Maven Pro, sans-serif', mt: 3, mb: 2 }}>{textState == 'edit' ? 'Edit Text' : 'Add Text'}</InputLabel>
                                                        <TextField
                                                            fullWidth
                                                            size='small'
                                                            InputProps={{
                                                                style: {
                                                                    fontSize: `${16}px`,
                                                                    color: "white",
                                                                    fontFamily: 'Maven Pro, sans-serif',
                                                                    textAlign: 'center',
                                                                    border: '1px solid white'
                                                                }
                                                            }}
                                                            {...register("tshirtText", {
                                                                required: true,
                                                                onChange: (e) => {
                                                                    console.log(e.target.value.length);
                                                                    if (e.target.value.length > 25) {
                                                                        setTextLength(true)
                                                                    }
                                                                    else {
                                                                        setTextLength(false)
                                                                    }
                                                                }
                                                            })}
                                                        />
                                                        {textLength && <span style={{ color: 'red', fontSize: '12px' }}>Text cannot exceed 25 characters</span>}
                                                        <br />
                                                        {textState == 'edit' && <Button sx={{
                                                            background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)",
                                                            color: '#0F172A',
                                                            fontWeight: 'bold',
                                                            mt: 2,
                                                            textTransform: 'capitalize',
                                                            borderRadius: '15px',
                                                            padding: '8px 25px'
                                                        }} disabled={textLength} onClick={() => handleInputChange()}>Update</Button>}
                                                        {textState == 'edit' && <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />}
                                                        {textState == 'edit' && <Box>
                                                            <div style={{ marginTop: '20px' }}>
                                                                <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mb: 2, fontFamily: 'Maven Pro, sans-serif' }}>Font Family</InputLabel>
                                                                <div>
                                                                    <div className="dropdown-container">
                                                                        <input
                                                                            type="text"
                                                                            readOnly
                                                                            id='dropdown-font'
                                                                            className="dropdown-toggle"
                                                                            placeholder="Select Font"
                                                                            style={{ fontFamily: searchTerm, backgroundColor: 'transparent', borderRadius: '5px', borderColor: 'white', color: 'white' }}
                                                                            value={searchTerm == 'Black Ops One' || searchTerm == 'Audiowide' ? searchTerm.toUpperCase() : searchTerm}
                                                                            onClick={toggleDropdown}
                                                                            onChange={handleSearch}
                                                                        />
                                                                        {isDropdownOpen && (
                                                                            <div ref={containerRef}>
                                                                                <Grid container>
                                                                                    {displayedFonts.map((font) => {
                                                                                        loadFont(font.family);
                                                                                        return (
                                                                                            <Grid item xs={6}>
                                                                                                <div
                                                                                                    key={font.family}
                                                                                                    style={{ fontFamily: font.family, cursor: 'pointer', padding: '10px', color: 'white' }}
                                                                                                    onClick={() => handleFontClick(font.family)}
                                                                                                >
                                                                                                    {font.family == 'Black Ops One' || font.family == 'Audiowide' ? font?.family?.toUpperCase() : font.family}
                                                                                                </div>
                                                                                            </Grid>
                                                                                        );
                                                                                    })}
                                                                                </Grid>
                                                                                {loading && <div>Loading more fonts...</div>}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                            </div>

                                                            {/* NEW: Text Formatting Section */}
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mt: 2, mb: 2, fontFamily: 'Maven Pro, sans-serif' }}>Text Formatting</InputLabel>
                                                                    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                                        <Button
                                                                            sx={{
                                                                                border: '1px solid white',
                                                                                padding: '8px 12px',
                                                                                minWidth: '45px !important',
                                                                                backgroundColor: isBold ? '#0BD1D1' : 'transparent',
                                                                                color: isBold ? '#0F172A' : 'white',
                                                                                '&:hover': {
                                                                                    backgroundColor: isBold ? '#0BD1D1' : '#1E293B',
                                                                                }
                                                                            }}
                                                                            onClick={() => {
                                                                                setIsBold(!isBold);
                                                                                if (textState === 'edit') {
                                                                                    if (!rotateDirection) {
                                                                                        textArray[selectedIndex].isBold = !isBold;
                                                                                        updateTextWithFormatting();
                                                                                    } else {
                                                                                        textBackArray[selectedIndexBack].isBold = !isBold;
                                                                                        updateTextWithFormatting();
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FormatBoldIcon />
                                                                        </Button>
                                                                        <Button
                                                                            sx={{
                                                                                border: '1px solid white',
                                                                                padding: '8px 12px',
                                                                                minWidth: '45px !important',
                                                                                backgroundColor: isItalic ? '#0BD1D1' : 'transparent',
                                                                                color: isItalic ? '#0F172A' : 'white',
                                                                                '&:hover': {
                                                                                    backgroundColor: isItalic ? '#0BD1D1' : '#1E293B',
                                                                                }
                                                                            }}
                                                                            onClick={() => {
                                                                                setIsItalic(!isItalic);
                                                                                if (textState === 'edit') {
                                                                                    if (!rotateDirection) {
                                                                                        textArray[selectedIndex].isItalic = !isItalic;
                                                                                        updateTextWithFormatting();
                                                                                    } else {
                                                                                        textBackArray[selectedIndexBack].isItalic = !isItalic;
                                                                                        updateTextWithFormatting();
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FormatItalicIcon />
                                                                        </Button>
                                                                        <Button
                                                                            sx={{
                                                                                border: '1px solid white',
                                                                                padding: '8px 12px',
                                                                                minWidth: '45px !important',
                                                                                backgroundColor: isUnderline ? '#0BD1D1' : 'transparent',
                                                                                color: isUnderline ? '#0F172A' : 'white',
                                                                                '&:hover': {
                                                                                    backgroundColor: isUnderline ? '#0BD1D1' : '#1E293B',
                                                                                }
                                                                            }}
                                                                            onClick={() => {
                                                                                setIsUnderline(!isUnderline);
                                                                                if (textState === 'edit') {
                                                                                    if (!rotateDirection) {
                                                                                        textArray[selectedIndex].isUnderline = !isUnderline;
                                                                                        updateTextWithFormatting();
                                                                                    } else {
                                                                                        textBackArray[selectedIndexBack].isUnderline = !isUnderline;
                                                                                        updateTextWithFormatting();
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FormatUnderlinedIcon />
                                                                        </Button>
                                                                    </Box>
                                                                    <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                                </Grid>
                                                            </Grid>
                                                            {/* END: Text Formatting Section */}

                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mt: 2, mb: 2, fontFamily: 'Maven Pro, sans-serif' }}>Text Color</InputLabel>
                                                                    <div className="blockpicker" style={{ textAlign: 'left' }}>
                                                                        <CirclePicker colors={colors} disableAlpha={true} editableDisable={true} color={blockPickerColor} onChange={(color) => {
                                                                            console.log(color.hex, 'color.hex');
                                                                            handleTextColor(color.hex);
                                                                            setBlockPickerColor(color.hex);
                                                                        }} />
                                                                    </div>
                                                                    <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                                </Grid>
                                                                <Grid item mt={2} xs={12}>
                                                                    <InputLabel className='heading-font2' sx={{ color: 'white', fontWeight: 700, textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mb: 2 }}>Text Alignments</InputLabel>
                                                                    <Box>
                                                                        <Grid container mt={'1%'} >
                                                                            <Grid item lg={12} md={12}>
                                                                                <Box sx={{ display: 'flex', gap: 2 }}>
                                                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('left', rotateDirection ? 'back' : 'front')}><FormatAlignLeftIcon sx={{ color: 'white' }} /></Button>
                                                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('center', rotateDirection ? 'back' : 'front')}><FormatAlignJustifyIcon sx={{ color: 'white' }} /></Button>
                                                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalPosition('right', rotateDirection ? 'back' : 'front')}><FormatAlignRightIcon sx={{ color: 'white' }} /></Button>
                                                                                </Box>
                                                                                <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                                            </Grid>
                                                                            <Grid item lg={12} md={12}>
                                                                                <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Maven Pro, sans-serif', mb: 2, mt: 2 }}>Alignment Top - Bottom</InputLabel>
                                                                                <Box>
                                                                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('top', rotateDirection ? 'back' : 'front')}><VerticalAlignTopIcon sx={{ color: 'white' }} /></Button>
                                                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('center', rotateDirection ? 'back' : 'front')} ><VerticalAlignCenterIcon sx={{ color: 'white' }} /></Button>
                                                                                        <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalPosition('bottom', rotateDirection ? 'back' : 'front')}><VerticalAlignBottomIcon sx={{ color: 'white' }} /></Button>
                                                                                    </Box>
                                                                                </Box>
                                                                                <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                                            </Grid>
                                                                        </Grid>
                                                                        <Box >
                                                                            <InputLabel sx={{ color: 'white', textAlign: 'left', fontFamily: 'Maven Pro, sans-serif', mt: 2, fontWeight: '500', mb: 2 }}>Layer Position</InputLabel>
                                                                            <Box sx={{ display: 'flex', gap: 2 }}>
                                                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                                                    typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                                                                        ? handleContextMenuOption(selectedIndex, 'Forward', rotateDirection ? 'back' : 'front')
                                                                                        : ''
                                                                                }><Box component={'img'} src={Images.bringFront} width={'20px'}></Box></Button>
                                                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                                                    typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number'
                                                                                        ? handleContextMenuOption(selectedIndex, 'Backward', rotateDirection ? 'back' : 'front')
                                                                                        : ''
                                                                                } ><Box component={'img'} src={Images.bringBack} width={'20px'}></Box></Button>
                                                                            </Box>
                                                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                                                        </Box>
                                                                        <InputLabel
                                                                            className='heading-font2'
                                                                            sx={{
                                                                                color: 'white',
                                                                                fontWeight: 700,
                                                                                textAlign: 'left',
                                                                                mt: 2,
                                                                                fontFamily: 'Maven Pro, sans-serif'
                                                                            }}
                                                                        >
                                                                            Text Shapes
                                                                        </InputLabel>
                                                                        <Box sx={{ display: 'flex', mb: 2, mt: 2, flexWrap: 'wrap', gap: 1 }}>
                                                                            {[
                                                                                { shape: 'straight', value: 'shape0', curve: 0, offSetY: 0, height: 70, bottom: 84, triangle: false },
                                                                                { shape: 'above', value: 'shape1', curve: 120, offSetY: 5, height: 80, bottom: 180, triangle: false },
                                                                                { shape: 'down', value: 'shape2', curve: -120, offSetY: 50, height: 60, bottom: 0, triangle: false },
                                                                                { shape: 'triangle', value: 'shape3', curve: 200, offSetY: 40, height: 60, bottom: 0, triangle: false },
                                                                                { shape: 'triangle', value: 'shape4', curve: 140, offSetY: 50, height: 60, bottom: 0, triangle: true },
                                                                                { shape: 'triangle', value: 'shape5', curve: 180, offSetY: 50, height: 50, bottom: 0, triangle: true },
                                                                                { shape: 'triangle', value: 'shape6', curve: 350, offSetY: 50, height: 60, bottom: 0, triangle: false },
                                                                            ].map((item, index) => (
                                                                                <Box
                                                                                    width={'28%'}
                                                                                    height={'60px'}
                                                                                    key={index}
                                                                                    onClick={async () => {
                                                                                        setSelectedShape(item);
                                                                                        console.log(textArray[selectedIndex], 'sdadasd');
                                                                                        if (!rotateDirection) {
                                                                                            try {
                                                                                                console.log(textArray[selectedIndex], 'textarrararar');
                                                                                                let oldWidth = textArray[selectedIndex].width;
                                                                                                let oldHeight = textArray[selectedIndex].height;
                                                                                                let size = await calculateTextDimensions(
                                                                                                    getValues('tshirtText'),
                                                                                                    textArray[selectedIndex].font,
                                                                                                    '35',
                                                                                                    600
                                                                                                );
                                                                                                console.log(size, 'sizesize');
                                                                                                let url = await generateCurvedTextCanvas(
                                                                                                    getValues('tshirtText'),
                                                                                                    item.curve,
                                                                                                    item.offSetY,
                                                                                                    item.height,
                                                                                                    item.bottom,
                                                                                                    item?.triangle, // ✅ fixed
                                                                                                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                                                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                                                    textArray[selectedIndex].color,
                                                                                                    textArray[selectedIndex].font,
                                                                                                    item,
                                                                                                    textArray[selectedIndex].isBold,
                                                                                                    textArray[selectedIndex].isItalic,
                                                                                                    textArray[selectedIndex].isUnderline,
                                                                                                );
                                                                                                console.log(url, 'front url');
                                                                                                let scaleFactor = oldWidth / (url.width / 4);
                                                                                                let adjustedHeight = (url.height / 4) * scaleFactor;
                                                                                                let updatedArray = textArray.map((item2, index) => {
                                                                                                    if (index === selectedIndex) {
                                                                                                        return {
                                                                                                            ...item2,
                                                                                                            text: getValues('tshirtText'),
                                                                                                            width: oldWidth,
                                                                                                            height: adjustedHeight,
                                                                                                            url: url.croppedBase64Image,
                                                                                                            shape: item,
                                                                                                            scaleFactor: scaleFactor
                                                                                                        };
                                                                                                    }
                                                                                                    return item2;
                                                                                                });
                                                                                                console.log(updatedArray, 'updated front array');
                                                                                                setTextArray(updatedArray);
                                                                                            } catch (error) {
                                                                                                console.error("Error updating textArray:", error);
                                                                                            }
                                                                                        } else {
                                                                                            try {
                                                                                                if (selectedIndexBack === undefined || selectedIndexBack === -1 || !textBackArray[selectedIndexBack]) {
                                                                                                    console.warn("Invalid selectedIndexBack or textBackArray[selectedIndexBack] missing.");
                                                                                                    return;
                                                                                                }
                                                                                                let oldWidth = textBackArray[selectedIndexBack].width;
                                                                                                let oldHeight = textBackArray[selectedIndexBack].height;
                                                                                                let size = await calculateTextDimensions(
                                                                                                    getValues('tshirtText'),
                                                                                                    textBackArray[selectedIndexBack].font,
                                                                                                    '35',
                                                                                                    600
                                                                                                );
                                                                                                let url = await generateCurvedTextCanvas(
                                                                                                    getValues('tshirtText'),
                                                                                                    item.curve,
                                                                                                    item.offSetY,
                                                                                                    item.height,
                                                                                                    item.bottom,
                                                                                                    item?.triangle, // ✅ fixed here too
                                                                                                    size.width + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                                                    size.height + (getValues('tshirtText')?.length <= 7 ? 200 :
                                                                                                        (getValues('tshirtText')?.length <= 15 ? 700 :
                                                                                                            (getValues('tshirtText')?.length <= 22 ? 750 : 900))),
                                                                                                    textBackArray[selectedIndexBack].color,
                                                                                                    textBackArray[selectedIndexBack].font,
                                                                                                    item,
                                                                                                    textBackArray[selectedIndexBack].isBold,
                                                                                                    textBackArray[selectedIndexBack].isItalic,
                                                                                                    textBackArray[selectedIndexBack].isUnderline,
                                                                                                );
                                                                                                console.log(url, 'back url');
                                                                                                let scaleFactor = oldWidth / (url.width / 4);
                                                                                                let adjustedHeight = (url.height / 4) * scaleFactor;
                                                                                                let updatedArray = textBackArray.map((item2, index) => {
                                                                                                    if (index === selectedIndexBack) {
                                                                                                        return {
                                                                                                            ...item2,
                                                                                                            text: getValues('tshirtText'),
                                                                                                            width: oldWidth,
                                                                                                            height: adjustedHeight,
                                                                                                            fontSize: item.fontSize ? parseFloat(item.fontSize) * scaleFactor : undefined, // ✅ safety check
                                                                                                            url: url.croppedBase64Image,
                                                                                                            shape: item,
                                                                                                            scaleFactor: scaleFactor
                                                                                                        };
                                                                                                    }
                                                                                                    return item2;
                                                                                                });
                                                                                                console.log(updatedArray, 'updated back array');
                                                                                                setTextBackArray(updatedArray);
                                                                                            } catch (error) {
                                                                                                console.error("Error updating textBackArray:", error);
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    sx={{
                                                                                        fontSize: '16px',
                                                                                        display: 'flex',
                                                                                        justifyContent: 'center',
                                                                                        alignItems: 'center',
                                                                                        color: 'white',
                                                                                        textTransform: 'none',
                                                                                        border: item?.value == selectedShape?.value ? '2px solid #0BD1D1 ' : '2px solid white',
                                                                                        borderRadius: '10px',
                                                                                        transition: '0.3s ease',
                                                                                    }}
                                                                                >
                                                                                    <Box
                                                                                        component={'img'}
                                                                                        src={Images[item?.value]}
                                                                                        width={'60px'}
                                                                                        height={'30px'}
                                                                                    />
                                                                                </Box>
                                                                            ))}
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>}
                                                    </div>
                                                    {textState != 'edit' &&
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%', margin: '0 auto', mt: '5%' }}>
                                                            <Button type='submit' disabled={textLength} fullWidth={true} sx={{
                                                                background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)",
                                                                color: '#0F172A',
                                                                fontWeight: 'bold',
                                                                padding: '10px 25px',
                                                                border: '2px solid transparent',
                                                                borderRadius: '15px'
                                                            }}>
                                                                Add Text
                                                            </Button>
                                                        </Box>}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Box>
                                )}
                                {selectedTab == 1 &&
                                    <Box  >
                                        <Box component={'form'} sx={{ margin: '0 auto', height: '86.4vh' }} onSubmit={handleSubmit(Addtext)} >
                                            <Grid container display={'flex'} alignItems={'flex-start'} p={3} >
                                                <Grid>
                                                    <div>
                                                        <InputLabel sx={{ color: 'white', fontWeight: '500', fontFamily: 'Poppins, sans-serif' }}>Tshirt Colors</InputLabel>


                                                        <Grid className='color-options-div' sx={{ mt: "20px" }}  >
                                                            <div className="color-options">
                                                                {tshirtColors?.map((color) => (
                                                                    color?.enabled && (
                                                                        <div
                                                                            key={color.name}
                                                                            className="circle"
                                                                            style={{
                                                                                background: color.color,
                                                                                transform: selectedColor === color.color ? 'scale(1.2)' : '',
                                                                                border: selectedColor === color.color ? '2px solid #0EA5EA' : ''
                                                                            }}
                                                                            onClick={() => {
                                                                                setSelectedTshirt(color.name);
                                                                                setSelectedColor(color.color);
                                                                            }}
                                                                        >
                                                                        </div>
                                                                    )
                                                                ))}
                                                            </div>
                                                        </Grid>



                                                    </div>

                                                </Grid>

                                            </Grid>
                                        </Box>
                                    </Box>}
                                {selectedTab == 2 && <>
                                    <Box sx={{ height: '500px', overflow: 'none' }} >
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <IconButton sx={{ textAlign: 'right' }} onClick={() => {
                                                if (!rotateDirection) {


                                                    if (imageSelectedIndex != null && imageSelectedIndex !== '') {
                                                        console.log(imageSelectedIndex, 'asdasdas2');
                                                        handleImageDelete(imageSelectedIndex, 'front');
                                                        setSelectedTab(0)
                                                    }

                                                }
                                                else {

                                                    console.log(imageSelectedIndexBack != null, imageSelectedIndexBack !== '', imageSelectedIndexBack);
                                                    if (imageSelectedIndexBack != null && imageSelectedIndexBack !== '') {

                                                        handleImageDelete(imageSelectedIndexBack, 'back')
                                                        setSelectedTab(0)
                                                    }
                                                }
                                            }}><DeleteIcon sx={{ color: 'white' }} /></IconButton>
                                        </Box>
                                        <Box sx={{ p: 2 }}>
                                            <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', marginTop: '2%', fontFamily: 'Poppins, sans-serif', mb: 2 }}>Image Alignment</InputLabel>
                                            <Box>
                                                <Box sx={{ display: 'flex', gap: 2 }}>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('left', rotateDirection ? 'back' : 'front')}><FormatAlignLeftIcon sx={{ color: 'white' }} /></Button>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('center', rotateDirection ? 'back' : 'front')}  ><FormatAlignJustifyIcon sx={{ color: 'white' }} /></Button>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleHorizontalImagePosition('right', rotateDirection ? 'back' : 'front')}><FormatAlignRightIcon sx={{ color: 'white' }} /></Button>



                                                </Box>

                                            </Box>
                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                            <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', mt: 2, fontFamily: 'Poppins, sans-serif', mb: 2 }}>Alignment Top - Bottom</InputLabel>
                                            <Box>
                                                <Box sx={{ display: 'flex', gap: 2 }}>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('top', rotateDirection ? 'back' : 'front')}><VerticalAlignTopIcon sx={{ color: 'white' }} /></Button>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('center', rotateDirection ? 'back' : 'front')}  ><VerticalAlignCenterIcon sx={{ color: 'white' }} /></Button>
                                                    <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={() => handleVerticalImagePosition('bottom', rotateDirection ? 'back' : 'front')}><VerticalAlignBottomIcon sx={{ color: 'white' }} /></Button>



                                                </Box>

                                            </Box>
                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                        </Box>
                                        <Box sx={{ p: 2, pb: 0 }}>
                                            <InputLabel sx={{ color: 'white', textAlign: 'left', fontFamily: 'Poppins, sans-serif', fontWeight: '500', mb: 2 }}>Layer Position</InputLabel>
                                            <Box sx={{ display: 'flex', gap: 2 }}>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                    typeof imageSelectedIndex === 'number' || typeof imageSelectedIndexBack === 'number'
                                                        ? handleContextMenuOption(imageSelectedIndex, 'Forward', rotateDirection ? 'back' : 'front', 'image')
                                                        : ''
                                                }><Box component={'img'} src={Images.bringFront} width={'20px'}></Box></Button>
                                                <Button sx={{ border: '1px solid white', padding: '8px 0px', minWidth: '45px !important' }} onClick={(e, data, target) =>
                                                    typeof imageSelectedIndex === 'number' || typeof imageSelectedIndexBack === 'number'
                                                        ? handleContextMenuOption(imageSelectedIndex, 'Backward', rotateDirection ? 'back' : 'front', 'image')
                                                        : ''
                                                }><Box component={'img'} src={Images.bringBack} width={'20px'}></Box></Button>




                                            </Box>
                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                        </Box>

                                        <Box sx={{ p: '20px', pb: 0 }}>
                                            <InputLabel
                                                sx={{
                                                    color: 'white',
                                                    fontWeight: '500',
                                                    textAlign: 'left',
                                                    fontFamily: 'Maven Pro, sans-serif',
                                                    mt: 1,
                                                }}
                                            >
                                                Image Border Radius
                                            </InputLabel>

                                            <Slider
                                                aria-label="Font Weight"
                                                value={imageBorderRadius}
                                                onChange={handleImageBorderRadius}
                                                valueLabelDisplay="auto"
                                                min={0}
                                                max={100}
                                                sx={{
                                                    color: '#ff5722', // Change slider color (e.g., orange)
                                                    '& .MuiSlider-thumb': {
                                                        backgroundColor: 'white', // Thumb color
                                                        width: '17px',
                                                        height: '17px'
                                                    },
                                                    '& .MuiSlider-track': {
                                                        backgroundColor: '#0BD1D1', // Track color
                                                        borderColor: ' #0BD1D1 !important'
                                                    },
                                                    '& .MuiSlider-rail': {
                                                        backgroundColor: 'gray', // Rail color (background)
                                                    },
                                                }}
                                            />
                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                        </Box>

                                        <Box sx={{ p: '20px', pt: 0 }}><InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', fontFamily: 'Poppins, sans-serif', mt: 3 }}>Background</InputLabel>
                                            <Box sx={{ display: 'flex', gap: 2, mt: 2, mb: 2 }}>

                                                <Button onClick={() => {

                                                    if (!rotateDirection) {
                                                        console.log(revertedArrayFront[imageSelectedIndex]?.reverted, 'checkcheckcheckcheck');
                                                        if (frontPictures[imageSelectedIndex]?.removed) {
                                                            setFrontPictures((prevPictures) =>
                                                                prevPictures.map((pic, newIndex) =>
                                                                    newIndex === imageSelectedIndex
                                                                        ? { ...pic, imageUrl: frontPictures[imageSelectedIndex]?.removed, width: revertedArrayFront[imageSelectedIndex]?.width, height: revertedArrayFront[imageSelectedIndex]?.height, rotation: revertedArrayFront[imageSelectedIndex]?.rotation, top: revertedArrayFront[imageSelectedIndex]?.top, left: revertedArrayFront[imageSelectedIndex]?.left, borderRadius: revertedArrayFront[imageSelectedIndex]?.borderRadius, clipPath: revertedArrayFront[imageSelectedIndex]?.clipPath }
                                                                        : pic
                                                                )
                                                            );
                                                            setRevertedArrayFront((prev) =>
                                                                prev.map((item, newIndex2) =>
                                                                    newIndex2 === imageSelectedIndex
                                                                        ? {
                                                                            ...item,
                                                                            reverted: frontPictures[imageSelectedIndex]?.imageUrl,

                                                                        }
                                                                        : item
                                                                )
                                                            );
                                                        }
                                                        else {
                                                            removeBg(
                                                                !rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack],
                                                                !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack
                                                            );
                                                        }
                                                    }
                                                    else {
                                                        if (backPictures[imageSelectedIndexBack]?.removed) {
                                                            setBackPictures((prevPictures) =>
                                                                prevPictures.map((pic, newIndex) =>
                                                                    newIndex === imageSelectedIndexBack
                                                                        ? { ...pic, imageUrl: backPictures[imageSelectedIndexBack]?.removed, width: revertedArrayFront[imageSelectedIndexBack]?.width, height: revertedArrayFront[imageSelectedIndexBack]?.height, rotation: revertedArrayFront[imageSelectedIndexBack]?.rotation, top: revertedArrayFront[imageSelectedIndexBack]?.top, left: revertedArrayFront[imageSelectedIndexBack]?.left, borderRadius: revertedArrayFront[imageSelectedIndexBack]?.borderRadius, clipPath: revertedArrayFront[imageSelectedIndexBack]?.clipPath }
                                                                        : pic
                                                                )
                                                            );
                                                            setRevertedArrayFront((prev) =>
                                                                prev.map((item, newIndex2) =>
                                                                    newIndex2 === imageSelectedIndexBack
                                                                        ? {
                                                                            ...item,
                                                                            reverted: backPictures[imageSelectedIndexBack]?.imageUrl,

                                                                        }
                                                                        : item
                                                                )
                                                            );
                                                        }
                                                        else {
                                                            removeBg(
                                                                !rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack],
                                                                !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack
                                                            );
                                                        }
                                                    }






                                                }} sx={{
                                                    textTransform: 'capitalize', background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A', borderRadius: '10px', fontSize: '12px',
                                                    '&.Mui-disabled': {
                                                        backgroundColor: 'gray',

                                                    },
                                                    '&:hover': {
                                                        backgroundColor: '#0F172A',
                                                    },
                                                }} disabled={!rotateDirection ? revertedArrayFront[imageSelectedIndex]?.reverted : revertedArrayBack[imageSelectedIndexBack]?.reverted}>Remove Background</Button>
                                                <Button onClick={() => {
                                                    revertImage(!rotateDirection ? frontPictures[imageSelectedIndex] : backPictures[imageSelectedIndexBack], !rotateDirection ? imageSelectedIndex : imageSelectedIndexBack)


                                                }} sx={{
                                                    textTransform: 'capitalize', background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A', borderRadius: '10px', fontSize: '12px',
                                                    '&.Mui-disabled': {
                                                        backgroundColor: 'gray',

                                                    },
                                                    '&:hover': {
                                                        backgroundColor: '#0F172A',
                                                    },

                                                }} disabled={!rotateDirection ? !revertedArrayFront[imageSelectedIndex]?.reverted : !revertedArrayBack[imageSelectedIndexBack]?.reverted}>Revert Background</Button>
                                            </Box>
                                            <Divider sx={{ backgroundColor: '#879099', mt: 2 }} />
                                        </Box>

                                        <Box sx={{ pl: '20px', pt: 0 }}>
                                            <InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'left', fontFamily: 'Poppins, sans-serif', mb: 2, mt: 2 }}>Shapes</InputLabel>

                                            <Box sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>

                                                <Grid container sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                                    {shapesArray.map((item) => (

                                                        <Box component={'div'} onClick={() => handleShapeSelect(item?.name, item?.value)} sx={{ border: '1px solid white', borderRadius: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '45px', p: '10px 0px', cursor: 'pointer' }}>
                                                            <Box component={'img'} src={Images[item?.name]} width={'25px'}></Box>
                                                        </Box>


                                                    ))}
                                                </Grid>
                                            </Box>

                                        </Box>

                                    </Box></>}
                                {selectedTab == 3 &&
                                    <Box sx={{ p: '10px', overflow: 'none' }}  >
                                        <Box sx={{ p: '20px' }}><InputLabel sx={{ color: 'white', fontWeight: '500', textAlign: 'center', fontFamily: 'Poppins, sans-serif', mt: 3.5, mb: 4 }}>Gallery</InputLabel>

                                            <Box sx={{ width: "90%", margin: "0 auto", overflow: 'none' }}>
                                                <Grid container justifyContent={"space-between"}>
                                                    {library.length > 0 &&
                                                        library?.map((item, index) => (
                                                            <Grid
                                                                key={index}
                                                                onClick={() => {
                                                                    const newImage = {
                                                                        imageUrl: item?.url,
                                                                        width: 100,
                                                                        height: 100,
                                                                        rotation: 0,
                                                                        top: 20,
                                                                        left: 20,
                                                                        borderRadius: 10,
                                                                        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
                                                                    };

                                                                    if (!rotateDirection) {
                                                                        const highestZIndexFront = Math.max(...frontPictures.map(p => p.zIndexes ?? 0), 0);
                                                                        const newZIndex = highestZIndexFront + 1;

                                                                        const newFrontItem = { ...newImage, zIndexes: newZIndex };
                                                                        const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                                        setFrontPictures([...frontPictures, newFrontItem]);
                                                                        setRevertedArrayFront([...frontPictures, newRevertedItem]);
                                                                    } else {
                                                                        const highestZIndexBack = Math.max(...backPictures.map(p => p.zIndexes ?? 0), 0);
                                                                        const newZIndex = highestZIndexBack + 1;

                                                                        const newBackItem = { ...newImage, zIndexes: newZIndex };
                                                                        const newRevertedItem = { ...newImage, zIndexes: newZIndex, reverted: false };

                                                                        setBackPictures([...backPictures, newBackItem]);
                                                                        setRevertedArrayBack([...backPictures, newRevertedItem]);
                                                                    }
                                                                }}

                                                                item
                                                                xs={5}
                                                                sx={{
                                                                    mt: "2%",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                <Box sx={{ position: "relative" }}>
                                                                    <Box
                                                                        component={"img"}
                                                                        className="image-selection"
                                                                        width={"100%"}
                                                                        src={item.url}
                                                                        style={{ borderRadius: '12px', backgroundColor: "#0BD1D14D" }}
                                                                        onError={(e) => {
                                                                            e.target.onerror = null;
                                                                            e.target.src = "";
                                                                            if (e.target.parentNode) {
                                                                                e.target.parentNode.style.backgroundColor =
                                                                                    "grey";
                                                                                e.target.parentNode.style.display = "flex";
                                                                                e.target.parentNode.style.justifyContent =
                                                                                    "center";
                                                                                e.target.parentNode.style.alignItems = "center";
                                                                                e.target.parentNode.style.height = "220px";
                                                                                e.target.parentNode.innerHTML =
                                                                                    "No preview available";
                                                                            }
                                                                        }}
                                                                    />

                                                                </Box>
                                                            </Grid>

                                                        ))}
                                                    {totalCount !== library?.length && <Grid item lg={12} md={12} sm={12} xs={12}>
                                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                            <Button
                                                                //   variant="text"
                                                                className="heading-font2"
                                                                //   color="primary"
                                                                onClick={() => { setPageLimit(pageLimit + 6); getLibrary(pageLimit + 6); }}
                                                                sx={{
                                                                    background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", color: '#0F172A',
                                                                    fontWeight: 500,
                                                                    textTransform: "capitalize",
                                                                    mt: 4,
                                                                    p: "7px 20px",
                                                                    fontSize: "15px",

                                                                    borderRadius: "15px",
                                                                    "&:hover": {
                                                                        background: '#0F172A',
                                                                        color: "white",
                                                                    },
                                                                }}
                                                            >
                                                                View More
                                                            </Button>
                                                        </Box>
                                                    </Grid>}
                                                </Grid>
                                            </Box>
                                        </Box>


                                    </Box>
                                }
                                {selectedTab == 4 &&
                                    <Box  >
                                        <Box
                                            sx={{
                                                width: "94%",
                                                margin: '20px auto',
                                                height: 160,
                                                border: "2px dashed white",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "transparent",
                                                color: "#fff",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                "&:hover": { borderColor: "#ffffff90" },
                                            }}
                                            onClick={() => document.getElementById("upload-image2").click()} // Trigger file input click
                                        >
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                id="upload-image2"
                                                onChange={handleFileChange}
                                            />
                                            <UploadIconSecond sx={{ fontSize: 40, color: "#fff" }} />
                                            <Typography variant="body1" sx={{ mt: 0.5, color: 'white !important', fontFamily: 'Maven Pro, sans-serif' }}>
                                                Upload Image
                                            </Typography>
                                        </Box>

                                        {uploadedImg && <Box sx={{ position: "relative", display: 'flex', justifyContent: 'center' }}>
                                            <Box
                                                className="image-selection"
                                                component={"img"}
                                                width={"200px"}
                                                height={'200px'}
                                                src={uploadedImg}
                                                style={{ borderRadius: '12px', backgroundColor: "#0BD1D14D", textAlign: 'center' }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = "";
                                                    if (e.target.parentNode) {
                                                        e.target.parentNode.style.backgroundColor =
                                                            "grey";
                                                        e.target.parentNode.style.display = "flex";
                                                        e.target.parentNode.style.justifyContent =
                                                            "center";
                                                        e.target.parentNode.style.alignItems = "center";
                                                        e.target.parentNode.style.height = "220px";
                                                        e.target.parentNode.innerHTML =
                                                            "No preview available";
                                                    }
                                                }}
                                            />

                                        </Box>}
                                        {uploadedImg && <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <SecondaryButton
                                                onClick={() => {
                                                    handleAddImage()
                                                }}
                                                className="checkout-btn"
                                                iconPosition="end"
                                                m="20px"
                                                p="10px 20px"
                                                fontWeight={600}
                                                color="#0C1427"
                                                sx={{ background: "linear-gradient(to right, #0EA5EA, #0CC7D7, #0BD1D1)", ml: '0px !important' }}
                                                title="Add"
                                            />
                                        </Box>}
                                    </Box>}
                            </Grid>
                        </Grid>
                    </Grid>}
                    <Grid item component={'div'} onClick={() => {
                        if (!selectedElement) {

                            // setImageEdit(false)
                            // setSimpleNav(true)
                            setTextState(''); setValue('tshirtText', '')
                        }
                    }} className='edges-parent' xs={12} md={8} lg={8} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ position: 'relative', height: '100%' }}>


                        <div className='edges' style={{ position: 'relative', width: '460px', height: '300px', background: 'linear-gradient(160deg, rgba(11, 209, 209, 0.3), rgba(15, 23, 42, 0.2))', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '20px', backgroundColor: '#0F172A' }}>
                            <Box className={`square ${rotate ? 'rotate' : ''} `}
                                onClick={() => { handleRotate(); setRotateDirection(!rotateDirection); setSelectedTab(0) }} sx={{ position: 'absolute', top: '-95px', right: '0px', width: '50px', height: '50px', backgroundColor: ' #0F172A ', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', zIndex: '11111' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '30px' }} viewBox="0 0 24 24"><path d="M16.688 20.667C20.98 19.864 24 17.725 24 15c0-1.653-1.122-3.109-3.005-4.176a1 1 0 0 0-.986 1.74C21.326 13.311 22 14.184 22 15c0 1.481-2.221 3.054-5.68 3.701a1 1 0 0 0 .368 1.966zM4.371 11.2a1 1 0 0 1-.377 1.362C2.674 13.31 2 14.184 2 15c0 1.566 2.434 3.164 6 3.758v-1.55a.5.5 0 0 1 .854-.354l2.792 2.792a.5.5 0 0 1 0 .708l-2.792 2.792A.5.5 0 0 1 8 22.793v-2.01c-4.61-.68-8-2.898-8-5.783 0-1.654 1.123-3.11 3.008-4.178a1 1 0 0 1 1.363.378zM9 2a1 1 0 0 1 1 1 2 2 0 1 0 4 0l.007-.117A1 1 0 0 1 15 2h5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v6.5a1 1 0 0 1-2 0V9a2 2 0 0 1 2-2h2V4h-4.126a4.002 4.002 0 0 1-7.748 0H4v3h2a2 2 0 0 1 2 2v6.5a1 1 0 0 1-2 0V9H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#fff" fill-rule="evenodd"></path></svg>
                            </Box>
                            <div className={`tshirt-img-scale`} style={{ position: 'relative', width: '600px', marginBottom: '25px', marginTop: '25px' }}>
                                <img className={`  ${rotate ? 'rotateshirt' : ''}`} width={'450px'} height={'570px'} id="tshirt-backgroundpicture" src={Images[rotateDirection ? selectedTshirt + 'Back' : selectedTshirt]} />
                                <div style={{ position: 'absolute', top: 90, left: 112 }}>
                                    {!rotateDirection && <PDFExport ref={contentRef} paperSize="A4" scale={2.7} fileName="PrintContent">
                                        <div>
                                            <div className=' pdf-data no-scroll' id='pdf' ref={parentRef} style={{ border: (selectedElement || imageSeleted || imageSeletedBack) ? `1px dotted ${selectedTshirt == 'black' || selectedTshirt == 'darkgreen' || selectedTshirt == 'blue' ? 'white' : 'black'}` : 'none', width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>
                                                {console.log(textState, 'textState')}
                                                {textArray.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        {console.log(index)}

                                                        <div
                                                            onClick={(e) => {
                                                                setSelectedFont(textArray[index].font)
                                                                setSearchTerm(textArray[index].font)
                                                                console.log(textArray);
                                                                let element = e.currentTarget
                                                                console.log(e.currentTarget);
                                                                if (element) {
                                                                    console.log(element.style.top);
                                                                    let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                    let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                    textArray[index].top = number
                                                                    textArray[index].left = number2
                                                                }

                                                                setSelectedIndex(index);
                                                                setSelectedIndexBack('');
                                                                setValue('tshirtText', '');
                                                                setValue1('tshirtText', '');
                                                                setSelectedElement('True')

                                                                setEditNav(true)
                                                                setSimpleNav(false)
                                                                setTextState('edit');
                                                                setImageSeleted(false);
                                                                setSelectedTab(0)
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                    console.log(textArray[selectedIndex].text, 'textArray[selectedIndex].text');
                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                                                }
                                                            }}
                                                            onMouseDown={(e) => {
                                                                setSelectedIndex(index);
                                                                setSelectedIndexBack('');
                                                                setValue('tshirtText', '');
                                                                setValue1('tshirtText', '');
                                                                setSelectedElement('True')
                                                                setEditNav(true)
                                                                setSelectedTab(0)
                                                                setSimpleNav(false)
                                                                setTextState('edit');
                                                                setImageSeleted(false);
                                                                let element = e.currentTarget
                                                                console.log(e.currentTarget);
                                                                if (element) {
                                                                    console.log(element.style.top);
                                                                    let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                    let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                    textArray[index].top = number
                                                                    textArray[index].left = number2
                                                                }
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {

                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                                                }
                                                            }}
                                                            onTouchStart={(e) => {
                                                                setSelectedIndex(index);
                                                                setSelectedIndexBack('');
                                                                setValue('tshirtText', '');
                                                                setValue1('tshirtText', '');
                                                                setSelectedElement('True')
                                                                setEditNav(true)
                                                                setSelectedTab(0)
                                                                setSimpleNav(false)
                                                                setTextState('edit');
                                                                setImageSeleted(false);
                                                                let element = e.currentTarget
                                                                console.log(e.currentTarget);
                                                                if (element) {
                                                                    console.log(element.style.top);
                                                                    let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                    let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                    textArray[index].top = number
                                                                    textArray[index].left = number2
                                                                }
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                    console.log(textArray[selectedIndex].text, 'textArray[selectedIndex].text');
                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                                                }
                                                            }}
                                                            id={index}
                                                            style={{

                                                                border: (index === selectedIndex && selectedElement) ? `1px dotted ${selectedTshirt == 'black' || selectedTshirt == 'darkgreen' || selectedTshirt == 'blue' ? 'white' : 'black'}` : 'none',
                                                                position: 'absolute',
                                                                width: `${textArray[index].width}px`,
                                                                height: `${textArray[index].height}px`,
                                                                zIndex: textArray[index].zIndexes,
                                                                top: textArray[index]?.top?.toString().includes('px') ? textArray[index].top : `${textArray[index].top}px`,
                                                                left: textArray[index]?.left?.toString().includes('px') ? textArray[index].left : `${textArray[index].left}px`,
                                                                transform: `rotate(${textArray[index].rotation}deg)`,
                                                                backgroundImage: `url('${item.url}')`,
                                                                backgroundSize: 'contain',
                                                                backgroundRepeat: 'no-repeat',
                                                                backgroundPosition: 'center'

                                                            }}>
                                                            {console.log(textArray[index].width)}
                                                            {console.log(textArray[index].height)}


                                                            {/* {textArray?.length > 0 && <img
                                                                src={item?.url}
                                                                alt={`Canvas ${index}`}
                                                                style={{ width: `${textArray[index].width}px`, height: `${textArray[index].height}px` }}
                                                            />} */}
                                                        </div>

                                                        <Moveable
                                                            onClick={(e) => {
                                                                handleElementClick(e, index);
                                                                console.log(textArray[index], 'asdasd');

                                                                setSimpleNav(false);
                                                                setImageEdit(false);
                                                                setEditNav(true);
                                                                setSelectedTab(0);

                                                                if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                    console.log(textArray[selectedIndex].text, 'textArray[selectedIndex].text');
                                                                    setValue(
                                                                        'tshirtText',
                                                                        rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                    );
                                                                    setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');
                                                                }
                                                            }}

                                                            onTouchStart={(e) => {
                                                                handleElementClick(e, index);
                                                                setSimpleNav(false);
                                                                setImageEdit(false);
                                                                setEditNav(true);
                                                                setSelectedTab(0);

                                                                if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                    console.log(textArray[selectedIndex].text, 'textArray[selectedIndex].text');
                                                                    setValue(
                                                                        'tshirtText',
                                                                        rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                    );
                                                                    setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');
                                                                }
                                                            }}

                                                            renderIndicator={(direction, element) => {
                                                                if (direction === 'se') {
                                                                    return (
                                                                        <div className="custom-icon">
                                                                            <img
                                                                                src={Images.avatar1}
                                                                                alt="Resize"
                                                                                width={'50px'}
                                                                            />
                                                                        </div>
                                                                    );
                                                                }
                                                                if (direction === 'rotate') {
                                                                    return (
                                                                        <div className="custom-icon rotate-icon">
                                                                            <img
                                                                                src="path_to_rotate_icon.svg"
                                                                                alt="Rotate"
                                                                            />
                                                                        </div>
                                                                    );
                                                                }
                                                                return null;
                                                            }}

                                                            target={document.getElementById(index)}
                                                            container={null}
                                                            draggable={true}
                                                            resizable={index === selectedIndex && selectedElement}
                                                            scalable={index === selectedIndex && selectedElement}
                                                            rotatable={index === selectedIndex && selectedElement}
                                                            pinchable={true}
                                                            keepRatio={true}
                                                            origin={false}
                                                            snappable={true}
                                                            edge={false}
                                                            throttleDrag={0}
                                                            throttleResize={0}
                                                            throttleScale={0}
                                                            throttleRotate={0}
                                                            hideDefaultLines={true}
                                                            renderDirections={['se']}

                                                            onDrag={({ target, left, top }) => {
                                                                if (index === selectedIndex) {
                                                                    setSimpleNav(false);
                                                                    setEditNav(true);
                                                                    setSelectedTab(0);

                                                                    textArray[index].left = left;
                                                                    textArray[index].top = top;

                                                                    target.style.left = `${left}px`;
                                                                    target.style.top = `${top}px`;

                                                                    if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                        setValue(
                                                                            'tshirtText',
                                                                            rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                        );
                                                                        setTextState('edit');
                                                                    }
                                                                }
                                                            }}

                                                            onDragEnd={({ target }) => {
                                                                const designBox = document.getElementById('pdf');
                                                                const rect = designBox.getBoundingClientRect();
                                                                const targetRect = target.getBoundingClientRect();
                                                                const left = parseFloat(target.style.left);
                                                                const top = parseFloat(target.style.top);
                                                                const elementWidth = target.offsetWidth;
                                                                const elementHeight = target.offsetHeight;

                                                                const right = left + elementWidth;
                                                                const bottom = top + elementHeight;

                                                                const isCompletelyOutside =
                                                                    targetRect.right < rect.left ||   // Fully left
                                                                    targetRect.left > rect.right ||   // Fully right
                                                                    targetRect.bottom < rect.top ||   // Fully above
                                                                    targetRect.top > rect.bottom;     // Fully below

                                                                if (isCompletelyOutside && index === selectedIndex) {
                                                                    setSimpleNav(false);
                                                                    setEditNav(true);
                                                                    setSelectedTab(0);

                                                                    textArray[index].left = 10;
                                                                    textArray[index].top = 10;

                                                                    target.style.left = '10px';
                                                                    target.style.top = '10px';

                                                                    if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                        setValue(
                                                                            'tshirtText',
                                                                            rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                        );
                                                                        setTextState('edit');
                                                                    }
                                                                }
                                                            }}



                                                            onResize={({ target, width, height }) => {
                                                                setSelectedTab(0);

                                                                if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                    setValue(
                                                                        'tshirtText',
                                                                        rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                    );
                                                                    setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');
                                                                }

                                                                target.style.width = `${width}px`;
                                                                target.style.height = `${height}px`;

                                                                const updatedTextArray = [...textArray];
                                                                updatedTextArray[index] = {
                                                                    ...updatedTextArray[index],
                                                                    width,
                                                                    height,
                                                                };
                                                                setTextArray(updatedTextArray);
                                                            }}

                                                            onScale={({ target, delta }) => {
                                                                target.style.width = `${parseFloat(target.style.width) + delta[0]}px`;
                                                                target.style.height = `${parseFloat(target.style.height) + delta[1]}px`;
                                                            }}

                                                            onRotate={({ target, beforeRotate }) => {
                                                                textArray[index].rotation = beforeRotate;
                                                                target.style.transform = `rotate(${beforeRotate}deg)`;
                                                            }}
                                                        />

                                                        {/* Context Menu for Shape Change */}
                                                        <ContextMenu id={`context-menu-${index}`} style={{ zIndex: '9999', backgroundColor: 'white', borderRadius: '10px', padding: "10px", fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                                                            <Box sx={{ cursor: 'pointer' }}>
                                                                <MenuItem onClick={() => handleShapeChange(index, 'circle')}>Circle</MenuItem>
                                                            </Box>
                                                            <Box sx={{ cursor: 'pointer' }}>
                                                                <MenuItem onClick={() => handleShapeChange(index, 'wave')}>Wave</MenuItem>
                                                            </Box>
                                                            <Box sx={{ cursor: 'pointer' }}>
                                                                <MenuItem onClick={() => handleShapeChange(index, 'triangle')}>Triangle</MenuItem>
                                                            </Box>
                                                        </ContextMenu>
                                                    </React.Fragment>
                                                ))}

                                                {frontPictures?.map((imageUrl, index) => (
                                                    <div key={index}>
                                                        {console.log(imageUrl.imageUrl, 'urltest')}
                                                        <div
                                                            onClick={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndex(index);
                                                                    setImageSelectedIndexBack('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                            onMouseDown={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndex(index);
                                                                    setImageSelectedIndexBack('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                            onTouchStart={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndex(index);
                                                                    setImageSelectedIndexBack('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                        >
                                                            <Grid
                                                                id={`front-${index}`}
                                                                component={'div'}
                                                                onClick={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndex(index);
                                                                        setImageSelectedIndexBack('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                onMouseDown={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndex(index);
                                                                        setImageSelectedIndexBack('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                onTouchStart={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndex(index);
                                                                        setImageSelectedIndexBack('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                className={`Design-${index}`}
                                                                style={{
                                                                    clipPath: `${frontPictures[index].clipPath}`,
                                                                    width: `${frontPictures[index].width}px`,
                                                                    height: `${frontPictures[index].height}px`,
                                                                    position: 'absolute',
                                                                    top: `${frontPictures[index].top}px`,
                                                                    left: `${frontPictures[index].left}px`,
                                                                    borderRadius: `${frontPictures[index].borderRadius}px`,
                                                                    transform: `${frontPictures[index].rotation}`,
                                                                    zIndex: frontPictures[index].zIndexes,
                                                                }}
                                                            >
                                                                {/* Prevent Download Layer */}
                                                                <div
                                                                    className="prevent-download"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        backgroundImage: `url(${imageUrl.imageUrl})`,
                                                                        backgroundSize: 'contain',
                                                                        backgroundPosition: 'center',
                                                                        backgroundRepeat: 'no-repeat',
                                                                        pointerEvents: 'none',
                                                                        userSelect: 'none',
                                                                        borderRadius: `${frontPictures[index].borderRadius}px`,
                                                                        WebkitUserDrag: 'none',
                                                                        WebkitTouchCallout: 'none',
                                                                    }}
                                                                />

                                                                {/* Loader overlay */}
                                                                {removerLoader && (
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            backgroundColor: index === imageSelectedIndex ? 'rgba(0, 0, 0, 0.5)' : '',
                                                                            borderRadius: `${frontPictures[index].borderRadius}px`,
                                                                            zIndex: 9999,
                                                                        }}
                                                                    >
                                                                        {index === imageSelectedIndex && (
                                                                            <Box
                                                                                component={"img"}
                                                                                src={Images.loader}
                                                                                width={"50px"}
                                                                                height={"50px"}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Grid>
                                                        </div>

                                                        <Moveable
                                                            target={document.getElementsByClassName(`Design-${index}`)}
                                                            container={null}
                                                            draggable={true}
                                                            resizable={index === imageSelectedIndex && imageSeleted}
                                                            scalable={index === imageSelectedIndex && imageSeleted}
                                                            rotatable={index === imageSelectedIndex && imageSeleted}
                                                            pinchable={true}
                                                            keepRatio={true}
                                                            origin={false}
                                                            snappable={true}
                                                            edge={false}
                                                            renderDirections={['se']}
                                                            throttleDrag={0}
                                                            throttleResize={0}
                                                            throttleScale={0}
                                                            hideDefaultLines={true}
                                                            throttleRotate={0}
                                                            onDrag={({ target, left, top }) => {
                                                                const boxWidth = 220;
                                                                const boxHeight = 313;
                                                                const elementWidth = target.offsetWidth;
                                                                const elementHeight = target.offsetHeight;

                                                                if (left + elementWidth <= 0 || left >= boxWidth || top + elementHeight <= 0 || top >= boxHeight) {
                                                                    if (index === imageSelectedIndex) {
                                                                        frontPictures[index].top = 10;
                                                                        frontPictures[index].left = 10;
                                                                        target.style.left = `${10}px`;
                                                                        target.style.top = `${10}px`;
                                                                    }
                                                                } else {
                                                                    if (index === imageSelectedIndex) {
                                                                        frontPictures[index].top = top;
                                                                        frontPictures[index].left = left;
                                                                        target.style.left = `${left}px`;
                                                                        target.style.top = `${top}px`;
                                                                    }
                                                                }
                                                            }}
                                                            onResize={({ target, width, height }) => {
                                                                frontPictures[index].width = width;
                                                                frontPictures[index].height = height;
                                                                target.style.width = `${width}px`;
                                                                target.style.height = `${height}px`;
                                                            }}
                                                            onScale={({ target, transform }) => {
                                                                target.style.transform = transform;
                                                            }}
                                                            onRotate={({ target, transform }) => {
                                                                frontPictures[index].rotation = transform;
                                                                console.log(transform, 'transformtransform');
                                                                target.style.transform = transform;
                                                            }}
                                                        />
                                                    </div>
                                                ))}


                                            </div>
                                        </div>
                                    </PDFExport>}
                                    {rotateDirection && <PDFExport ref={contentRef} paperSize="A4" scale={2.7} fileName="PrintContent">
                                        <div>
                                            <div id='pdf2' ref={parentRef} style={{ border: (selectedElement || imageSeletedBack) ? `1px dotted ${selectedTshirt == 'black' || selectedTshirt == 'darkgreen' || selectedTshirt == 'blue' ? 'white' : 'black'}` : 'none', width: '220px', height: '313px', position: 'relative', overflow: 'hidden' }}>

                                                {textBackArray?.map((item, index) => (
                                                    <React.Fragment key={index}>

                                                        <ContextMenuTrigger id={`context-menu-back`}>
                                                            <div onClick={(e) => {
                                                                setSelectedFont(textBackArray[index].font)
                                                                setSearchTerm(textBackArray[index].font)
                                                                let element = e.currentTarget
                                                                console.log(e.currentTarget);
                                                                if (element) {
                                                                    console.log(element.style.top);
                                                                    let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                    let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                    textBackArray[index].top = number
                                                                    textBackArray[index].left = number2
                                                                }
                                                                setSelectedIndexBack(index); setValue('tshirtText', ''); setTextState('add'); setImageSeletedBack(false); setEditNav(true); setSimpleNav(false); setTextState('edit')
                                                                setSelectedElement('True')
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack]?.text : textArray[selectedIndex]?.text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');
                                                                    setSelectedTab(0)

                                                                }
                                                            }}
                                                                onMouseDown={(e) => {
                                                                    let element = e.currentTarget
                                                                    console.log(e.currentTarget);
                                                                    if (element) {
                                                                        console.log(element.style.top);
                                                                        let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                        let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                        textBackArray[index].top = number
                                                                        textBackArray[index].left = number2
                                                                    }
                                                                    setSelectedIndexBack(index); setValue('tshirtText', ''); setTextState('add'); setImageSeletedBack(false); setEditNav(true); setSimpleNav(false); setTextState('edit')
                                                                    setSelectedElement('True')
                                                                    if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                        setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack]?.text : textArray[selectedIndex]?.text); setTextState('edit');
                                                                        console.log(isLessThan1000px, 'isLessThan1000px');
                                                                        setSelectedTab(0)
                                                                    }
                                                                }}

                                                                onTouchStart={(e) => {
                                                                    let element = e.currentTarget
                                                                    console.log(e.currentTarget);
                                                                    if (element) {
                                                                        console.log(element.style.top);
                                                                        let number = parseInt(element.style.top, 10); // 10 is the radix parameter for base 10

                                                                        let number2 = parseInt(element.style.left, 10); // 10 is the radix parameter for base 10


                                                                        textBackArray[index].top = number
                                                                        textBackArray[index].left = number2
                                                                    }
                                                                    setSelectedIndexBack(index); setValue('tshirtText', ''); setTextState('add'); setImageSeletedBack(false); setEditNav(true); setSimpleNav(false); setTextState('edit')
                                                                    setSelectedElement('True')
                                                                    if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                        setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack]?.text : textArray[selectedIndex]?.text); setTextState('edit');
                                                                        console.log(isLessThan1000px, 'isLessThan1000px');
                                                                        setSelectedTab(0)
                                                                    }
                                                                }}
                                                                id={'back' + index} className='' style={{
                                                                    border: index === selectedIndexBack && selectedElement ? `1px dotted ${selectedTshirt == 'black' || selectedTshirt == 'darkgreen' ? 'white' : 'black'}` : 'none', position: 'absolute',
                                                                    width: `${textBackArray[index].width}px`,
                                                                    height: `${textBackArray[index].height}px`,
                                                                    zIndex: textBackArray[index].zIndexes,
                                                                    top: textBackArray[index]?.top?.toString().includes('px') ? textBackArray[index].top : `${textBackArray[index].top}px`,
                                                                    left: textBackArray[index]?.left?.toString().includes('px') ? textBackArray[index].left : `${textBackArray[index].left}px`,
                                                                    transform: `rotate(${textBackArray[index].rotation}deg)`,
                                                                    backgroundImage: `url('${item.url}')`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundRepeat: 'no-repeat',
                                                                    backgroundPosition: 'center'
                                                                }}>
                                                                {/* {index === selectedIndexBack && selectedElement && (
                                                                    <div onClick={(e) => { e.stopPropagation(); handleDelete(index); }}
                                                                        onTouchStart={(e) => { e.stopPropagation(); handleDelete(index); }}
                                                                        style={{ position: 'absolute', top: '-12px', left: '-10px', zIndex: '9999' }}>

                                                                        <CancelIcon sx={{ color: '#C70000', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }} />
                                                                    </div>
                                                                )} */}
                                                                {/* {index === selectedIndexBack && selectedElement && (
                                                                    <div onClick={(e) => {
                                                                        e.stopPropagation(); setValue('tshirtText', textBackArray[index].text); setTextState('edit'); if (isLessThan1000px) {
                                                                            handleDrawer(true, 'Text')
                                                                            setSelectedElement('')
                                                                        }
                                                                    }}
                                                                        onTouchStart={(e) => {
                                                                            e.stopPropagation(); setValue('tshirtText', textBackArray[index].text); setTextState('edit'); if (isLessThan1000px) {
                                                                                handleDrawer(true, 'Text')
                                                                                setSelectedElement('')
                                                                            }
                                                                        }}
                                                                        style={{ position: 'absolute', top: '-12px', right: '-10px', zIndex: '9999' }}>
                                                                        <EditIcon sx={{ color: 'black', cursor: 'pointer', fontSize: '20px' }} />
                                                                    </div>
                                                                )} */}
                                                                {/* {textBackArray?.length > 0 && <img
                                                                    src={item?.url}
                                                                    alt={`Canvas ${index}`}
                                                                    style={{ width: `${textBackArray[index].width}px`, height: `${textBackArray[index].height}px` }}
                                                                />} */}
                                                            </div>
                                                        </ContextMenuTrigger>
                                                        <Moveable onClick={(e) => {
                                                            handleElementClick(e, index);
                                                            setSimpleNav(false); setImageEdit(false); setEditNav(true); setSelectedTab(0)
                                                            if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                console.log(isLessThan1000px, 'isLessThan1000px');

                                                            }
                                                        }}
                                                            onTouchStart={(e) => {
                                                                handleElementClick(e, index); setSimpleNav(false); setImageEdit(false); setEditNav(true); setSelectedTab(0)
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                                                }
                                                            }}
                                                            target={document.getElementById('back' + index)}
                                                            container={null}
                                                            draggable={true}
                                                            resizable={index === selectedIndexBack && selectedElement}
                                                            scalable={index === selectedIndexBack && selectedElement}
                                                            rotatable={index === selectedIndexBack && selectedElement}
                                                            pinchable={true}
                                                            keepRatio={true}
                                                            origin={false}
                                                            snappable={true}
                                                            edge={false}
                                                            throttleDrag={0}
                                                            throttleResize={0}
                                                            throttleScale={0}
                                                            hideDefaultLines={true}
                                                            throttleRotate={0}
                                                            renderDirections={['se']}
                                                            // During drag: just update position
                                                            onDrag={({ target, left, top }) => {
                                                                if (index === selectedIndexBack) {
                                                                    setSimpleNav(false);
                                                                    setImageEdit(false);
                                                                    setEditNav(true);

                                                                    textBackArray[index].left = left;
                                                                    textBackArray[index].top = top;

                                                                    target.style.left = `${left}px`;
                                                                    target.style.top = `${top}px`;

                                                                    if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                        setValue(
                                                                            'tshirtText',
                                                                            rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                        );
                                                                        setTextState('edit');
                                                                        console.log(isLessThan1000px, 'isLessThan1000px');
                                                                    }
                                                                }
                                                            }}

                                                            // After drag ends: check if out of bounds and reset if needed
                                                            onDragEnd={({ target }) => {
                                                                const designBox = document.getElementById('pdf2');
                                                                const rect = designBox.getBoundingClientRect();
                                                                const targetRect = target.getBoundingClientRect();
                                                                const left = parseFloat(target.style.left);
                                                                const top = parseFloat(target.style.top);
                                                                const elementWidth = target.offsetWidth;
                                                                const elementHeight = target.offsetHeight;

                                                                const right = left + elementWidth;
                                                                const bottom = top + elementHeight;

                                                                const isCompletelyOutside =
                                                                    targetRect.right < rect.left ||   // Fully left
                                                                    targetRect.left > rect.right ||   // Fully right
                                                                    targetRect.bottom < rect.top ||   // Fully above
                                                                    targetRect.top > rect.bottom;     // Fully below

                                                                if (isCompletelyOutside && index === selectedIndexBack) {
                                                                    setSimpleNav(false);
                                                                    setImageEdit(false);
                                                                    setEditNav(true);

                                                                    textBackArray[index].left = 10;
                                                                    textBackArray[index].top = 10;

                                                                    target.style.left = '10px';
                                                                    target.style.top = '10px';

                                                                    if (typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number') {
                                                                        setValue(
                                                                            'tshirtText',
                                                                            rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text
                                                                        );
                                                                        setTextState('edit');
                                                                        console.log(isLessThan1000px, 'isLessThan1000px');
                                                                    }
                                                                }
                                                            }}


                                                            // onDragStart={({ target, left, top, clientX, clientY }) => {
                                                            //     const designBox = document.getElementById('pdf2'); // Replace with the actual ID of your design box
                                                            //     const rect = designBox.getBoundingClientRect();

                                                            //     if (clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom) {
                                                            //         // Only allow dragging if the click event is within the design box
                                                            //         if (index === selectedIndexBack) {
                                                            //             setSimpleNav(false); setImageEdit(false); setEditNav(true)
                                                            //             textBackArray[index].left = left
                                                            //             textBackArray[index].top = top

                                                            //             target.style.left = `${textBackArray[index].left}px`; target.style.top = `${textBackArray[index].top}px`;
                                                            //             if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                            //                 setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                            //                 console.log(isLessThan1000px, 'isLessThan1000px');
                                                            //             }
                                                            //         }
                                                            //     }
                                                            // }}
                                                            onResize={({ target, width, height }) => {
                                                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {
                                                                    setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');
                                                                    console.log(isLessThan1000px, 'isLessThan1000px');

                                                                }

                                                                target.style.width = `${width}px`;
                                                                target.style.height = `${height}px`;

                                                                let updatedTextArray = [...textBackArray];

                                                                updatedTextArray[index] = {
                                                                    ...updatedTextArray[index],
                                                                    width: width,
                                                                    height: height,

                                                                };
                                                                console.log(updatedTextArray);
                                                                setTextBackArray(updatedTextArray);
                                                            }}

                                                            onScale={({ target, delta }) => { target.style.width = `${parseFloat(target.style.width) + delta[0]}px`; target.style.height = `${parseFloat(target.style.height) + delta[1]}px`; }}
                                                            onRotate={({ target, beforeRotate }) => {
                                                                textBackArray[index].rotation = beforeRotate
                                                                target.style.transform = `rotate(${beforeRotate}deg)`;
                                                            }}
                                                        />
                                                        {/* <ContextMenu id={`context-menu-back`} style={{ zIndex: '9999', backgroundColor: 'white', borderRadius: '10px', padding: "10px", fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                                                            <Box sx={{ cursor: 'pointer' }}>
                                                                <MenuItem onClick={(e, data, target) => handleContextMenuOption(index, 'Forward','back')}>Move Forward</MenuItem>
                                                            </Box>
                                                            <Divider sx={{ backgroundColor: 'gray' }} />
                                                            <Box sx={{ cursor: 'pointer' }}>
                                                                <MenuItem onClick={(e, data, target) => handleContextMenuOption(index, 'Backward','back')}>Move Backward</MenuItem>
                                                            </Box>
                                                        </ContextMenu> */}
                                                    </React.Fragment>
                                                ))}

                                                {backPictures?.map((imageUrl, index) => (
                                                    <div key={index}>
                                                        <div
                                                            onClick={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndexBack(index);
                                                                    setImageSelectedIndex('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                            onMouseDown={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndexBack(index);
                                                                    setImageSelectedIndex('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                            onTouchStart={() => {
                                                                if (!removerLoader) {
                                                                    setImageSeleted(true);
                                                                    setImageSelectedIndexBack(index);
                                                                    setImageSelectedIndex('');
                                                                    setSelectedIndex('');
                                                                    setTextState('Add');
                                                                    setImageEdit(true);
                                                                    setEditNav(false);
                                                                    setSimpleNav(false);
                                                                    setSelectedTab(2);
                                                                }
                                                            }}
                                                        >
                                                            <Grid
                                                                id={`back-${index}`}
                                                                component={'div'}
                                                                onClick={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndexBack(index);
                                                                        setImageSelectedIndex('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                onMouseDown={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndexBack(index);
                                                                        setImageSelectedIndex('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                onTouchStart={() => {
                                                                    if (!removerLoader) {
                                                                        setImageSeleted(true);
                                                                        setImageSelectedIndexBack(index);
                                                                        setImageSelectedIndex('');
                                                                        setSelectedIndex('');
                                                                    }
                                                                }}
                                                                className={`DesignBack-${index}`}
                                                                style={{
                                                                    clipPath: `${backPictures[index].clipPath}`,
                                                                    width: `${backPictures[index].width}px`,
                                                                    height: `${backPictures[index].height}px`,
                                                                    position: 'absolute',
                                                                    top: `${backPictures[index].top}px`,
                                                                    left: `${backPictures[index].left}px`,
                                                                    borderRadius: `${backPictures[index].borderRadius}px`,
                                                                    transform: `${backPictures[index].rotation}`,
                                                                    zIndex: backPictures[index].zIndexes,
                                                                }}
                                                            >
                                                                {/* Prevent Download Layer */}
                                                                <div
                                                                    className="prevent-download"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        backgroundImage: `url(${imageUrl.imageUrl})`,
                                                                        borderRadius: `${backPictures[index].borderRadius}px`,
                                                                        backgroundSize: 'contain',
                                                                        backgroundPosition: 'center',
                                                                        backgroundRepeat: 'no-repeat',
                                                                        pointerEvents: 'none',
                                                                        userSelect: 'none',
                                                                        WebkitUserDrag: 'none',
                                                                        WebkitTouchCallout: 'none',
                                                                    }}
                                                                />

                                                                {/* Loader overlay */}
                                                                {removerLoader && (
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            backgroundColor: index === imageSelectedIndexBack ? 'rgba(0, 0, 0, 0.5)' : '',
                                                                            borderRadius: `${backPictures[index].borderRadius}px`,
                                                                            zIndex: 9999,
                                                                        }}
                                                                    >
                                                                        {index === imageSelectedIndexBack && (
                                                                            <Box
                                                                                component={"img"}
                                                                                src={Images.loader}
                                                                                width={"50px"}
                                                                                height={"50px"}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </Grid>
                                                        </div>

                                                        <Moveable
                                                            target={document.getElementsByClassName(`DesignBack-${index}`)}
                                                            container={null}
                                                            draggable={true}
                                                            resizable={index === imageSelectedIndexBack && imageSeleted}
                                                            scalable={index === imageSelectedIndexBack && imageSeleted}
                                                            rotatable={index === imageSelectedIndexBack && imageSeleted}
                                                            pinchable={true}
                                                            keepRatio={true}
                                                            origin={false}
                                                            snappable={true}
                                                            edge={false}
                                                            renderDirections={['se']}
                                                            throttleDrag={0}
                                                            throttleResize={0}
                                                            throttleScale={0}
                                                            hideDefaultLines={true}
                                                            throttleRotate={0}
                                                            onDrag={({ target, left, top }) => {
                                                                const boxWidth = 220;
                                                                const boxHeight = 313;
                                                                const elementWidth = target.offsetWidth;
                                                                const elementHeight = target.offsetHeight;

                                                                if (left + elementWidth <= 0 || left >= boxWidth || top + elementHeight <= 0 || top >= boxHeight) {
                                                                    if (index === imageSelectedIndexBack) {
                                                                        backPictures[index].top = 10;
                                                                        backPictures[index].left = 10;
                                                                        target.style.left = `${10}px`;
                                                                        target.style.top = `${10}px`;
                                                                    }
                                                                } else {
                                                                    if (index === imageSelectedIndexBack) {
                                                                        backPictures[index].top = top;
                                                                        backPictures[index].left = left;
                                                                        target.style.left = `${left}px`;
                                                                        target.style.top = `${top}px`;
                                                                    }
                                                                }
                                                            }}
                                                            onResize={({ target, width, height }) => {
                                                                backPictures[index].width = width;
                                                                backPictures[index].height = height;
                                                                target.style.width = `${width}px`;
                                                                target.style.height = `${height}px`;
                                                            }}
                                                            onScale={({ target, transform }) => {
                                                                target.style.transform = transform;
                                                            }}
                                                            onRotate={({ target, transform }) => {
                                                                backPictures[index].rotation = transform;
                                                                target.style.transform = transform;
                                                            }}
                                                        />
                                                    </div>
                                                ))}



                                            </div>
                                        </div>
                                    </PDFExport>}
                                </div>
                            </div>
                        </div>

                    </Grid>

                    {/* {isLessThan1000px && <Box component={'div'} className="animat__animat animat__fadeInLeft" sx={{ display: 'flex', justifyContent: 'center', p: '5px', width: '100%', mt: 10 }}>
                        <ButtonGroup variant="contained" aria-label="Basic button group" >
                            <Button onClick={(e, data, target) => handleContextMenuOption(selectedIndex, 'Forward', rotateDirection ? 'back' : 'front')} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Bring To Front</Button>
                            <Button onClick={(e, data, target) => handleContextMenuOption(selectedIndex, 'Backward', rotateDirection ? 'back' : 'front')} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Send to Back</Button>
                            <Button onClick={(e) => {
                                if ((typeof selectedIndex === 'number' || typeof selectedIndexBack === 'number')) {

                                    e.stopPropagation(); setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack].text : textArray[selectedIndex].text); setTextState('edit');

                                }
                            }} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Edit</Button>
                            <Button onClick={(e) => {
                                e.stopPropagation();
                                if (!rotateDirection) {

                                    handleDelete(selectedIndex, 'front');
                                    console.log(imageSelectedIndex, 'asdasdas');
                                    if (imageSelectedIndex != null && imageSelectedIndex !== '') {
                                        console.log(imageSelectedIndex, 'asdasdas2');
                                        handleImageDelete(imageSelectedIndex, 'front');
                                    }

                                }
                                else {
                                    console.log('asasdasd');
                                    handleDelete(selectedIndexBack, 'back');
                                    if (imageSelectedIndexBack != null && imageSelectedIndexBack !== '') {

                                        handleImageDelete(imageSelectedIndexBack, 'back')
                                    }
                                }
                            }} sx={{ fontSize: '10px', backgroundColor: '#0F172A', color: 'white' }}>Delete</Button>

                        </ButtonGroup>

                    </Box>} */}
                    {(isLessThan1000px || isLessThan400) && simpleNav &&

                        <Grid container id={'Test2'} sx={{ backgroundColor: '#0F172A' }}>
                            <BottomNavigation sx={{ width: "100%", backgroundColor: '#0F172A', backgroundImage: `url('data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.dev/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1015%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='%230e2a47'%3e%3c/rect%3e%3cpath d='M857.4054818464008 562.8280822832133L862.8097368853744 408.07046618169204 708.0521207838531 402.66621114271845 702.6478657448795 557.4238272442398z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1068.605%2c761.61C1124.042%2c762.198%2c1165.694%2c718.117%2c1194.324%2c670.641C1224.208%2c621.085%2c1246.37%2c562.166%2c1219.915%2c510.698C1191.599%2c455.61%2c1130.545%2c425.864%2c1068.605%2c426.061C1007.011%2c426.256%2c946.531%2c456.58%2c918.949%2c511.653C893.521%2c562.425%2c918.253%2c619.303%2c947.423%2c668.022C975.523%2c714.955%2c1013.906%2c761.03%2c1068.605%2c761.61' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M435.28 506.82 a107.41 107.41 0 1 0 214.82 0 a107.41 107.41 0 1 0 -214.82 0z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1366.751%2c555.357C1385.605%2c555.407%2c1401.227%2c541.723%2c1409.91%2c524.988C1417.909%2c509.572%2c1416.308%2c491.513%2c1407.707%2c476.424C1399.013%2c461.173%2c1384.292%2c449.981%2c1366.751%2c449.275C1347.946%2c448.518%2c1328.936%2c456.506%2c1319.659%2c472.881C1310.491%2c489.064%2c1314.765%2c508.607%2c1323.987%2c524.759C1333.302%2c541.073%2c1347.965%2c555.307%2c1366.751%2c555.357' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1110.455%2c679.809C1151.126%2c679.17%2c1188.721%2c660.721%2c1211.243%2c626.849C1236.737%2c588.507%2c1251.541%2c540.312%2c1230.409%2c499.404C1207.827%2c455.689%2c1159.653%2c431.076%2c1110.455%2c431.745C1062.375%2c432.399%2c1018.757%2c460.222%2c996.024%2c502.593C974.443%2c542.815%2c979.266%2c591.759%2c1004.027%2c630.106C1026.791%2c665.36%2c1068.495%2c680.468%2c1110.455%2c679.809' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M765.525%2c318.969C812.977%2c320.301%2c862.211%2c302.19%2c884.816%2c260.447C906.63%2c220.164%2c890.441%2c172.303%2c865.893%2c133.626C843.394%2c98.178%2c807.481%2c74.065%2c765.525%2c72.498C720.542%2c70.818%2c674.321%2c86.945%2c651.272%2c125.61C627.748%2c165.072%2c633.921%2c214.509%2c657.292%2c254.062C680.229%2c292.88%2c720.455%2c317.704%2c765.525%2c318.969' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M211.9419448301731 89.35902224861107L151.0610337916129 152.40305116022705 276.067532678317 212.20240326225934z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M1018.3040490007429 259.3766250295063L1101.7531773213684 337.19419611352714 1096.1216200847637 175.92749670888065z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M787.748%2c594.705C841.79%2c595.952%2c903.743%2c592.094%2c930.746%2c545.266C957.734%2c498.463%2c931.334%2c442.102%2c901.85%2c396.829C875.634%2c356.574%2c835.598%2c329.949%2c787.748%2c325.69C729.86%2c320.537%2c662.642%2c323.4%2c632.051%2c372.814C600.498%2c423.781%2c621.31%2c489.851%2c655.741%2c538.92C685.15%2c580.832%2c736.562%2c593.524%2c787.748%2c594.705' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M603.0628099646025 102.6542160165518L461.89226609342813 115.00503822906866 474.243088305945 256.17558210024305 615.4136321771193 243.82475988772617z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M219.197%2c414.817C242.984%2c413.192%2c260.885%2c395.231%2c272.171%2c374.229C282.766%2c354.513%2c284.873%2c331.54%2c274.648%2c311.63C263.436%2c289.798%2c243.727%2c271.884%2c219.197%2c271.08C193.432%2c270.235%2c170.387%2c285.703%2c157.069%2c307.775C143.256%2c330.667%2c138.58%2c359.316%2c152.001%2c382.44C165.378%2c405.487%2c192.611%2c416.634%2c219.197%2c414.817' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M168.27 356.2 a150.39 150.39 0 1 0 300.78 0 a150.39 150.39 0 1 0 -300.78 0z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M983.479%2c634.017C1032.291%2c631.917%2c1068.929%2c592.441%2c1090.136%2c548.427C1108.527%2c510.257%2c1101.903%2c467.382%2c1081.715%2c430.131C1060.308%2c390.63%2c1028.374%2c353.37%2c983.479%2c351.618C936.129%2c349.771%2c895.353%2c381.259%2c871.002%2c421.91C845.868%2c463.869%2c836.733%2c515.132%2c859.647%2c558.343C883.937%2c604.149%2c931.679%2c636.245%2c983.479%2c634.017' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1190.3023241117567 338.3727185498644L1112.707614215488 235.19662410965577 1066.8066547407257 338.2918670474591z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M1277.119%2c172.913C1303.693%2c172.483%2c1328.817%2c160.808%2c1342.971%2c138.313C1358.129%2c114.222%2c1362.383%2c83.918%2c1348.878%2c58.863C1334.721%2c32.597%2c1306.927%2c17.482%2c1277.119%2c16.137C1244.568%2c14.668%2c1209.114%2c23.41%2c1193.193%2c51.839C1177.515%2c79.834%2c1189.188%2c114.137%2c1207.467%2c140.507C1223.103%2c163.064%2c1249.677%2c173.357%2c1277.119%2c172.913' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M-9.72504775419963 417.57860121439603L-18.03933971226099 512.6113931554654 76.9934522288084 520.9256851135268 85.30774418686975 425.8928931724574z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M983.6402480001692 532.9189230725806L972.7743361230298 377.5291437427689 817.3845567932182 388.39505561990825 828.2504686703576 543.78483494972z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M857.13 525.55 a173.21 173.21 0 1 0 346.42 0 a173.21 173.21 0 1 0 -346.42 0z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M614.29 258.12 a112.26 112.26 0 1 0 224.52 0 a112.26 112.26 0 1 0 -224.52 0z' fill='rgba(43%2c 107%2c 175%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1015'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e')` }} value={selectedBottomTab} onChange={handleChange}>
                                {/* <BottomNavigationAction
                                onClick={() => handleDrawer(true, 'Image')}
                                sx={{ color: selectedBottomTab == 'upload' ? 'white' : 'gray' }}
                                label="Image"
                                value="upload"
                                icon={<ImageIcon sx={{ color: selectedBottomTab == 'upload' ? 'white' : 'gray' }} />}
                            /> */}
                                <BottomNavigationAction
                                    onClick={() => { handleDrawer(true, 'Text'); setTextState(''); setValue('tshirtText', '') }}

                                    label="Add Text"
                                    value="Addtext"
                                    icon={<FontDownloadIcon sx={{ color: selectedBottomTab == 'Addtext' ? 'white' : 'gray' }} />}
                                />
                                <BottomNavigationAction
                                    onClick={() => handleDrawer(true, 'Color')}
                                    label=" Color"
                                    value="color"
                                    icon={<WaterDropIcon sx={{ color: selectedBottomTab == 'color' ? 'white' : 'gray' }} />}
                                />
                                <BottomNavigationAction onClick={() => handleDrawer(true, 'Gallery')} label="Gallery" value="gallery" icon={<FolderIcon sx={{ color: selectedBottomTab == 'gallery' ? 'white' : 'gray' }} />} />
                                <BottomNavigationAction onClick={() => handleDrawer(true, 'Upload')} label="Upload" value="upload" icon={<CloudUploadIcon sx={{ color: selectedBottomTab == 'upload' ? 'white' : 'gray' }} />} />
                            </BottomNavigation>
                        </Grid>}
                    {(isLessThan1000px || isLessThan400) && editNav && (
                        <Grid container id={'Test2'} sx={{ overflowX: 'auto', backgroundColor: '#0F172A', flexWrap: 'nowrap', '&::-webkit-scrollbar': { display: 'none' } }}>
                            <BottomNavigation
                                sx={{

                                    backgroundColor: '#0F172A',
                                    width: '100%',
                                    '& .MuiBottomNavigationAction-root.Mui-selected': {
                                        color: 'inherit',
                                        paddingBottom: 0,
                                    },
                                    display: 'flex',
                                    justifyContent: 'space-around'
                                }}
                                value={selectedBottomTab}
                                onChange={handleChange}
                            >
                                <BottomNavigationAction
                                    onClick={() => handleEditDrawer(true, 'Color')}
                                    sx={{ color: 'white', '&.Mui-selected': { color: 'inherit' }, width: '50%' }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div className={`circle2`} style={{ background: !rotateDirection ? textArray[selectedIndex]?.color : textBackArray[selectedIndexBack]?.color ? textBackArray[selectedIndexBack].color : 'black' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Color</span>
                                        </Box>
                                    }
                                />
                                <BottomNavigationAction
                                    onClick={() => {
                                        handleEditDrawer(true, 'fontFamily');
                                        setTextState('edit');
                                        setSelectedElement(null)
                                        setSelectedElement(null)
                                        setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack]?.text : textArray[selectedIndex]?.text);
                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <FontDownloadIcon sx={{ color: 'white' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Font</span>
                                        </Box>
                                    }
                                />
                                <BottomNavigationAction
                                    onClick={() => {
                                        handleEditDrawer(true, 'editText');
                                        setSelectedElement(null)
                                        setSelectedElement(null)
                                        setTextState('edit');
                                        setValue('tshirtText', rotateDirection ? textBackArray[selectedIndexBack]?.text : textArray[selectedIndex]?.text);
                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <EditIcon sx={{ color: 'white' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Edit </span>
                                        </Box>
                                    }
                                />
                                <BottomNavigationAction
                                    onClick={() => handleEditDrawer(true, 'Alignment')}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <FormatAlignLeftIcon sx={{ color: 'white' }} />
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Alignment </span>
                                    </Box>}
                                />
                                <BottomNavigationAction
                                    onClick={() => handleEditDrawer(true, 'Shapes')}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        {/* <CategoryIcon sx={{ color: '#0f172a' }} /> */}
                                        <Box component={'img'} src={Images.curved} width={'50px'}>

                                        </Box>
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Shapes </span>
                                    </Box>}
                                />
                                <BottomNavigationAction
                                    onClick={() => {
                                        if (!rotateDirection) {

                                            handleDelete(selectedIndex, 'front');
                                            console.log(imageSelectedIndex, 'asdasdas');


                                        }
                                        else {
                                            console.log(selectedIndexBack);
                                            handleDelete(selectedIndexBack, 'back');
                                            console.log(imageSelectedIndexBack != null, imageSelectedIndexBack !== '', imageSelectedIndexBack);

                                        }
                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <DeleteIcon sx={{ color: 'white' }} />
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Delete </span>
                                    </Box>}
                                />
                                <BottomNavigationAction
                                    onClick={() => handleEditDrawer(true, 'Layers')}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <LayersIcon sx={{ color: 'white' }} />
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Layers </span>
                                    </Box>}
                                />

                            </BottomNavigation>
                        </Grid>
                    )}
                    {(isLessThan1000px || isLessThan400) && imageEdit && (
                        <Grid container id={'Test2'} sx={{ overflowX: 'auto', flexWrap: 'nowrap', '&::-webkit-scrollbar': { display: 'none' },background:'#0F172A' }}>
                            <BottomNavigation
                                sx={{
                                    width: '100%',
                                    backgroundColor: '#0F172A',
                                    '& .MuiBottomNavigationAction-root.Mui-selected': {
                                        color: 'inherit',
                                        paddingBottom: 0,
                                    },
                                }}
                                value={selectedBottomTab}
                                onChange={handleChange}
                            >
                                <BottomNavigationAction
                                    onClick={() => {
                                        handleEditDrawer(true, 'background');

                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                            <BsTransparency size={24} style={{ color: 'white' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Background</span>
                                        </Box>
                                    }
                                />

                                <BottomNavigationAction
                                    onClick={() => {
                                        handleEditDrawer(true, 'imageShapes');

                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <InterestsIcon sx={{ color: 'white' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Shapes</span>
                                        </Box>
                                    }
                                />
                                <BottomNavigationAction
                                    onClick={() => {
                                        handleEditDrawer(true, 'ImageLayers');

                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}

                                    icon={
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <LayersIcon sx={{ color: 'white' }} />
                                            <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Layers </span>
                                        </Box>
                                    }
                                />
                                <BottomNavigationAction
                                    onClick={() => handleEditDrawer(true, 'ImageAlignment')}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <FormatAlignLeftIcon sx={{ color: 'white' }} />
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Alignment </span>
                                    </Box>}
                                />

                                <BottomNavigationAction
                                    onClick={() => {
                                        if (!rotateDirection) {


                                            if (imageSelectedIndex != null && imageSelectedIndex !== '') {
                                                console.log(imageSelectedIndex, 'asdasdas2');
                                                handleImageDelete(imageSelectedIndex, 'front');
                                            }

                                        }
                                        else {

                                            console.log(imageSelectedIndexBack != null, imageSelectedIndexBack !== '', imageSelectedIndexBack);
                                            if (imageSelectedIndexBack != null && imageSelectedIndexBack !== '') {

                                                handleImageDelete(imageSelectedIndexBack, 'back')
                                            }
                                        }
                                    }}
                                    sx={{ '&.Mui-selected': { color: 'inherit' } }}


                                    icon={<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <DeleteIcon sx={{ color: 'white' }} />
                                        <span style={{ fontWeight: 'bold', fontFamily: 'Maven pro, sans-serif', color: 'white' }}>Delete </span>
                                    </Box>}
                                />
                            </BottomNavigation>
                            
                        </Grid>
                    )}
                </Grid>




            </Grid >
        </>
    );
}

export default TshirtDesignCanvasFinal;